<template>
    <div>
         <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item>会员卡管理</el-breadcrumb-item>
            <el-breadcrumb-item>会员卡列表</el-breadcrumb-item>
        </el-breadcrumb>
        <!--面包屑导航区域-->
        <!--卡片视图区-->
        <el-card>
            <!--搜索与添加区域-->
            <el-row :gutter="20" style="margin-bottom: 15px;">
                <el-col :span="5">
                    <el-input placeholder="请输入会员卡名称" clearable v-model="queryInfo.cardname" @clear="getList()">
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input>
                </el-col>
               <el-col :span="4">
                    <el-select v-model="queryInfo.cardclassid" placeholder="选择会员卡类型" clearable @clear="getList()" @change="getList()">
                        <el-option label="时间卡" :value="1"></el-option>
                        <el-option label="次卡" :value="2"></el-option>
                        <el-option label="体验卡" :value="3"></el-option>
                        <el-option label="学生卡" :value="4"></el-option>
                        <el-option label="女神卡" :value="5"></el-option>
                        <el-option label="店主卡" :value="6"></el-option>
                        <el-option label="私教卡" :value="7"></el-option>
                        <el-option label="早鸟卡" :value="9"></el-option>
                        <el-option label="其他" :value="8"></el-option>
                    </el-select>
                </el-col>
                <el-col :span="4">
                    <el-select v-model="queryInfo.cardScopeType" placeholder="选择适用范围" clearable @clear="getList()" @change="getList()">
                        <el-option label="单店卡" :value="1"></el-option>
                        <el-option label="城市通卡" :value="2"></el-option>
                        <el-option label="全国通卡" :value="3"></el-option>
                        <el-option label="自定义店铺组合" :value="4"></el-option>
                    </el-select>
                </el-col>
                <!-- <el-col :span="4">
                    <el-input placeholder="天数范围" clearable v-model="queryInfo.days" @clear="getList()">
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input>
                </el-col> -->
                <!-- <el-col :span="4">
                    <el-input placeholder="请输入抖音id" clearable v-model="queryInfo.douyinid" @clear="getList()">
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input>
                </el-col>
                <el-col :span="4">
                    <el-input placeholder="请输入美团id" clearable v-model="queryInfo.meituanid" @clear="getList()">
                        <el-button slot="append" icon="el-icon-search" @click="getList()"></el-button>
                    </el-input>
                </el-col> -->
                <el-col :span="3">
                    <el-button type="primary" @click="addDialogVisible = true" v-permission="'btn:card:add'">添加会员卡</el-button>
                </el-col>
            </el-row>
            <!--搜索与添加区域-->
            <!--用户列表区域-->
            <el-table :data="list" :key="list.index" style="width: 100%" stripe size="middle" height="700" :header-cell-style="{textAlign: 'center'}">
                <!-- <el-table-column label="ID" type="index"  width="40"></el-table-column> -->
                <el-table-column label="ID" prop="id" width="50" align="center"/>
                <el-table-column label="会员卡名称" prop="cardname" width="220" align="center"></el-table-column>
               <el-table-column label="会员卡类型" prop="cardclassid" width="100" align="center">
                    <template slot-scope="scope">
                        <div style="text-align: center;">
                            <el-tag type="success" effect="dark" v-if="scope.row.cardclassid == 1">时间卡</el-tag>
                            <el-tag type="success" effect="plain" v-if="scope.row.cardclassid == 2">次卡</el-tag>
                            <el-tag type="primary" effect="dark"  v-if="scope.row.cardclassid == 3">体验卡</el-tag>
                            <el-tag type="warning" effect="dark" v-if="scope.row.cardclassid == 4">学生卡</el-tag>
                            <el-tag type="danger" effect="dark" v-if="scope.row.cardclassid == 5">女神卡</el-tag>
                            <el-tag type="primary" effect="plain" v-if="scope.row.cardclassid == 6">店主卡</el-tag>
                            <el-tag type="warning" effect="plain" v-if="scope.row.cardclassid == 7">私教卡</el-tag>
                            <el-tag type="warning" effect="plain" v-if="scope.row.cardclassid == 9">早鸟卡</el-tag>
                            <el-tag type="info" effect="dark" v-if="scope.row.cardclassid == 8">其他</el-tag>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="店铺价格配置" width="180" align="center">
                    <template slot-scope="scope">
                        <div>
                            <el-tag size="mini" type="info" v-if="scope.row.priceConfigCount > 0">
                                {{ scope.row.priceConfigCount }}个店铺已配置
                            </el-tag>
                            <el-tag size="mini" type="warning" v-else-if="scope.row.priceConfigCount === 0">
                                未配置价格
                            </el-tag>
                            <el-tag size="mini" type="info" v-else>
                                <i class="el-icon-loading"></i> 加载中
                            </el-tag>
                            <br>
                            <span style="font-size: 12px; color: #999;" v-if="scope.row.priceRange">
                                {{ scope.row.priceRange }}
                            </span>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="适用范围" width="120" align="center">
                    <template slot-scope="scope">
                        <!-- 使用新的 cardScopeType 字段 -->
                        <el-tag size="small" type="success" v-if="scope.row.cardScopeType == 1">单店卡</el-tag>
                        <el-tag size="small" type="warning" v-if="scope.row.cardScopeType == 2">城市通卡</el-tag>
                        <el-tag size="small" type="danger" v-if="scope.row.cardScopeType == 3">全国通卡</el-tag>
                        <el-tag size="small" type="info" v-if="scope.row.cardScopeType == 4">自定义</el-tag>
                        <!-- 如果没有cardScopeType，显示未知 -->
                        <el-tag size="small" type="info" v-if="!scope.row.cardScopeType">未知</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="范围描述" prop="scope_desc" width="150" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.scopeDesc">{{ scope.row.scopeDesc }}</span>
                        <span v-else style="color: #999;">{{ scope.row.carddescribe || '-' }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="可用时间" prop="scope_desc" width="150" align="center">
                    <template slot-scope="scope">
                        <span v-if="scope.row.startTime">{{ formatDate(scope.row.startTime) + ' ~ ' + formatDate(scope.row.endTime) }}</span>
                        <span v-else>-</span>
                    </template>
                </el-table-column>
                <!-- <el-table-column label="抖音商品ID" prop="douyinid" width="150" align="center"></el-table-column> -->
                <!-- <el-table-column label="美团商品ID" prop="meituanid" width="150" align="center"></el-table-column> -->
                <el-table-column label="自动续费" width="90" align="center">
                    <template slot-scope="scope">
                        <el-tag v-if="scope.row.isAutoRenewal == 1" type="success" size="small">是</el-tag>
                        <el-tag v-else type="info" size="small">否</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="备注" prop="remark" width="100" align="center"></el-table-column>
                <el-table-column label="操作" min-width="420"  align="center">
                    <!--作用域插槽-->
                    <template slot-scope="scope">
                        <div style="display: flex; justify-content: center; flex-wrap: wrap; gap: 5px;">
                            <el-button type="danger" icon="el-icon-edit" size="mini" @click="handleDeleteCard(scope.row)" v-permission="'btn:card:delete'" style="margin: 2px;">删除</el-button>
                            <el-button type="primary" icon="el-icon-edit" size="mini" @click="ShowEditDialog(scope.row.id)" v-permission="'btn:card:edit'" style="margin: 2px;">编辑</el-button>

                            <!-- 🎯 关键修复：非单店卡时禁用店铺价格和批量设置按钮 -->
                            <el-button
                                type="info"
                                icon="el-icon-shop"
                                size="mini"
                                @click="showStorePrices(scope.row.id)"
                                v-permission="'btn:card:store:price'"
                                style="margin: 2px;">
                                店铺价格
                            </el-button>
                            <el-button

                                type="warning"
                                icon="el-icon-setting"
                                size="mini"
                                @click="openBatchPriceDialog(scope.row.id)"
                                v-permission="'btn:card:price:batch'"
                                style="margin: 2px;">
                                批量设置
                            </el-button>
                             <!-- :disabled="isNonSingleStoreCard(scope.row.cardScopeType)" -->

                            <!-- <el-button type="danger" icon="el-icon-delete" size="mini" @click="DelInfo(scope.row.id)"></el-button> -->
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <!--用户列表区域-->
            <!--分页区域-->
            <br>
            <div align="center">
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                :current-page="queryInfo.pageNum" :page-sizes="[20,50,500,1000]"  :page-size="queryInfo.pageSize"
                layout="total, sizes, prev, pager, next" :total="total">
                </el-pagination>
            </div>
            <!--分页区域-->
            <!--添加用户对话框-->
            <el-dialog title="添加会员卡" :visible.sync="addDialogVisible" width="800px" top="3vh" @close="addDialogClosed">
                <el-form :model="addForm" :rules="addFormRules" ref="addFormRef" label-width="120px" style="padding: 0 20px;">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="会员卡名称" prop="cardname">
                                <el-input v-model="addForm.cardname" placeholder="请输入会员卡名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="会员卡类型" prop="cardclassid">
                                <el-select v-model="addForm.cardclassid" placeholder="请选择类型" style="width: 100%;" @change="ChangeCardClass">
                                    <el-option v-for="item in classlist" :key="item.id" :label="item.classname" :value="item.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="会员卡价格" prop="price">
                                <el-input v-model="addForm.price" placeholder="请输入价格">
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="会员卡天数" prop="days" v-if="addForm.cardclassid !== 3">
                                <el-input v-model="addForm.days" placeholder="请输入天数" type="number" step="1" min="1" @input="validateIntegerInput('days', 'addForm')">
                                    <template slot="append">天</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12" v-if="addForm.cardclassid == 9">
                            <el-form-item label="可用时间" prop="startTime">
                              <el-time-picker
                                  is-range
                                  v-model="validTimes"
                                  @change="handleTimeChange(addForm)"
                                  format="HH:mm"
                                  range-separator="至"
                                  start-placeholder="开始时间"
                                  end-placeholder="结束时间"
                                  placeholder="选择时间范围">
                              </el-time-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- 自动续费开关 - 仅时间卡显示 -->
                    <el-row :gutter="20" v-if="addForm.cardclassid == 1">
                        <el-col :span="12">
                            <el-form-item label="是否自动续费">
                                <el-switch v-model="addForm.isAutoRenewal" active-text="是" inactive-text="否"
                                    :active-value="1" :inactive-value="0"
                                    active-color="#13ce66" inactive-color="#ff4949">
                                </el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="卡片适用范围" prop="cardScopeType">
                                <el-select v-model="addForm.cardScopeType" placeholder="请选择适用范围" style="width: 100%;" @change="onScopeTypeChange" :disabled="addForm.cardclassid === 3">
                                    <el-option label="单店卡" :value="1">
                                        <span style="float: left">单店卡</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">仅在单个店铺使用</span>
                                    </el-option>
                                    <el-option label="城市通卡" :value="2" :disabled="addForm.cardclassid === 3">
                                        <span style="float: left">城市通卡</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">同城店铺通用</span>
                                    </el-option>
                                    <el-option label="全国通卡" :value="3" :disabled="addForm.cardclassid === 3">
                                        <span style="float: left">全国通卡</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">全国店铺通用</span>
                                    </el-option>
                                    <el-option label="自定义店铺组合" :value="4" :disabled="addForm.cardclassid === 3">
                                        <span style="float: left">自定义店铺组合</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">指定店铺组合</span>
                                    </el-option>
                                </el-select>
                                <!-- 编辑限制提示 -->
                                <div v-if="addForm.cardScopeType && addForm.cardScopeType !== 1" style="background: #fff7e6; border: 1px solid #faad14; padding: 12px; margin-top: 10px; border-radius: 4px; border-left: 4px solid #faad14;">
                                    <div style="display: flex; align-items: center; margin-bottom: 6px;">
                                        <i class="el-icon-warning" style="color: #faad14; margin-right: 6px; font-size: 14px;"></i>
                                        <span style="color: #d48806; font-weight: bold; font-size: 13px;">重要提示</span>
                                    </div>
                                    <div style="color: #d48806; font-size: 12px; line-height: 1.4;">
                                        您选择的是「{{ getScopeTypeText(addForm.cardScopeType) }}」，保存后将有以下限制：<br>
                                        1、限购设置不可修改<br>
                                        2、除价格外的其他信息不可修改<br>
                                        3、适用范围和城市/店铺配置不可修改
                                    </div>
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="范围描述" prop="scopeDesc">
                                <el-input v-model="addForm.scopeDesc" placeholder="请输入适用范围描述" :disabled="!addForm.cardScopeType"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 城市选择 - 当选择城市通卡时显示 -->
                    <el-row :gutter="20" v-if="addForm.cardScopeType === 2">
                        <el-col :span="24">
                            <el-form-item label="适用城市" prop="scopeCities">
                                <el-select v-model="addForm.scopeCities" multiple placeholder="请选择适用城市" style="width: 100%;" filterable>
                                    <el-option v-for="city in cityList" :key="city" :label="city" :value="city"></el-option>
                                </el-select>
                                <div style="margin-top: 5px; font-size: 12px; color: #999;">选择此卡可在哪些城市的店铺使用</div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 店铺选择 - 当选择自定义店铺组合时显示 -->
                    <el-row :gutter="20" v-if="addForm.cardScopeType === 4">
                        <el-col :span="24">
                            <el-form-item label="适用店铺" prop="scopeStores">
                              <el-input
                                  v-model="addStoreSearchKeyword"
                                  placeholder="搜索店铺"
                                  prefix-icon="el-icon-search"
                                  @input="filterAddStores"
                                  clearable
                                  size="mini"
                                  class="store-search-input">
                              </el-input>
                                <el-checkbox-group v-model="addForm.scopeStores" style="max-height: 200px; overflow-y: auto; border: 1px solid #dcdfe6; padding: 10px; border-radius: 4px;">
                                    <el-row :gutter="10">
                                        <el-col :span="8" v-for="store in addStoreList" :key="store.id" style="margin-bottom: 8px;">
                                            <el-checkbox :label="store.id" style="width: 100%; margin-right: 0;">
                                                <span :title="store.storename">{{ store.storename }}</span>
                                            </el-checkbox>
                                        </el-col>
                                    </el-row>
                                </el-checkbox-group>
                                <div style="margin-top: 5px; font-size: 12px; color: #999;">选择此卡可在哪些店铺使用</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="会员卡描述" prop="carddescribe">
                        <el-input v-model="addForm.carddescribe" type="textarea" :rows="2" placeholder="请输入会员卡描述"></el-input>
                    </el-form-item>
                    <el-form-item label="会员卡备注" prop="remark">
                        <el-input v-model="addForm.remark" type="textarea" :rows="2" placeholder="请输入备注信息"></el-input>
                    </el-form-item>
                    <!-- <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="抖音团购ID" prop="douyinid">
                                <el-input v-model="addForm.douyinid" placeholder="请输入抖音团购ID"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="美团团购ID" prop="meituanid">
                                <el-input v-model="addForm.meituanid" placeholder="请输入美团团购ID"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row> -->
                    <div style="font-size: 12px; color: #999; margin-top: 10px;">
<!--                        <p><i class="el-icon-info"></i> 注：未设置预售时间时，开卡时间即为购买时间。</p>-->
                        <!-- <p><i class="el-icon-warning"></i> 注：如果上抖音/美团团购，一定要把对应平台的商品ID填写正确！</p> -->
                    </div>
                </el-form>
                <div slot="footer" class="dialog-footer" style="text-align: center; padding: 20px 0;">
                    <el-button size="medium" @click="addDialogVisible = false">取 消</el-button>
                    <el-button type="primary" size="medium" @click="AddInfo" v-permission="'btn:card:save'" :loading="addLoading">确 定</el-button>
                </div>
            </el-dialog>
            <!--添加用户对话框-->
            <!--编辑用户对话框-->
            <el-dialog title="编辑会员卡" :visible.sync="editDialogVisible" width="50%" top="5vh"  @close="editDialogClosed">
                <el-form :model="editForm" :rules="editFormRules" ref="editFormRef" label-width="100px">
                    <!-- 非单店卡编辑限制提示 -->
                    <div v-if="editForm.cardScopeType && editForm.cardScopeType !== 1" style="background: #fff7e6; border: 1px solid #faad14; padding: 15px; margin-bottom: 20px; border-radius: 4px; border-left: 4px solid #faad14;">
                        <div style="display: flex; align-items: center; margin-bottom: 8px;">
                            <i class="el-icon-warning" style="color: #faad14; margin-right: 8px; font-size: 16px;"></i>
                            <span style="color: #d48806; font-weight: bold; font-size: 14px;">编辑限制说明</span>
                        </div>
                        <div style="color: #d48806; font-size: 13px; line-height: 1.5;">
                            当前为「{{ getScopeTypeText(editForm.cardScopeType) }}」，为保证数据一致性，除价格外的其他信息不可修改。<br>
                            如需修改其他信息，请联系系统管理员。
                        </div>
                    </div>

                    <el-form-item label="会员卡名称" prop="cardname">
                        <el-input v-model="editForm.cardname"></el-input>
                    </el-form-item>
                    <el-form-item label="会员卡描述" prop="carddescribe">
                        <el-input v-model="editForm.carddescribe"></el-input>
                    </el-form-item>
                    <el-form-item label="会员卡类型" prop="cardclassid">
                        <el-select  v-model="editForm.cardclassid" placeholder="请选择类型" style="width:300px" disabled>
                            <el-option v-for="item in classlist" :key="item.id" :label="item.classname" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="会员卡价格" prop="price">
                        <el-input v-model="editForm.price" style="width:300px"></el-input> 元
                    </el-form-item>
                    <el-form-item label="会员卡天数" prop="days" v-if="editForm.cardclassid !== 3">
                        <el-input v-model="editForm.days" style="width:300px" type="number" step="1" min="1" :disabled="editForm.cardScopeType && editForm.cardScopeType !== 1" @input="validateIntegerInput('days', 'editForm')"></el-input> 天
                    </el-form-item>
                    <!-- 自动续费 - 仅时间卡显示，编辑时不允许修改 -->
                    <el-form-item label="是否自动续费" v-if="editForm.cardclassid == 1">
                        <el-switch v-model="editForm.isAutoRenewal" active-text="是" inactive-text="否"
                            :active-value="1" :inactive-value="0"
                            active-color="#13ce66" inactive-color="#ff4949"
                            disabled>
                        </el-switch>
                        <span style="color: #909399; margin-left: 10px; font-size: 12px;">
                            编辑时不允许修改自动续费
                        </span>
                    </el-form-item>
                    <el-form-item label="会员卡备注" prop="remark">
                        <el-input v-model="editForm.remark" :disabled="editForm.cardScopeType && editForm.cardScopeType !== 1"></el-input>
                    </el-form-item>
                  <el-form-item label="可用时间" prop="startTime" v-if="editForm.cardclassid == 9">
                    <el-time-picker
                        is-range
                        v-model="validTimes"
                        @change="handleTimeChange(editForm)"
                        format="HH:mm"
                        range-separator="至"
                        start-placeholder="开始时间"
                        end-placeholder="结束时间"
                        placeholder="选择时间范围">
                    </el-time-picker>
                  </el-form-item>
                    <!-- <el-form-item label="抖音团购ID" prop="douyinid">
                        <el-input v-model="editForm.douyinid" style="width:300px"></el-input>
                        <span style="color: #ff0000;padding-left: 10px;">(注：如果上抖音团购，一定要把抖音团购商品的ID填写到这里！)</span>
                    </el-form-item>
                    <el-form-item label="美团团购ID" prop="meituanid">
                        <el-input v-model="editForm.meituanid" style="width:300px"></el-input>
                        <span style="color: #ff0000;padding-left: 10px;">(注：如果上美团团购，一定要把美团团购商品的ID填写到这里！)</span>
                    </el-form-item> -->
                    <el-form-item label="卡片适用范围" prop="cardScopeType">
                        <el-select v-model="editForm.cardScopeType" placeholder="请选择适用范围" style="width: 100%;" @change="onEditScopeTypeChange" :disabled="true">
                            <el-option label="单店卡" :value="1">
                                <span style="float: left">单店卡</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">仅在单个店铺使用</span>
                            </el-option>
                            <el-option label="城市通卡" :value="2">
                                <span style="float: left">城市通卡</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">同城店铺通用</span>
                            </el-option>
                            <el-option label="全国通卡" :value="3">
                                <span style="float: left">全国通卡</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">全国店铺通用</span>
                            </el-option>
                            <el-option label="自定义店铺组合" :value="4">
                                <span style="float: left">自定义店铺组合</span>
                                <span style="float: right; color: #8492a6; font-size: 13px">指定店铺组合</span>
                            </el-option>
                        </el-select>
                        <div style="color: #909399; font-size: 12px; margin-top: 4px;">卡片适用范围创建后不可修改</div>
                    </el-form-item>
                    <el-form-item label="范围描述" prop="scopeDesc">
                        <el-input v-model="editForm.scopeDesc" placeholder="请输入适用范围描述"></el-input>
                    </el-form-item>
                    <el-row :gutter="20" v-if="editForm.cardScopeType === 2">
                        <el-col :span="24">
                            <el-form-item label="适用城市" prop="scopeConfig">
                                <el-select v-model="editForm.scopeCities" multiple placeholder="请选择适用城市" style="width: 100%;" filterable :disabled="true">
                                    <el-option v-for="city in cityList" :key="city" :label="city" :value="city"></el-option>
                                </el-select>
                                <div style="margin-top: 5px; font-size: 12px; color: #909399;">适用城市创建后不可修改</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="editForm.cardScopeType === 4">
                        <el-col :span="24">
                            <el-form-item label="适用店铺" prop="scopeConfig">
                                <el-checkbox-group v-model="editForm.scopeStores" style="max-height: 200px; overflow-y: auto; border: 1px solid #dcdfe6; padding: 10px; border-radius: 4px;" :disabled="true">
                                    <el-checkbox v-for="store in storeList" :key="store.id" :label="store.id" style="display: block; margin-bottom: 8px;" :disabled="true" v-show="editForm.scopeStores.indexOf(store.id) > -1">
                                        {{ store.storename }} (ID: {{ store.id }})
                                    </el-checkbox>
                                </el-checkbox-group>
                                <div style="margin-top: 5px; font-size: 12px; color: #909399;">适用店铺创建后不可修改</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>

                <!-- 🎯 关键功能：非单店卡的特殊店铺价格管理提示 -->
                <div v-if="isNonSingleStoreCard(editForm.cardScopeType)"
                     style="background: #f0f9ff; border: 1px solid #b3d8ff; padding: 15px; margin: 15px 0; border-radius: 4px;">
                    <div style="display: flex; align-items: center; justify-content: space-between;">
                        <div>
                            <i class="el-icon-info" style="color: #409eff; margin-right: 8px;"></i>
                            <span style="color: #409eff; font-weight: 500;">当前为「{{ getScopeTypeText(editForm.cardScopeType) }}」，可统一管理所有店铺价格</span>
                        </div>
                        <el-button
                            type="warning"
                            icon="el-icon-shop"
                            size="small"
                            @click="openGlobalStorePriceDialog(editForm.id)"
                            v-permission="'btn:card:global:store:price'">
                            统一管理店铺价格
                        </el-button>
                    </div>
                    <div style="margin-top: 8px; font-size: 12px; color: #666;">
                        通过此功能可以统一修改该卡片在所有店铺的价格、数量、折扣等信息
                    </div>
                </div>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="editDialogVisible = false">取 消</el-button>
                    <el-button type="primary" @click="EditInfoSave(editForm.id)" v-permission="'btn:card:update'" :loading="editLoading">确 定</el-button>
                </span>
            </el-dialog>
            <!--编辑用户对话框-->

            <!--价格管理对话框-->
            <el-dialog :title="`${currentCardName} - 价格管理`" :visible.sync="priceDialogVisible" width="80%" top="5vh">
                <div style="margin-bottom: 20px;">
                    <!-- 只有单店卡才显示添加价格按钮 -->
                    <el-button v-if="currentCardScopeType === 1" type="primary" @click="addPrice" v-permission="'btn:card:price:add'" :loading="addPriceLoading">添加价格</el-button>
                    <el-button v-if="currentCardScopeType !== 1" type="success" @click="openBatchPriceDialog(currentCardId)" v-permission="'btn:card:price:batch'">批量设置</el-button>

                    <!-- 非单店卡的提示信息 -->
                    <div v-if="currentCardScopeType && currentCardScopeType !== 1" style="background: #f0f9ff; border: 1px solid #b3d8ff; padding: 12px; margin-top: 10px; border-radius: 4px;">
                        <div style="display: flex; align-items: center;">
                            <i class="el-icon-info" style="color: #409eff; margin-right: 8px;"></i>
                            <span style="color: #409eff; font-weight: 500;">当前为「{{ getScopeTypeText(currentCardScopeType) }}」，系统已自动为所有适用店铺创建价格记录</span>
                        </div>
                    </div>
                </div>

                <el-table :data="cardPrices" style="width: 100%" stripe>
                    <el-table-column prop="storeId" label="店铺ID" width="80"></el-table-column>
                    <el-table-column prop="storeName" label="店铺名称" width="150"></el-table-column>
                    <el-table-column prop="price" label="价格" width="100">
                        <template slot-scope="scope">
                            ￥{{ scope.row.price }}
                        </template>
                    </el-table-column>
                    <el-table-column prop="originalPrice" label="原价" width="100">
                        <template slot-scope="scope">
                            <span v-if="scope.row.originalPrice">￥{{ scope.row.originalPrice }}</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="purchaseLimitType" label="限购类型" width="100">
                        <template slot-scope="scope">
                            <el-tag v-if="scope.row.purchaseLimitType === 0" type="info">无限购</el-tag>
                            <el-tag v-else-if="scope.row.purchaseLimitType === 1" type="warning">全局限购</el-tag>
                            <el-tag v-else-if="scope.row.purchaseLimitType === 2" type="danger">个人限购</el-tag>
                            <el-tag v-else type="primary">混合限购</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="totalLimit" label="总限购" width="80"></el-table-column>
                    <el-table-column prop="personalLimit" label="个人限购" width="80"></el-table-column>
                    <el-table-column prop="soldCount" label="已售" width="60"></el-table-column>
                    <el-table-column label="有效期" width="120" v-if="currentCardClassId !== 3">
                        <template slot-scope="scope">
                            <span v-if="currentCardClassId == 2">{{ scope.row.days || '-' }}天 / {{ scope.row.useTimes || scope.row.use_times || '-' }}次</span>
                            <span v-else>{{ scope.row.days || '-' }}天</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="120">
                        <template slot-scope="scope">
                            <el-button type="danger" size="mini" @click="deletePrice(scope.row.id)" v-permission="'btn:card:price:delete'" :loading="deletePriceLoading">删除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

                <!-- 添加价格表单 -->
                <el-form :model="priceForm" :rules="priceFormRules" ref="priceFormRef" label-width="120px" style="margin-top: 20px;">
                    <!-- 隐藏的 cardId 字段，用于验证 -->
                    <el-form-item prop="cardId" style="display: none;">
                        <el-input v-model="priceForm.cardId" type="hidden"></el-input>
                    </el-form-item>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="选择店铺" prop="storeId">
                                <el-select v-model="priceForm.storeId" filterable placeholder="请选择店铺" style="width: 100%;">
                                    <el-option v-for="store in storeList" :key="store.id" :label="store.storename" :value="store.id"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="价格" prop="price">
                                <el-input v-model="priceForm.price" placeholder="请输入价格"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="原价">
                                <el-input v-model="priceForm.originalPrice" placeholder="请输入原价（可选）"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="限购类型">
                                <el-select v-model="priceForm.purchaseLimitType" style="width: 100%;" :disabled="addForm.cardclassid === 3">
                                    <el-option label="无限购" :value="0"></el-option>
                                    <el-option label="总量限购" :value="1"></el-option>
                                    <el-option label="个人限购" :value="2"></el-option>
                                    <el-option label="混合限购" :value="3"></el-option>
                                </el-select>
                                <div v-if="addForm.cardclassid === 3" style="color: #909399; font-size: 12px; margin-top: 4px;">体验卡不支持限购设置</div>
                                <div v-else style="color: #f56c6c; font-size: 12px; margin-top: 4px;">⚠️ 注意：限购设置保存后将无法修改</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8" v-if="priceForm.purchaseLimitType === 1 || priceForm.purchaseLimitType === 3">
                            <el-form-item label="总限购数量">
                                <el-input v-model="priceForm.totalLimit" placeholder="总限购数量" :disabled="addForm.cardclassid === 3" @input="onTotalLimitInput('price')" @blur="onTotalLimitBlur('price')"></el-input>
                                <div v-if="addForm.cardclassid === 3" style="color: #909399; font-size: 12px; margin-top: 4px;">体验卡不支持限购数量</div>
                                <div v-if="priceForm.totalLimitValidation && !priceForm.totalLimitValidation.valid" style="color: #f56c6c; font-size: 12px; margin-top: 4px;">
                                    {{ priceForm.totalLimitValidation.message }}
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="priceForm.purchaseLimitType === 2 || priceForm.purchaseLimitType === 3">
                            <el-form-item label="个人限购数量">
                                <el-input v-model="priceForm.personalLimit" placeholder="个人限购数量" :disabled="addForm.cardclassid === 3"></el-input>
                                <div v-if="addForm.cardclassid === 3" style="color: #909399; font-size: 12px; margin-top: 4px;">体验卡不支持限购数量</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="升级折扣(%)">
                                <el-input v-model="priceForm.upgradeDiscount" placeholder="升级折扣百分比" :disabled="addForm.cardclassid === 3"></el-input>
                                <div v-if="addForm.cardclassid === 3" style="color: #909399; font-size: 12px; margin-top: 4px;">体验卡不支持升级折扣</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="限购周期">
                                <el-select v-model="priceForm.limitPeriod" style="width: 100%;">
                                    <el-option label="永久" :value="0"></el-option>
                                    <el-option label="每日" :value="1"></el-option>
                                    <el-option label="每周" :value="2"></el-option>
                                    <el-option label="每月" :value="3"></el-option>
                                    <el-option label="每年" :value="4"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="有效天数">
                                <el-input v-model="priceForm.days" placeholder="卡片有效天数" type="number" step="1" min="1" @input="validateIntegerInput('days', 'priceForm')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8" v-if="currentCardClassId === 2">
                            <el-form-item label="可用次数">
                                <el-input v-model="priceForm.useTimes" placeholder="次卡可用次数" type="number" step="1" min="1" @input="validateIntegerInput('useTimes', 'priceForm')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="排序权重">
                                <el-input v-model="priceForm.sortOrder" placeholder="排序权重" type="number"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="限购开始时间">
                                <el-date-picker v-model="priceForm.limitStartTime" type="datetime" placeholder="选择限购开始时间" style="width: 100%;" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="限购结束时间">
                                <el-date-picker v-model="priceForm.limitEndTime" type="datetime" placeholder="选择限购结束时间" style="width: 100%;" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="预售时间">
                                <el-date-picker v-model="priceForm.presaleTime" type="datetime" placeholder="选择预售时间" style="width: 100%;" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="是否启用">
                                <el-switch v-model="priceForm.isActive" active-text="启用" inactive-text="禁用"></el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="抖音商品ID">
                                <el-input v-model="priceForm.douyinId" placeholder="抖音平台商品ID" :disabled="addForm.cardclassid === 3"></el-input>
                                <div v-if="addForm.cardclassid === 3" style="color: #909399; font-size: 12px; margin-top: 4px;">体验卡不支持团购设置</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="美团商品ID">
                                <el-input v-model="priceForm.meituanId" placeholder="美团平台商品ID" :disabled="addForm.cardclassid === 3"></el-input>
                                <div v-if="addForm.cardclassid === 3" style="color: #909399; font-size: 12px; margin-top: 4px;">体验卡不支持团购设置</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="高德商品ID">
                                <el-input v-model="priceForm.gaodeId" placeholder="高德平台商品ID" :disabled="addForm.cardclassid === 3"></el-input>
                                <div v-if="addForm.cardclassid === 3" style="color: #909399; font-size: 12px; margin-top: 4px;">体验卡不支持团购设置</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="限购说明">
                                <el-input v-model="priceForm.limitDesc" placeholder="限购规则说明" type="textarea" :rows="2"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="店铺特殊说明">
                                <el-input
                                    v-model="priceForm.storeDesc"
                                    placeholder="针对该店铺的特殊说明（最多16个字符）"
                                    type="textarea"
                                    :rows="2"
                                    maxlength="20"
                                    show-word-limit
                                    @input="validatePriceFormStoreDesc">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="备注">
                        <el-input v-model="priceForm.remark" placeholder="备注信息" type="textarea" :rows="3"></el-input>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="savePrice" v-permission="'btn:card:price:save'" :loading="priceLoading">保存价格</el-button>
                        <el-button @click="resetPriceForm">重置</el-button>
                    </el-form-item>
                </el-form>
            </el-dialog>

            <!--批量价格设置对话框-->
            <el-dialog title="批量设置价格" :visible.sync="batchPriceDialogVisible" width="80%" top="2vh" class="batch-price-dialog" @close="onBatchPriceDialogClose">
                <div style="display: flex; height: 650px; gap: 15px;">
                    <!-- 左侧：店铺选择 -->
                    <div class="store-selection-panel" style="width: 20%;">
                        <div class="panel-header">
                            <h4><i class="el-icon-shop"></i> 选择店铺</h4>
                            <!-- 卡片类型提示 -->
                            <div v-if="currentCardScopeType && currentCardScopeType !== 1" style="background: #f0f9ff; border: 1px solid #1890ff; padding: 8px; margin: 8px 0; border-radius: 4px; font-size: 12px;">
                                <!-- <div style="color: #1890ff; text-align: center;">
                                    <i class="el-icon-info"></i><br>
                                    当前为「{{ getScopeTypeText(currentCardScopeType) }}」<br>
                                    可以选择特定店铺进行价格设置
                                </div> -->
                            </div>
                            <div class="search-container">
                                <el-input
                                    v-model="storeSearchKeyword"
                                    placeholder="搜索店铺"
                                    prefix-icon="el-icon-search"
                                    @input="filterStores"
                                    clearable
                                    size="mini"
                                    class="store-search-input">
                                </el-input>
                            </div>
                        </div>
                        <div class="panel-actions">
                            <el-button size="mini" type="primary" @click="selectAllStores" icon="el-icon-check">全选</el-button>
                            <el-button size="mini" @click="clearAllStores" icon="el-icon-close">清空</el-button>
                            <el-button size="mini" @click="reverseSelectStores" icon="el-icon-refresh">反选</el-button>
                        </div>
                        <div class="store-list" v-loading="storeListLoading" element-loading-text="加载店铺中...">
                            <transition-group name="store-item" tag="div">
                                <div v-for="store in filteredStoreList" :key="store.id"
                                     class="store-item"
                                     :class="{
                                         selected: selectedStores.includes(store.id),
                                         bound: boundStores.includes(store.id),
                                         disabled: boundStores.includes(store.id)
                                     }"
                                     @click="handleStoreItemClick(store.id, $event)">
                                    <el-checkbox
                                        v-model="selectedStores"
                                        :label="store.id"
                                        :disabled="boundStores.includes(store.id)">
                                        <span class="store-name">{{ store.storename }}</span>
                                        <span class="store-city" v-if="store.city">({{ store.city }})</span>
                                        <span v-if="boundStores.includes(store.id)" class="bound-tag">
                                            <i class="el-icon-check"></i>已绑定
                                        </span>
                                    </el-checkbox>
                                </div>
                            </transition-group>
                            <div v-if="filteredStoreList.length === 0 && !storeListLoading" class="empty-state">
                                <i class="el-icon-info"></i>
                                <p>暂无匹配的店铺</p>
                            </div>
                        </div>
                        <div class="panel-pagination" v-if="!batchPriceDialogVisible">
                            <el-pagination
                                @current-change="handleStorePageChange"
                                :current-page="storeCurrentPage"
                                :page-size="storePageSize"
                                layout="prev, pager, next, total"
                                :total="totalStoreCount"
                                small>
                            </el-pagination>
                        </div>
                        <div class="panel-info" v-else>
                            <span style="color: #909399; font-size: 12px;">
                                <i class="el-icon-info"></i> 显示全部 {{totalStoreCount}} 个店铺
                            </span>
                        </div>
                    </div>

                    <!-- 中间：已选店铺 -->
                    <div class="selected-stores-panel" style="width: 20%;">
                        <div class="panel-header">
                            <h4><i class="el-icon-collection-tag"></i> 已选店铺 ({{selectedStores.length}})</h4>
                            <el-button size="mini" type="danger" @click="clearAllStores" v-if="selectedStores.length > 0" icon="el-icon-delete">清空</el-button>
                        </div>

                        <!-- 已绑定店铺信息提示 -->
                        <div v-if="boundStoreDetails.length > 0" class="bound-stores-info">
                            <div class="bound-header">
                                <i class="el-icon-info"></i>
                                <span>已绑定店铺 ({{boundStoreDetails.length}})</span>
                            </div>
                            <div class="bound-stores-list">
                                <div v-for="store in boundStoreDetails" :key="'bound-' + store.storeId" class="bound-store-item">
                                    <span class="store-info">
                                        <i class="el-icon-shop"></i>
                                        {{ store.storeName }}
                                    </span>
                                    <span class="store-price">￥{{ store.price }}</span>
                                </div>
                            </div>
                        </div>

                        <div class="selected-store-list">
                            <transition-group name="selected-store" tag="div">
                                <div v-for="storeId in selectedStores" :key="storeId" class="selected-store-item">
                                    <span class="store-info">
                                        <i class="el-icon-shop"></i>
                                        {{ getStoreName(storeId) }}
                                    </span>
                                    <el-button size="mini" type="text" @click="removeSelectedStore(storeId)" class="remove-btn">
                                        <i class="el-icon-close"></i>
                                    </el-button>
                                </div>
                            </transition-group>
                            <div v-if="selectedStores.length === 0" class="empty-selected">
                                <i class="el-icon-plus"></i>
                                <p>请从左侧选择店铺</p>
                            </div>
                        </div>
                    </div>

                    <!-- 右侧：价格设置表单 -->
                    <div class="price-form-panel" style="width: 60%;overflow-y: auto">
                        <div class="panel-header">
                            <h4><i class="el-icon-money"></i> 价格设置</h4>
                        </div>
                        <el-form :model="batchPriceForm" label-width="130px" style="height: 520px;">
                            <!-- 批量设置说明 -->
                            <div style="
                                background: linear-gradient(135deg, #fff7ed 0%, #fed7aa 100%);
                                border: 1px solid #fb923c;
                                border-radius: 6px;
                                padding: 10px 14px;
                                margin-bottom: 15px;
                                border-left: 3px solid #ea580c;
                                font-size: 13px;
                                color: #9a3412;
                            ">
                                <i class="el-icon-info" style="margin-right: 6px; color: #ea580c;"></i>
                                <strong>批量设置说明：</strong>表单显示第一个店铺的现有价格作为参考，您修改后的值将统一应用到所有店铺
                            </div>
                            <!-- 会员卡适用范围类型回显 -->
                            <div style="
                                background: linear-gradient(135deg, #f0f9ff 0%, #dbeafe 100%);
                                border: 1px solid #93c5fd;
                                border-radius: 8px;
                                padding: 14px 18px;
                                margin-bottom: 20px;
                                border-left: 4px solid #409eff;
                                box-shadow: 0 2px 4px rgba(59, 130, 246, 0.1);
                                min-height: 48px;
                                display: flex;
                                align-items: center;
                            ">
                                <div style="
                                    display: flex;
                                    align-items: center;
                                    justify-content: space-between;
                                    width: 100%;
                                    min-height: 20px;
                                ">
                                    <div style="display: flex; align-items: center; gap: 12px;">
                                        <span style="
                                            font-weight: 600;
                                            color: #1e40af;
                                            font-size: 14px;
                                            line-height: 20px;
                                            display: flex;
                                            align-items: center;
                                        ">
                                            <i class="el-icon-postcard" style="
                                                margin-right: 6px;
                                                color: #409eff;
                                                font-size: 15px;
                                            "></i>会员卡范围类型：
                                        </span>
                                        <el-tag
                                            :type="getScopeTypeTagType(currentCardScopeType)"
                                            size="small"
                                            effect="dark"
                                            style="
                                                font-weight: bold;
                                                padding: 6px 12px;
                                                font-size: 13px;
                                                border-radius: 16px;
                                                display: flex;
                                                align-items: center;
                                                min-height: 28px;
                                            "
                                        >
                                            <i class="el-icon-info" style="margin-right: 4px; font-size: 13px;"></i>{{ getScopeTypeText(currentCardScopeType) }}
                                        </el-tag>
                                    </div>
                                    <span style="
                                        color: #64748b;
                                        font-size: 11px;
                                        font-style: italic;
                                        line-height: 20px;
                                        display: flex;
                                        align-items: center;
                                    ">
                                        （来自会员卡设置，不可修改）
                                    </span>
                                </div>
                            </div>
                            <el-row :gutter="15">
                                <el-col :span="12">
                                    <el-form-item label="价格" required>
                                        <el-input v-model="batchPriceForm.price" placeholder="请输入价格" type="number" size="small" style="width: 80%;" @input="validateNumberInput('price', $event)"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="成本价" required>
                                        <el-input v-model="batchPriceForm.costPrice" placeholder="请输入成本价" type="number" size="small" style="width: 80%;" @input="validateNumberInput('costPrice', $event)"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="15">
                                <el-col :span="12">
                                    <el-form-item label="有效天数">
                                        <el-input v-model="batchPriceForm.days" placeholder="卡片有效天数" type="number" step="1" min="1" size="small" style="width: 80%;" @input="validateIntegerInput('days', 'batchPriceForm')"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" v-if="currentCardClassId === 2">
                                    <el-form-item label="可用次数">
                                        <el-input v-model="batchPriceForm.useTimes" placeholder="次卡可用次数" type="number" step="1" min="1" size="small" style="width: 80%;" @input="validateIntegerInput('useTimes', 'batchPriceForm')"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="排序权重">
                                        <el-input v-model="batchPriceForm.sortOrder" placeholder="排序权重" type="number" size="small" style="width: 80%;"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="15">
                                <el-col :span="12">
                                    <el-form-item label="限购类型">
                                        <el-select v-model="batchPriceForm.purchaseLimitType" style="width: 80%;" size="small" :disabled="isPurchaseLimitTypeDisabled()">
                                            <el-option label="无限购" :value="0"></el-option>
                                            <el-option label="总量限购" :value="1"></el-option>
                                            <el-option label="个人限购" :value="2"></el-option>
                                            <el-option label="混合限购" :value="3"></el-option>
                                        </el-select>
                                        <div style="color: #f56c6c; font-size: 11px; margin-top: 2px;">⚠️ 限购设置保存后无法修改</div>
                                        <div v-if="batchPriceForm.purchaseLimitType !== 0" style="color: #faad14; font-size: 11px; margin-top: 2px;">
                                            <i class="el-icon-lock"></i> 当前限购类型已设置，无法修改
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <!-- <el-col :span="12">
                                    <el-form-item label="限购周期">
                                        <el-select v-model="batchPriceForm.limitPeriod" style="width: 80%;" size="small">
                                            <el-option label="永久" :value="0"></el-option>
                                            <el-option label="每日" :value="1"></el-option>
                                            <el-option label="每周" :value="2"></el-option>
                                            <el-option label="每月" :value="3"></el-option>
                                            <el-option label="每年" :value="4"></el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col> -->
                            </el-row>
                            <el-row :gutter="15">
                                <el-col :span="12" v-if="batchPriceForm.purchaseLimitType === 1 || batchPriceForm.purchaseLimitType === 3">
                                    <el-form-item label="总限购数量">
                                        <el-input v-model="batchPriceForm.totalLimit" placeholder="总限购数量" type="number" size="small" style="width: 80%;" @input="onTotalLimitInput('batch')" @blur="onTotalLimitBlur('batch')"></el-input>
                                        <div v-if="batchPriceForm.totalLimitValidation && !batchPriceForm.totalLimitValidation.valid" style="color: #f56c6c; font-size: 12px; margin-top: 4px;">
                                            {{ batchPriceForm.totalLimitValidation.message }}
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12" v-if="batchPriceForm.purchaseLimitType === 2 || batchPriceForm.purchaseLimitType === 3">
                                    <el-form-item label="个人限购数量">
                                        <el-input v-model="batchPriceForm.personalLimit" placeholder="个人限购数量" type="number" size="small" style="width: 80%;" @input="validateNumberInput('personalLimit', batchPriceForm.personalLimit, 'batch')"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="15">
                                <!-- <el-col :span="8">
                                    <el-form-item label="升级折扣(%)">
                                        <el-input v-model="batchPriceForm.upgradeDiscount" placeholder="升级折扣百分比" type="number" size="small" style="width: 100%;" @input="validateNumberInput('upgradeDiscount', batchPriceForm.upgradeDiscount, 'batch')"></el-input>
                                    </el-form-item>
                                </el-col> -->
                                <el-col :span="12">
                                    <el-form-item label="是否启用">
                                        <el-switch v-model="batchPriceForm.isActive"
                                                   active-text="启用"
                                                   inactive-text="禁用"
                                                   :active-value="1"
                                                   :inactive-value="0"></el-switch>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="是否显示">
                                        <el-switch v-model="batchPriceForm.isShow"
                                                   active-text="显示"
                                                   inactive-text="隐藏"
                                                   :active-value="1"
                                                   :inactive-value="0"></el-switch>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <!-- <el-row :gutter="15">
                                <el-col :span="12">
                                    <el-form-item label="限购开始时间">
                                        <el-date-picker v-model="batchPriceForm.limitStartTime" type="datetime" placeholder="选择限购开始时间" style="width: 80%;" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="限购结束时间">
                                        <el-date-picker v-model="batchPriceForm.limitEndTime" type="datetime" placeholder="选择限购结束时间" style="width: 80%;" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="15">
                                <el-col :span="12">
                                    <el-form-item label="预售时间">
                                        <el-date-picker v-model="batchPriceForm.presaleTime" type="datetime" placeholder="选择预售时间" style="width: 80%;" size="small" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                                    </el-form-item>
                                </el-col>
                            </el-row> -->
                            <el-row :gutter="15" v-if="batchPriceForm.isAutoRenewal != 1">
                                <el-col :span="12">
                                    <el-form-item label="抖音商品ID">
                                        <el-input v-model="batchPriceForm.douyinId" placeholder="抖音平台商品ID" size="small" style="width: 80%;" @blur="checkDouyinIdUnique('batch')"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="美团商品ID">
                                        <el-input v-model="batchPriceForm.meituanId" placeholder="美团平台商品ID" size="small" style="width: 80%;" @blur="checkMeituanIdUnique('batch')"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="高德商品ID">
                                        <el-input v-model="batchPriceForm.gaodeId" placeholder="高德平台商品ID" size="small" style="width: 80%;" @blur="checkGaodeIdUnique('batch')"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <!-- 自动续费配置区域 -->
                            <div style="border: 1px solid #e8e8e8; border-radius: 8px; padding: 15px; margin-bottom: 15px; background: #fafafa;">
                                <div style="display: flex; align-items: center; margin-bottom: 10px;">
                                    <span style="font-weight: bold; font-size: 14px; margin-right: 16px;">
                                        <i class="el-icon-refresh"></i> 自动续费设置
                                    </span>
                                    <el-switch
                                        v-model="batchPriceForm.isAutoRenewal"
                                        active-text="启用"
                                        inactive-text="关闭"
                                        :active-value="1"
                                        :inactive-value="0"
                                        active-color="#13ce66"
                                        disabled
                                        @change="onBatchAutoRenewalToggle">
                                    </el-switch>
                                    <span style="font-size: 11px; color: #909399; margin-left: 8px;">（来自会员卡设置，不可修改）</span>
                                </div>
                                <div v-if="batchPriceForm.isAutoRenewal == 1">
                                    <el-row :gutter="15">
                                        <el-col :span="12">
                                            <el-form-item label="续费类型" required>
                                                <el-select v-model="batchPriceForm.renewalType" size="small" style="width: 100%;" @change="onBatchRenewalTypeChange">
                                                    <el-option
                                                        v-for="item in autoRenewalTypes"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="扣款方式" required>
                                                <el-select v-model="batchPriceForm.deductMethod" size="small" style="width: 100%;">
                                                    <el-option
                                                        v-for="item in deductMethods"
                                                        :key="item.value"
                                                        :label="item.label"
                                                        :value="item.value">
                                                    </el-option>
                                                </el-select>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="15">
                                        <el-col :span="12">
                                            <el-form-item label="扣费周期" required>
                                                <el-input v-model="batchPriceForm.deductCycle" type="number" :min="1" :max="36" size="small" style="width: 100%;" @change="onDeductCycleChange">
                                                    <template slot="append">{{ batchRenewalUnit }}</template>
                                                </el-input>
                                                <div style="font-size: 11px; color: #909399; margin-top: 2px;">
                                                    扣满自动解约，需重新签约（1-36）
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="12">
                                            <el-form-item label="提前扣款天数" required>
                                                <el-input v-model="batchPriceForm.advanceDeductDays" type="number" :min="0" :max="3" size="small" style="width: 100%;">
                                                    <template slot="append">天</template>
                                                </el-input>
                                                <div style="font-size: 11px; color: #909399; margin-top: 2px;">
                                                    到期前N天发起扣款（0-3）
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <el-row :gutter="15">
                                        <el-col :span="12">
                                            <el-form-item label="失败重试次数" required>
                                                <el-input v-model="batchPriceForm.retryTimes" type="number" :min="0" :max="7" size="small" style="width: 100%;">
                                                    <template slot="append">次</template>
                                                </el-input>
                                                <div style="font-size: 11px; color: #909399; margin-top: 2px;">
                                                    每天1次，全部失败后自动解约（0-7）
                                                </div>
                                            </el-form-item>
                                        </el-col>
                                    </el-row>
                                    <!-- 代扣明细 -->
                                    <div style="margin-top: 10px;">
                                        <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px;">
                                            <span style="font-weight: bold; font-size: 13px;">代扣明细（共{{ deductDetails.length }}期）</span>
                                            <el-button size="mini" type="primary" @click="generateDeductDetails">重新生成</el-button>
                                        </div>
                                        <el-table :data="deductDetails" border size="mini" max-height="250" style="width: 100%;">
                                            <el-table-column prop="phase" label="阶段" min-width="80" align="center">
                                                <template slot-scope="scope">
                                                    第{{ scope.row.phase }}期
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="originalPrice" label="原价" min-width="120" align="center">
                                                <template slot-scope="scope">
                                                    ￥{{ scope.row.originalPrice }}
                                                </template>
                                            </el-table-column>
                                            <el-table-column label="优惠价" min-width="140" align="center">
                                                <template slot-scope="scope">
                                                    <el-input
                                                        v-model="scope.row.actualPrice"
                                                        type="number"
                                                        size="mini"
                                                        style="width: 100px;"
                                                        @change="onDeductDetailPriceChange(scope.row)">
                                                    </el-input>
                                                </template>
                                            </el-table-column>
                                            <el-table-column prop="saving" label="每期节省" min-width="120" align="center">
                                                <template slot-scope="scope">
                                                    <span style="color: #67c23a;">省￥{{ scope.row.saving }}</span>
                                                </template>
                                            </el-table-column>
                                        </el-table>
                                    </div>
                                </div>
                            </div>
                            <el-row :gutter="15">
                                <el-col :span="24">
                                    <el-form-item label="备注">
                                        <el-input v-model="batchPriceForm.remark" type="textarea" placeholder="请输入备注" :rows="2" style="width: 90%;" size="small"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="15">
                                <el-col :span="24">
                                    <el-form-item label="店铺特定描述">
                                        <el-input
                                            v-model="batchPriceForm.storeDesc"
                                            type="textarea"
                                            placeholder="请输入店铺特定描述（最多20个字符）"
                                            :rows="2"
                                            style="width: 90%;"
                                            size="small"
                                            maxlength="20"
                                            show-word-limit
                                            @input="validateStoreDesc"></el-input>
                                        <div v-if="storeDescValidation && !storeDescValidation.valid" style="color: #f56c6c; font-size: 12px; margin-top: 4px;">
                                            {{ storeDescValidation.message }}
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </el-form>
                    </div>
                </div>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="batchPriceDialogVisible = false">取消</el-button>
                    <!-- <el-button @click="">重置</el-button> -->
                    <el-button type="primary" @click="saveBatchPrice" v-permission="'btn:card:price:batch:save'" :loading="batchPriceLoading">批量设置价格</el-button>
                </span>
            </el-dialog>

            <!--活动管理对话框-->
            <el-dialog :title="`${currentStoreName} - ${currentCardName} - 活动管理`" :visible.sync="activityDialogVisible" width="80%" top="2vh">
                <el-tabs v-model="activityTabActive" type="border-card">
                    <!-- 普通活动标签页 -->
                    <el-tab-pane label="普通活动" name="normal">
                        <div style="margin-bottom: 20px;">
                            <el-button type="primary" @click="addNormalActivity" v-permission="'btn:card:activity:add'" :disabled="isExperienceCard" :loading="addNormalActivityLoading">添加普通活动</el-button>
                            <div v-if="isExperienceCard" style="color: #909399; font-size: 12px; margin-top: 8px;">
                                <i class="el-icon-info"></i> 体验卡不支持添加活动
                            </div>
                        </div>

                        <el-table :data="normalActivities" style="width: 100%" stripe border>
                            <el-table-column prop="activityName" label="活动名称" width="150" align="center"></el-table-column>
                            <el-table-column prop="activityType" label="活动类型" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.activityType === 1" type="primary" size="small">直减</el-tag>
                                    <el-tag v-else-if="scope.row.activityType === 2" type="success" size="small">折扣</el-tag>
                                    <el-tag v-else-if="scope.row.activityType === 3" type="warning" size="small">满减</el-tag>
                                    <el-tag v-else-if="scope.row.activityType === 4" type="info" size="small">买N送N</el-tag>
                                    <el-tag v-else-if="scope.row.activityType === 5" type="danger" size="small">限时特价</el-tag>
                                    <!-- <el-tag v-else-if="scope.row.activityType === 6" type="" size="small">升级活动</el-tag>
                                    <el-tag v-else-if="scope.row.activityType === 7" type="success" size="small">续费活动</el-tag> -->
                                    <!-- <el-tag v-else type="info" size="small">其他</el-tag> -->
                                </template>
                            </el-table-column>
                            <el-table-column label="优惠信息" width="120" align="center">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.activityType === 1 && scope.row.discountAmount">
                                        <span style="color: #e6a23c;">-￥{{ scope.row.discountAmount }}</span>
                                    </div>
                                    <div v-else-if="scope.row.activityType === 2 && scope.row.discountRate">
                                        <span style="color: #67c23a;">{{ scope.row.discountRate }}折</span>
                                    </div>
                                    <div v-else-if="scope.row.activityType === 3">
                                        <span style="color: #909399; font-size: 12px;">满{{ scope.row.minAmount }}减{{ scope.row.discountAmount }}</span>
                                    </div>
                                    <div v-else-if="scope.row.activityType === 4">
                                        <span style="color: #409eff; font-size: 12px;">买{{ scope.row.buyCount }}送{{ scope.row.giftCount }}</span>
                                    </div>
                                    <div v-else-if="scope.row.activityType === 5 && scope.row.specialPrice">
                                        <span style="color: #f56c6c;">￥{{ scope.row.specialPrice }}</span>
                                    </div>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="startTime" label="开始时间" width="150" align="center">
                                <template slot-scope="scope">
                                    {{ scope.row.startTime || '-' }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="endTime" label="结束时间" width="150" align="center">
                                <template slot-scope="scope">
                                    {{ scope.row.endTime || '-' }}
                                </template>
                            </el-table-column>
                            <el-table-column label="状态" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.status === 1" type="success" size="small">启用</el-tag>
                                    <el-tag v-else-if="scope.row.status === 2" type="warning" size="small">暂停</el-tag>
                                    <el-tag v-else-if="scope.row.status === 3" type="danger" size="small">结束</el-tag>
                                    <el-tag v-else type="info" size="small">未知</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="显示" width="80" align="center">
                                <template slot-scope="scope">
                                    <el-switch
                                        v-model="scope.row.isShow"
                                        :active-value="1"
                                        :inactive-value="0"
                                        active-color="#67c23a"
                                        inactive-color="#dcdfe6"
                                        @change="toggleActivityShow(scope.row)"
                                        size="mini">
                                    </el-switch>
                                </template>
                            </el-table-column>
                            <el-table-column label="使用情况" width="100" align="center">
                                <template slot-scope="scope">
                                    <div style="font-size: 12px;">
                                        <div>已用: {{ scope.row.usedCount || 0 }}</div>
                                        <div v-if="scope.row.maxUseCount > 0" style="color: #909399;">
                                            限制: {{ scope.row.maxUseCount }}
                                        </div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="150" align="center">
                                <template slot-scope="scope">
                                    <el-button type="text" size="small" @click="editNormalActivity(scope.row)" v-permission="'btn:card:activity:edit'">编辑</el-button>
                                    <el-button type="text" size="small" style="color: #f56c6c;" @click="deleteActivity(scope.row.id)" v-permission="'btn:card:activity:delete'">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>

                    <!-- 续费活动标签页 -->
                    <el-tab-pane label="续费活动" name="renewal">
                        <div style="margin-bottom: 20px;">
                            <el-button type="success" @click="addRenewalActivity" v-permission="'btn:card:renewal:activity:add'" :disabled="isExperienceCard">
                                <i class="el-icon-plus"></i> 添加续费活动
                            </el-button>
                            <el-button type="info" @click="refreshRenewalActivities" icon="el-icon-refresh">刷新</el-button>
                            <div v-if="isExperienceCard" style="color: #909399; font-size: 12px; margin-top: 8px;">
                                <i class="el-icon-info"></i> 体验卡不支持添加续费活动
                            </div>
                        </div>

                        <el-table :data="renewalActivities" style="width: 100%" stripe border>
                            <el-table-column prop="activityName" label="续费活动名称" width="180" align="center"></el-table-column>
                            <el-table-column label="续费优惠" width="200" align="center">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.activityType === 1">
                                        <el-tag type="success" size="small">直减</el-tag>
                                        <span style="margin-left: 8px;">￥{{ scope.row.discountAmount }}</span>
                                    </div>
                                    <div v-else-if="scope.row.activityType === 2">
                                        <el-tag type="warning" size="small">折扣</el-tag>
                                        <span style="margin-left: 8px;">{{ scope.row.discountRate }}折</span>
                                    </div>
                                    <div v-else-if="scope.row.activityType === 3">
                                        <el-tag type="info" size="small">满减</el-tag>
                                        <span style="margin-left: 8px;">满{{ scope.row.minAmount }}减{{ scope.row.discountAmount }}</span>
                                    </div>
                                    <div v-else-if="scope.row.activityType === 4">
                                        <el-tag type="primary" size="small">买送</el-tag>
                                        <span style="margin-left: 8px;">买{{ scope.row.buyCount }}送{{ scope.row.giftCount }}</span>
                                    </div>
                                    <div v-else-if="scope.row.activityType === 5">
                                        <el-tag type="danger" size="small">特价</el-tag>
                                        <span style="margin-left: 8px;">￥{{ scope.row.specialPrice }}</span>
                                    </div>
                                    <div v-else-if="scope.row.activityType === 6">
                                        <el-tag type="" size="small">升级</el-tag>
                                        <span style="margin-left: 8px;">￥{{ scope.row.discountAmount }}</span>
                                    </div>
                                    <div v-else-if="scope.row.activityType === 7">
                                        <el-tag type="success" size="small">续费</el-tag>
                                        <span style="margin-left: 8px;">
                                            <span v-if="scope.row.renewalType === 1">￥{{ scope.row.discountAmount }}</span>
                                            <span v-else-if="scope.row.renewalType === 2">{{ scope.row.discountRate }}折</span>
                                            <span v-else-if="scope.row.renewalType === 3">满{{ scope.row.minAmount }}减{{ scope.row.discountAmount }}</span>
                                            <span v-else>-</span>
                                        </span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="续费条件" width="150" align="center">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.renewalCondition === 1">
                                        <el-tag size="mini" type="success">到期前续费</el-tag>
                                    </div>
                                    <div v-else-if="scope.row.renewalCondition === 2">
                                        <el-tag size="mini" type="warning">到期后续费</el-tag>
                                    </div>
                                    <div v-else-if="scope.row.renewalCondition === 3">
                                        <el-tag size="mini" type="info">任意时间续费</el-tag>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="有效期" width="200" align="center">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.isLongTerm">
                                        <el-tag size="mini" type="success">长期有效</el-tag>
                                    </div>
                                    <div v-else>
                                        <div>{{ scope.row.startTime ? scope.row.startTime.replace('T', ' ').slice(0, 16) : '-' }}</div>
                                        <div>{{ scope.row.endTime ? scope.row.endTime.replace('T', ' ').slice(0, 16) : '-' }}</div>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="状态" width="100" align="center">
                                <template slot-scope="scope">
                                    <span v-if="scope.row.status === 1"
                                          style="display: inline-block; padding: 4px 12px; background-color: #67c23a; color: white; border-radius: 4px; font-size: 12px; font-weight: bold;">启用</span>
                                    <span v-else-if="scope.row.status === 2"
                                          style="display: inline-block; padding: 4px 12px; background-color: #e6a23c; color: white; border-radius: 4px; font-size: 12px; font-weight: bold;">暂停</span>
                                    <span v-else-if="scope.row.status === 3"
                                          style="display: inline-block; padding: 4px 12px; background-color: #f56c6c; color: white; border-radius: 4px; font-size: 12px; font-weight: bold;">结束</span>
                                    <span v-else
                                          style="display: inline-block; padding: 4px 12px; background-color: #909399; color: white; border-radius: 4px; font-size: 12px; font-weight: bold;">未知</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="显示" width="80" align="center">
                                <template slot-scope="scope">
                                    <el-switch
                                        v-model="scope.row.isShow"
                                        :active-value="1"
                                        :inactive-value="0"
                                        @change="toggleRenewalActivityShow(scope.row)">
                                    </el-switch>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="200" align="center">
                                <template slot-scope="scope">
                                    <el-dropdown @command="(command) => handleRenewalActivityCommand(command)" trigger="click">
                                        <el-button type="text" size="small">
                                            状态管理<i class="el-icon-arrow-down el-icon--right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item :command="{action: 'status', id: scope.row.id, status: 1}" v-if="scope.row.status !== 1">
                                                <span style="color: #67c23a; font-weight: bold;">● 启用</span>
                                            </el-dropdown-item>
                                            <el-dropdown-item :command="{action: 'status', id: scope.row.id, status: 2}" v-if="scope.row.status !== 2">
                                                <span style="color: #e6a23c; font-weight: bold;">● 暂停</span>
                                            </el-dropdown-item>
                                            <el-dropdown-item :command="{action: 'status', id: scope.row.id, status: 3}" v-if="scope.row.status !== 3">
                                                <span style="color: #f56c6c; font-weight: bold;">● 结束</span>
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <el-button type="text" size="small" @click="editRenewalActivity(scope.row)" v-permission="'btn:card:renewal:activity:edit'">编辑</el-button>
                                    <el-button type="text" size="small" style="color: #f56c6c;" @click="deleteRenewalActivity(scope.row.id)" v-permission="'btn:card:renewal:activity:delete'">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>

                    <!-- 升级活动标签页 -->
                    <el-tab-pane label="升级活动" name="upgrade">
                        <div style="margin-bottom: 20px;">
                            <el-button type="success" @click="addUpgradeActivity" v-permission="'btn:card:upgrade:activity:add'" :disabled="true">
                                <i class="el-icon-plus"></i> 添加升级活动（暂时禁用）
                            </el-button>
                            <el-button type="info" @click="refreshUpgradeActivities" style="margin-left: 10px;">
                                <i class="el-icon-refresh"></i> 刷新
                            </el-button>
                        </div>

                        <el-table :data="upgradeActivities" style="width: 100%" stripe border>
                            <el-table-column prop="activityName" label="升级活动名称" width="180" align="center"></el-table-column>
                            <el-table-column label="活动类型" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-tag :type="getActivityTypeTagType(scope.row.activityType)" size="small">
                                        {{ getActivityTypeName(scope.row.activityType) }}
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="源卡片" width="200" align="center">
                                <template slot-scope="scope">
                                    <div style="max-height: 60px; overflow-y: auto;">
                                        <el-tag v-for="cardName in getSourceCardNames(scope.row.sourceCardIds)"
                                                :key="cardName"
                                                size="mini"
                                                type="info"
                                                style="margin: 2px;">
                                            {{ cardName }}
                                        </el-tag>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column label="目标卡片" width="150" align="center">
                                <template slot-scope="scope">
                                    <el-tag type="success" size="small">
                                        {{ getTargetCardName(scope.row.targetCardId) }}
                                    </el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="升级价格" width="120" align="center">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.upgradePriceType === 1">
                                        <span style="color: #e6a23c;">固定 ￥{{ scope.row.upgradeFixedPrice }}</span>
                                    </div>
                                    <div v-else-if="scope.row.upgradePriceType === 2">
                                        <span style="color: #67c23a;">差价{{ scope.row.originalCardCreditRate }}%抵扣</span>
                                    </div>
                                    <div v-else-if="scope.row.upgradePriceType === 3">
                                        <span style="color: #409eff;">目标卡{{ scope.row.discountRate }}折</span>
                                    </div>
                                    <span v-else>-</span>
                                </template>
                            </el-table-column>
                            <el-table-column label="适用店铺" width="120" align="center">
                                <template slot-scope="scope">
                                    <div v-if="scope.row.applicableStoreIds">
                                        <el-tag size="mini" type="warning">
                                            {{ getApplicableStoreCount(scope.row.applicableStoreIds) }}家店铺
                                        </el-tag>
                                    </div>
                                    <el-tag v-else size="mini" type="success">全部店铺</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column prop="startTime" label="开始时间" width="150" align="center">
                                <template slot-scope="scope">
                                    {{ scope.row.startTime || '-' }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="endTime" label="结束时间" width="150" align="center">
                                <template slot-scope="scope">
                                    {{ scope.row.endTime || '-' }}
                                </template>
                            </el-table-column>
                            <el-table-column label="状态" width="100" align="center">
                                <template slot-scope="scope">
                                    <el-tag v-if="scope.row.status === 1" type="success" size="small">启用</el-tag>
                                    <el-tag v-else-if="scope.row.status === 2" type="warning" size="small">暂停</el-tag>
                                    <el-tag v-else-if="scope.row.status === 3" type="danger" size="small">结束</el-tag>
                                    <el-tag v-else type="info" size="small">未知</el-tag>
                                </template>
                            </el-table-column>
                            <el-table-column label="显示" width="80" align="center">
                                <template slot-scope="scope">
                                    <el-switch
                                        v-model="scope.row.isShow"
                                        @change="toggleUpgradeActivityShow(scope.row)"
                                        :active-value="1"
                                        :inactive-value="0">
                                    </el-switch>
                                </template>
                            </el-table-column>
                            <el-table-column label="操作" width="200" align="center">
                                <template slot-scope="scope">
                                    <el-dropdown @command="handleUpgradeActivityCommand" trigger="click">
                                        <el-button type="text" size="small">
                                            状态管理<i class="el-icon-arrow-down el-icon--right"></i>
                                        </el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item :command="{action: 'enable', activity: scope.row}" v-if="scope.row.status !== 1">
                                                <span style="color: #67c23a; font-weight: bold;">● 启用</span>
                                            </el-dropdown-item>
                                            <el-dropdown-item :command="{action: 'pause', activity: scope.row}" v-if="scope.row.status !== 2">
                                                <span style="color: #e6a23c; font-weight: bold;">● 暂停</span>
                                            </el-dropdown-item>
                                            <el-dropdown-item :command="{action: 'end', activity: scope.row}" v-if="scope.row.status !== 3">
                                                <span style="color: #f56c6c; font-weight: bold;">● 结束</span>
                                            </el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
                                    <el-button type="text" size="small" @click="editUpgradeActivity(scope.row)" v-permission="'btn:card:upgrade:activity:edit'">编辑</el-button>
                                    <el-button type="text" size="small" style="color: #f56c6c;" @click="deleteUpgradeActivity(scope.row.id)" v-permission="'btn:card:upgrade:activity:delete'">删除</el-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                </el-tabs>
            </el-dialog>

            <!--普通活动添加/编辑对话框-->
            <el-dialog
                :title="activityForm.id ? '编辑普通活动' : '添加普通活动'"
                :visible.sync="normalActivityDialogVisible"
                width="800px"
                :modal-append-to-body="false"
                :append-to-body="true"
                :close-on-click-modal="false"
                @close="resetActivityForm"
            >
                <el-form :model="activityForm" :rules="activityFormRules" ref="activityFormRef" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="活动名称" prop="activityName">
                                <el-input v-model="activityForm.activityName" placeholder="请输入活动名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="活动类型" prop="activityType">
                                <el-select v-model="activityForm.activityType" placeholder="请选择活动类型" style="width: 100%;" @change="onActivityTypeChange">
                                    <el-option label="直减" :value="1"></el-option>
                                    <!-- <el-option label="折扣" :value="2"></el-option> -->
                                    <el-option label="满减" :value="3"></el-option>
                                    <!-- <el-option label="买N送N" :value="4"></el-option> -->
                                    <el-option label="限时特价" :value="5"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 直减活动 -->
                    <el-row :gutter="20" v-if="activityForm.activityType === 1">
                        <el-col :span="12">
                            <el-form-item label="直减金额" prop="discountAmount">
                                <el-input v-model="activityForm.discountAmount" placeholder="请输入直减金额" type="number">
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 折扣活动 -->
                    <el-row :gutter="20" v-if="activityForm.activityType === 2">
                        <el-col :span="12">
                            <el-form-item label="折扣率" prop="discountRate">
                                <el-input v-model="activityForm.discountRate" placeholder="如8.5表示8.5折" type="number">
                                    <template slot="append">折</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 满减活动 -->
                    <el-row :gutter="20" v-if="activityForm.activityType === 3">
                        <el-col :span="12">
                            <el-form-item label="最低消费金额" prop="minAmount">
                                <el-input v-model="activityForm.minAmount" placeholder="满多少" type="number">
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="减免金额" prop="discountAmount">
                                <el-input v-model="activityForm.discountAmount" placeholder="减多少" type="number">
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 买N送N活动 -->
                    <el-row :gutter="20" v-if="activityForm.activityType === 4">
                        <el-col :span="12">
                            <el-form-item label="购买数量" prop="buyCount">
                                <el-input v-model="activityForm.buyCount" placeholder="买几张" type="number">
                                    <template slot="append">张</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="赠送数量" prop="giftCount">
                                <el-input v-model="activityForm.giftCount" placeholder="送几张" type="number">
                                    <template slot="append">张</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 限时特价活动 -->
                    <el-row :gutter="20" v-if="activityForm.activityType === 5">
                        <el-col :span="12">
                            <el-form-item label="特价价格" prop="specialPrice">
                                <el-input v-model="activityForm.specialPrice" placeholder="请输入特价价格" type="number">
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 时间设置区域，长期活动时隐藏 -->
                    <div v-if="!activityForm.isLongTerm">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="开始时间" prop="startTime">
                                    <el-date-picker v-model="activityForm.startTime" type="datetime" placeholder="选择开始时间" style="width: 100%;" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="结束时间" prop="endTime">
                                    <el-date-picker v-model="activityForm.endTime" type="datetime" placeholder="选择结束时间" style="width: 100%;" format="yyyy-MM-dd HH:mm:ss" value-format="yyyy-MM-dd HH:mm:ss"></el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="最大使用次数">
                                <el-input v-model="activityForm.maxUseCount" placeholder="0表示不限制" type="number"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <!-- 移除活动限购字段，只保留时间相关控制 -->
                            <!-- <el-form-item label="活动状态">
                                <el-select v-model="activityForm.status" placeholder="请选择活动状态">
                                    <el-option label="启用" :value="1"></el-option>
                                    <el-option label="禁用" :value="0"></el-option>
                                </el-select>
                            </el-form-item> -->
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="优先级">
                                <el-input v-model="activityForm.priority" placeholder="数字越大优先级越高" type="number"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="活动状态">
                                <el-select v-model="activityForm.status" style="width: 100%;">
                                    <el-option label="启用" :value="1"></el-option>
                                    <el-option label="暂停" :value="2"></el-option>
                                    <el-option label="结束" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="是否显示">
                                <el-switch v-model="activityForm.isShow" :active-value="1" :inactive-value="0" active-text="显示" inactive-text="隐藏"></el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="是否长期活动">
                                <el-switch v-model="activityForm.isLongTerm" :active-value="1" :inactive-value="0" active-text="是" inactive-text="否"></el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-form-item label="活动描述">
                        <el-input v-model="activityForm.activityDesc" type="textarea" rows="3" placeholder="请输入活动描述"></el-input>
                    </el-form-item>

                    <el-form-item label="备注">
                        <el-input v-model="activityForm.remark" type="textarea" rows="2" placeholder="请输入备注信息"></el-input>
                    </el-form-item>
                </el-form>

                <span slot="footer" class="dialog-footer">
                    <el-button @click="normalActivityDialogVisible = false">取消</el-button>
                    <el-button @click="resetActivityForm">重置</el-button>
                    <el-button type="primary" @click="saveActivity" v-permission="'btn:card:activity:save'" :loading="activityLoading">保存活动</el-button>
                </span>
            </el-dialog>

            <!--续费活动管理对话框-->
            <el-dialog
                :title="renewalActivityForm.id ? '编辑续费活动' : '添加续费活动'"
                :visible.sync="renewalActivityDialogVisible"
                width="800px"
                :modal-append-to-body="false"
                :append-to-body="true"
                :close-on-click-modal="false"
                @close="resetRenewalActivityForm"
            >
                <el-form :model="renewalActivityForm" :rules="renewalActivityFormRules" ref="renewalActivityFormRef" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="活动名称" prop="activityName">
                                <el-input v-model="renewalActivityForm.activityName" placeholder="请输入续费活动名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="续费优惠类型" prop="renewalType">
                                <el-select v-model="renewalActivityForm.renewalType" placeholder="请选择续费优惠类型" style="width: 100%;" @change="onRenewalTypeChange">
                                    <el-option label="直减优惠" :value="1"></el-option>
                                    <!-- <el-option label="折扣优惠" :value="2"></el-option> -->
                                    <el-option label="满减优惠" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 续费优惠设置 - 基于renewalType显示 -->
                    <!-- 直减优惠 -->
                    <div v-if="renewalActivityForm.renewalType === 1">
                        <el-form-item label="续费直减金额">
                            <el-input v-model="renewalActivityForm.discountAmount" placeholder="请输入续费直减金额" type="number">
                                <template slot="append">元</template>
                            </el-input>
                        </el-form-item>
                    </div>

                    <!-- 折扣优惠 -->
                    <div v-if="renewalActivityForm.renewalType === 2">
                        <el-form-item label="续费折扣率">
                            <el-input v-model="renewalActivityForm.discountRate" placeholder="请输入续费折扣率(如8.5表示8.5折)" type="number">
                                <template slot="append">折</template>
                            </el-input>
                        </el-form-item>
                    </div>

                    <!-- 满减优惠 -->
                    <div v-if="renewalActivityForm.renewalType === 3">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="满减条件">
                                    <el-input v-model="renewalActivityForm.minAmount" placeholder="最低续费金额" type="number">
                                        <template slot="append">元</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="减免金额">
                                    <el-input v-model="renewalActivityForm.discountAmount" placeholder="减免金额" type="number">
                                        <template slot="append">元</template>
                                    </el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="续费条件" prop="renewalCondition">
                                <el-select v-model="renewalActivityForm.renewalCondition" placeholder="请选择续费条件" style="width: 100%;">
                                    <el-option label="到期前续费" :value="1"></el-option>
                                    <el-option label="到期后续费" :value="2"></el-option>
                                    <el-option label="任意时间续费" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <!-- 移除续费活动限购字段，只保留时间相关控制 -->
                            <el-form-item label="续费活动状态">
                                <el-select v-model="renewalActivityForm.status" placeholder="请选择状态">
                                    <el-option label="启用" :value="1"></el-option>
                                    <el-option label="禁用" :value="0"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <div v-if="renewalActivityForm.renewalCondition === 1">
                        <el-form-item label="提前续费天数">
                            <el-input v-model="renewalActivityForm.renewalDaysAdvance" placeholder="到期前多少天可续费" type="number" step="1" min="1" @input="validateIntegerInput('renewalDaysAdvance', 'renewalActivityForm')">
                                <template slot="append">天</template>
                            </el-input>
                        </el-form-item>
                    </div>

                    <div v-if="renewalActivityForm.renewalCondition === 2">
                        <el-form-item label="延后续费天数">
                            <el-input v-model="renewalActivityForm.renewalDaysAfter" placeholder="到期后多少天可续费" type="number" step="1" min="1" @input="validateIntegerInput('renewalDaysAfter', 'renewalActivityForm')">
                                <template slot="append">天</template>
                            </el-input>
                        </el-form-item>
                    </div>

                    <el-row :gutter="20">
                        <el-col :span="8">
                            <el-form-item label="是否长期">
                                <el-switch
                                    v-model="renewalActivityForm.isLongTerm"
                                    :active-value="1"
                                    :inactive-value="0"
                                    active-text="长期有效"
                                    inactive-text="限时活动">
                                </el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="活动状态">
                                <el-select v-model="renewalActivityForm.status" style="width: 100%;">
                                    <el-option label="启用" :value="1"></el-option>
                                    <el-option label="暂停" :value="2"></el-option>
                                    <el-option label="结束" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="是否显示">
                                <el-switch
                                    v-model="renewalActivityForm.isShow"
                                    :active-value="1"
                                    :inactive-value="0"
                                    active-text="显示"
                                    inactive-text="隐藏">
                                </el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <div v-if="!renewalActivityForm.isLongTerm">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="开始时间">
                                    <el-date-picker
                                        v-model="renewalActivityForm.startTime"
                                        type="datetime"
                                        placeholder="选择开始时间"
                                        style="width: 100%;"
                                        format="yyyy-MM-dd HH:mm:ss"
                                        value-format="yyyy-MM-dd HH:mm:ss">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="结束时间">
                                    <el-date-picker
                                        v-model="renewalActivityForm.endTime"
                                        type="datetime"
                                        placeholder="选择结束时间"
                                        style="width: 100%;"
                                        format="yyyy-MM-dd HH:mm:ss"
                                        value-format="yyyy-MM-dd HH:mm:ss">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>

                    <el-form-item label="活动描述">
                        <el-input v-model="renewalActivityForm.activityDesc" type="textarea" :rows="3" placeholder="请输入活动描述"></el-input>
                    </el-form-item>

                    <el-form-item label="备注">
                        <el-input v-model="renewalActivityForm.remark" type="textarea" :rows="2" placeholder="请输入备注信息"></el-input>
                    </el-form-item>
                </el-form>

                <div slot="footer" class="dialog-footer">
                    <el-button @click="renewalActivityDialogVisible = false">取消</el-button>
                    <el-button type="primary" @click="saveRenewalActivity" :loading="renewalActivityLoading">保存</el-button>
                </div>
            </el-dialog>

            <!--升级活动管理对话框-->
            <el-dialog
                :title="upgradeActivityForm.id ? '编辑升级活动' : '添加升级活动'"
                :visible.sync="upgradeActivityDialogVisible"
                width="70%"
                top="3vh"
                @close="resetUpgradeActivityForm">

                <el-form :model="upgradeActivityForm" :rules="upgradeActivityFormRules" ref="upgradeActivityFormRef" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="活动名称" prop="activityName">
                                <el-input v-model="upgradeActivityForm.activityName" placeholder="请输入升级活动名称"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="活动状态" prop="status">
                                <el-select v-model="upgradeActivityForm.status" placeholder="请选择状态" style="width: 100%;">
                                    <el-option label="启用" :value="1"></el-option>
                                    <el-option label="暂停" :value="2"></el-option>
                                    <el-option label="结束" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="源卡片" prop="sourceCardIds">
                                <el-select
                                    v-model="upgradeActivityForm.sourceCardIds"
                                    multiple
                                    placeholder="当前卡片"
                                    style="width: 100%;"
                                    disabled
                                    @change="onSourceCardsChange">
                                    <el-option
                                        v-for="card in availableSourceCards"
                                        :key="card.id"
                                        :label="card.cardname"
                                        :value="card.id">
                                    </el-option>
                                </el-select>
                                <div style="margin-top: 5px; font-size: 12px; color: #999;">
                                    源卡片固定为当前正在管理的卡片
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="目标卡片" prop="targetCardId">
                                <el-select
                                    v-model="upgradeActivityForm.targetCardId"
                                    placeholder="请选择升级目标卡片"
                                    style="width: 100%;"
                                    @change="onTargetCardChange">
                                    <el-option
                                        v-for="card in availableTargetCards"
                                        :key="card.id"
                                        :label="`${card.cardname} (¥${card.price})`"
                                        :value="card.id">
                                        <span style="float: left">{{ card.cardname }}</span>
                                        <span style="float: right; color: #8492a6; font-size: 13px">¥{{ card.price }}</span>
                                    </el-option>
                                </el-select>
                                <div style="margin-top: 5px; font-size: 12px; color: #999;">
                                    显示当前店铺下的其他可用卡片
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="升级价格类型" prop="upgradePriceType">
                                <el-select
                                    v-model="upgradeActivityForm.upgradePriceType"
                                    placeholder="请选择升级价格类型"
                                    style="width: 100%;"
                                    @change="onUpgradePriceTypeChange">
                                    <el-option label="固定升级费用" :value="1"></el-option>
                                    <el-option label="价格差额+原卡抵扣" :value="2"></el-option>
                                    <el-option label="目标卡折扣价" :value="3"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="upgradeActivityForm.upgradePriceType === 1">
                            <el-form-item label="固定升级费用" prop="upgradeFixedPrice">
                                <el-input
                                    v-model="upgradeActivityForm.upgradeFixedPrice"
                                    placeholder="请输入固定升级费用"
                                    type="number">
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="upgradeActivityForm.upgradePriceType === 2">
                            <el-form-item label="原卡抵扣比例" prop="originalCardCreditRate">
                                <el-input
                                    v-model="upgradeActivityForm.originalCardCreditRate"
                                    placeholder="原卡剩余价值抵扣比例"
                                    type="number">
                                    <template slot="append">%</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="upgradeActivityForm.upgradePriceType === 3">
                            <el-form-item label="目标卡折扣" prop="discountRate">
                                <el-input
                                    v-model="upgradeActivityForm.discountRate"
                                    placeholder="目标卡折扣率"
                                    type="number">
                                    <template slot="append">折</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="适用店铺">
                                <el-select
                                    v-model="upgradeActivityForm.applicableStoreIds"
                                    multiple
                                    placeholder="请选择适用店铺（不选则全部适用）"
                                    style="width: 100%;">
                                    <el-option
                                        v-for="store in storeList"
                                        :key="store.id"
                                        :label="store.storename"
                                        :value="store.id">
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="升级条件">
                                <el-input
                                    v-model="upgradeActivityForm.upgradeConditions"
                                    placeholder="升级条件（JSON格式，可选）"
                                    type="textarea"
                                    rows="2">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="开始时间" prop="startTime">
                                <el-date-picker
                                    v-model="upgradeActivityForm.startTime"
                                    type="datetime"
                                    placeholder="选择开始时间"
                                    style="width: 100%;"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="结束时间" prop="endTime">
                                <el-date-picker
                                    v-model="upgradeActivityForm.endTime"
                                    type="datetime"
                                    placeholder="选择结束时间"
                                    style="width: 100%;"
                                    format="yyyy-MM-dd HH:mm:ss"
                                    value-format="yyyy-MM-dd HH:mm:ss">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-form-item label="活动描述">
                        <el-input
                            v-model="upgradeActivityForm.activityDesc"
                            type="textarea"
                            rows="3"
                            placeholder="请输入升级活动描述">
                        </el-input>
                    </el-form-item>

                    <el-form-item label="备注">
                        <el-input
                            v-model="upgradeActivityForm.remark"
                            type="textarea"
                            rows="2"
                            placeholder="请输入备注信息">
                        </el-input>
                    </el-form-item>
                </el-form>

                <div slot="footer" class="dialog-footer" style="text-align: center; padding: 15px 0;">
                    <el-button size="medium" @click="upgradeActivityDialogVisible = false">取消</el-button>
                    <el-button type="primary" size="medium" @click="saveUpgradeActivity" v-permission="'btn:card:upgrade:activity:save'" :loading="upgradeActivityLoading">保存</el-button>
                </div>
            </el-dialog>

            <!--店铺价格管理对话框-->
            <el-dialog :title="'管理【' + currentCardName + '】的店铺价格'" :visible.sync="storePriceDialogVisible" width="85%" top="2vh">
                <!-- 操作栏 -->
                <div style="background: #f5f7fa; padding: 18px 20px; border-radius: 8px; margin-bottom: 15px;margin-top: -15px; min-height: 30px;margin-top: -20px">
                    <el-row :gutter="20" type="flex" justify="space-between" align="middle" style="min-height: 20px;">
                        <el-col :span="8">
                            <el-input
                                v-model="storePriceSearchText"
                                placeholder="搜索店铺名称..."
                                prefix-icon="el-icon-search"
                                clearable
                                @input="filterStorePrices"
                                style="width: 100%; height: 20px;"
                                size="medium"
                            ></el-input>
                        </el-col>
                        <el-col :span="8" v-if="currentCardClassId !== 3">
                            <el-input
                                v-model="storePriceMDSearchText"
                                placeholder="搜索美团/抖音/高德..."
                                prefix-icon="el-icon-search"
                                clearable
                                @input="filterStorePrices"
                                style="width: 100%; height: 20px;"
                                size="medium"
                            ></el-input>
                        </el-col>
                        <el-col :span="8">
                            <el-input
                                v-model="storePriceDaySearchText"
                                placeholder="搜索有效天数"
                                prefix-icon="el-icon-search"
                                clearable
                                @input="filterStorePrices"
                                style="width: 100%; height: 20px;"
                                size="medium"
                            ></el-input>
                        </el-col>
                        <el-col :span="12" style="text-align: right;">
                            <!-- 只有单店卡才显示添加店铺价格按钮 -->
                            <el-button v-if="currentCardScopeType === 1" type="primary" icon="el-icon-plus" @click="showAddStorePriceDialog" v-permission="'btn:card:store:price:add'" size="medium" :loading="showAddStorePriceLoading">添加店铺价格</el-button>
                            <el-button type="warning" icon="el-icon-refresh" @click="loadStorePrices" size="medium" :loading="loadStorePricesLoading">刷新</el-button>
                        </el-col>
                    </el-row>
                </div>

                <!-- 价格编辑权限提示 -->
                <div v-if="currentCardScopeType && currentCardScopeType !== 1" style="margin-bottom: 15px; padding: 12px 16px; background: #fff7e6; border-radius: 4px; border-left: 4px solid #faad14;">
                    <span style="color: #d48806; font-weight: bold; font-size: 14px;">
                        <i class="el-icon-warning"></i>
                        当前卡片为<el-tag size="mini" :type="getScopeTypeTagType(currentCardScopeType)" style="margin: 0 5px;">{{ getScopeTypeText(currentCardScopeType) }}</el-tag>，价格由卡片统一设置，店铺价格不可单独修改
                    </span>
                </div>

                <!-- 统计信息 -->
                <div style="margin-bottom: 10px; padding: 8px 12px; background: #ecf5ff; border-radius: 4px; border-left: 4px solid #409eff;">
                    <span style="color: #409eff; font-weight: bold; font-size: 13px;">
                        <i class="el-icon-info"></i>
                        共找到 {{ filteredStorePriceList.length }} 个店铺价格配置
                        <span v-if="storePriceSearchText" style="margin-left: 10px;">（搜索：{{ storePriceSearchText }}）</span>
                        <span v-if="storePriceMDSearchText" style="margin-left: 10px;">（搜索：{{ storePriceMDSearchText }}）</span>
                        <span v-if="storePriceDaySearchText" style="margin-left: 10px;">（搜索：{{ storePriceDaySearchText }}）</span>
                    </span>
                </div>


                <!-- 表格容器 -->
                <div style="overflow-x: auto; border: 1px solid #ebeef5; border-radius: 4px;">
                    <el-table :data="paginatedStorePriceList" border stripe style="min-width: 1240px; width: 100%;" :header-cell-style="{textAlign: 'center', background: '#f5f7fa', color: '#606266'}">
                    <el-table-column prop="storeName" label="店铺名称" width="150" align="center">
                        <template slot-scope="scope">
                            <div style="display: flex; align-items: center; justify-content: center;">
                                <i class="el-icon-shop" style="color: #409eff; margin-right: 5px;"></i>
                                <span style="font-weight: bold; color: #303133;">{{ scope.row.storeName }}</span>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column prop="storeDesc" label="描述" width="150" align="center"></el-table-column>
                    <el-table-column label="价格" width="120" align="center">
                        <template slot-scope="scope">
                            <span style="color: #e6a23c; font-weight: bold;">￥{{ scope.row.price }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="costPrice" label="成本价" width="120" align="center">
                        <template slot-scope="scope">
                            <span style="color: #909399;">￥{{ scope.row.costPrice || 0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="days" label="有效天数" width="120" align="center" v-if="currentCardClassId !== 3">
                        <template slot-scope="scope">
                            <span v-if="currentCardClassId == 2" style="color: #67c23a; font-weight: bold;">{{ scope.row.days || '-' }} 天 / {{ scope.row.useTimes || scope.row.use_times || '-' }} 次</span>
                            <span v-else style="color: #67c23a; font-weight: bold;">{{ scope.row.days || '-' }} 天</span>
                        </template>
                    </el-table-column>
                    <!-- <el-table-column prop="presaleTime" label="预售时间" width="150" align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row.presaleTime" style="display: flex; align-items: center; justify-content: center;">
                                <i class="el-icon-time" style="color: #409eff; margin-right: 5px;"></i>
                                <span style="color: #409eff; font-size: 12px; font-weight: bold;">
                                    {{ scope.row.presaleTime.slice(0, 16) }}
                                </span>
                            </div>
                            <span v-else style="color: #c0c4cc;">-</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="限购设置" width="120" align="center" v-if="currentCardClassId !== 3">
                        <template slot-scope="scope">
                            <el-tag size="mini" v-if="scope.row.purchaseLimitType == 0" type="success">无限购</el-tag>
                            <el-tag size="mini" type="warning" v-if="scope.row.purchaseLimitType == 1">总量限购</el-tag>
                            <el-tag size="mini" type="danger" v-if="scope.row.purchaseLimitType == 2">个人限购</el-tag>
                            <el-tag size="mini" type="info" v-if="scope.row.purchaseLimitType == 3">混合限购</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="totalLimit" label="总限购" width="80" align="center" v-if="currentCardClassId !== 3"></el-table-column>
                    <el-table-column prop="soldCount" label="已售" width="80" align="center">
                        <template slot-scope="scope">
                            <span style="color: #f56c6c;">{{ scope.row.soldCount || 0 }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column prop="personalLimit" label="个人限购" width="80" align="center" v-if="currentCardClassId !== 3"></el-table-column>
                    <!-- <el-table-column prop="upgradeDiscount" label="升级折扣" width="80" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.upgradeDiscount > 0">{{ scope.row.upgradeDiscount }}%</span>
                            <span v-else>-</span>
                        </template>
                    </el-table-column> -->
                    <el-table-column label="状态" width="80" align="center">
                        <template slot-scope="scope">
                            <el-tooltip
                                :content="scope.row.isActive == 1 ? '启用' : '禁用'"
                                placement="top"
                            >
                                <el-switch
                                    v-model="scope.row.isActive"
                                    :active-value="1"
                                    :inactive-value="0"
                                    active-color="#67c23a"
                                    inactive-color="#c0c4cc"
                                    @change="toggleStorePriceStatus(scope.row)"
                                    v-permission="'btn:card:store:price:toggle'"
                                    style="margin: 0;"
                                >
                                </el-switch>
                            </el-tooltip>
                        </template>
                    </el-table-column>
                    <el-table-column prop="douyinId" label="抖音ID" width="120" align="center"></el-table-column>
                    <el-table-column prop="meituanId" label="美团ID" width="120" align="center"></el-table-column>
                    <el-table-column prop="gaodeId" label="高德ID" width="120" align="center"></el-table-column>
                    <el-table-column label="自动续费" width="160" align="center">
                        <template slot-scope="scope">
                            <div v-if="scope.row.isAutoRenewal == 1">
                                <el-popover placement="bottom" width="450" trigger="click">
                                    <div style="font-size: 13px;">
                                        <div style="margin-bottom: 10px; padding-bottom: 8px; border-bottom: 1px solid #e8e8e8; display: flex; flex-wrap: wrap;">
                                            <div style="line-height: 1.8; width: 50%;"><strong>续费类型：</strong>{{ getRenewalTypeLabel(scope.row.renewalType) }}</div>
                                            <div style="line-height: 1.8; width: 50%;"><strong>扣款方式：</strong>{{ getDeductMethodLabel(scope.row.deductMethod) }}</div>
                                            <div style="line-height: 1.8; width: 50%;"><strong>扣费周期：</strong>{{ scope.row.deductCycle || 1 }}期</div>
                                            <div style="line-height: 1.8; width: 50%;"><strong>提前扣款：</strong>{{ scope.row.advanceDeductDays == null ? 1 : scope.row.advanceDeductDays }}天</div>
                                            <div style="line-height: 1.8; width: 50%;"><strong>重试次数：</strong>{{ scope.row.retryTimes == null ? 3 : scope.row.retryTimes }}次</div>
                                        </div>
                                        <div v-if="scope.row.deductDetails && scope.row.deductDetails.length">
                                            <div style="font-weight: bold; margin-bottom: 6px;">代扣明细（{{ scope.row.deductDetails.length }}期）</div>
                                            <el-table :data="scope.row.deductDetails" border size="mini" max-height="250" style="width: 100%;">
                                                <el-table-column prop="phase" label="阶段" min-width="60" align="center">
                                                    <template slot-scope="s">第{{ s.row.phase }}期</template>
                                                </el-table-column>
                                                <el-table-column prop="originalPrice" label="原价" min-width="80" align="center">
                                                    <template slot-scope="s">￥{{ s.row.originalPrice }}</template>
                                                </el-table-column>
                                                <el-table-column prop="actualPrice" label="优惠价" min-width="80" align="center">
                                                    <template slot-scope="s">￥{{ s.row.actualPrice }}</template>
                                                </el-table-column>
                                                <el-table-column prop="saving" label="每期节省" min-width="80" align="center">
                                                    <template slot-scope="s">
                                                        <span style="color: #67c23a;">省￥{{ s.row.saving }}</span>
                                                    </template>
                                                </el-table-column>
                                            </el-table>
                                        </div>
                                        <div v-else style="color: #909399; font-size: 12px;">暂无代扣明细</div>
                                    </div>
                                    <el-tag type="success" size="small" slot="reference" style="cursor: pointer;">
                                        {{ getRenewalTypeLabel(scope.row.renewalType) }}
                                    </el-tag>
                                </el-popover>
                            </div>
                            <el-tag v-else type="info" size="small">否</el-tag>
                        </template>
                    </el-table-column>

                    <el-table-column label="是否显示" width="120" align="center">

                      <template slot-scope="scope">
                        <el-tooltip
                            :content="scope.row.isShow == '1' ? '显示' : '隐藏'"
                            placement="top"
                        >
                          <el-switch
                              v-model="scope.row.isShow"
                              :active-value="1"
                              :inactive-value="0"
                              active-color="#67c23a"
                              inactive-color="#c0c4cc"
                              @change="toggleStorePriceShow(scope.row)"

                              style="margin: 0;"
                          >
                          </el-switch>
                        </el-tooltip>
                      </template>
                    </el-table-column>
                     <el-table-column prop="remark" label="备注" width="120" align="center"></el-table-column>
                        <el-table-column label="操作" min-width="130" align="center" >
                            <template slot-scope="scope">
                                <div style="display: flex; justify-content: center; align-items: center; gap: 6px; flex-wrap: nowrap;">
                                    <el-button type="primary" size="mini" icon="el-icon-edit" @click="editStorePrice(scope.row)" v-if="currentCardScopeType == '1'" v-permission="'btn:card:store:price:edit'" style="padding: 6px 10px; font-size: 12px;">编辑</el-button>
                                    <el-button type="success" size="mini" icon="el-icon-present" @click="ManageActivities(scope.row.cardId, scope.row.id, scope.row.storeName)" v-if="currentCardClassId !== 3" v-permission="'btn:card:activity:manage'" style="padding: 6px 10px; font-size: 12px;">活动</el-button>
                                    <!-- <el-button type="danger" size="mini" icon="el-icon-delete" @click="deleteStorePrice(scope.row.id)" v-permission="''" style="padding: 6px 10px; font-size: 12px;">删除</el-button> -->
                                </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>

                <!-- 店铺价格分页 -->
                <div style="margin-top: 12px; text-align: center;">
                    <el-pagination
                        @size-change="handleStorePriceSizeChange"
                        @current-change="handleStorePriceCurrentChange"
                        :current-page="storePriceCurrentPage"
                        :page-sizes="[10, 15, 20, 30]"
                        :page-size="storePricePageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="filteredStorePriceList.length"
                        background>
                    </el-pagination>
                </div>
            </el-dialog>

            <!--添加/编辑店铺价格对话框-->
            <el-dialog
                :title="storePriceForm.id ? '编辑店铺价格' : '添加店铺价格'"
                :visible.sync="addStorePriceDialogVisible"
                width="800px"
                :modal-append-to-body="false"
                :append-to-body="true"
                :close-on-click-modal="false"
                class="store-price-dialog"
            >
                <el-form :model="storePriceForm" :rules="storePriceFormRules" ref="storePriceFormRef" label-width="120px">
                    <!-- 会员卡适用范围类型回显 -->
                    <div style="
                        background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
                        border: 1px solid #dee2e6;
                        border-radius: 8px;
                        padding: 16px 20px;
                        margin-bottom: 24px;
                        border-left: 4px solid #409eff;
                        box-shadow: 0 2px 4px rgba(0,0,0,0.05);
                        min-height: 56px;
                        display: flex;
                        align-items: center;
                    ">
                        <div style="
                            display: flex;
                            align-items: center;
                            justify-content: space-between;
                            width: 100%;
                            min-height: 24px;
                        ">
                            <div style="display: flex; align-items: center; gap: 14px;">
                                <span style="
                                    font-weight: 600;
                                    color: #2c3e50;
                                    font-size: 15px;
                                    line-height: 24px;
                                    display: flex;
                                    align-items: center;
                                ">
                                    <i class="el-icon-postcard" style="
                                        margin-right: 8px;
                                        color: #409eff;
                                        font-size: 16px;
                                    "></i>会员卡范围类型：
                                </span>
                                <el-tag
                                    :type="getScopeTypeTagType(currentCardScopeType)"
                                    size="medium"
                                    effect="dark"
                                    style="
                                        font-weight: bold;
                                        padding: 8px 16px;
                                        font-size: 14px;
                                        border-radius: 20px;
                                        display: flex;
                                        align-items: center;
                                        min-height: 32px;
                                    "
                                >
                                    <i class="el-icon-info" style="margin-right: 6px; font-size: 14px;"></i>{{ getScopeTypeText(currentCardScopeType) }}
                                </el-tag>
                            </div>
                            <span style="
                                color: #6c757d;
                                font-size: 12px;
                                font-style: italic;
                                line-height: 24px;
                                display: flex;
                                align-items: center;
                            ">
                                （来自会员卡设置，不可修改）
                            </span>
                        </div>
                    </div>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="选择店铺" prop="storeId">
                                <el-select v-model="storePriceForm.storeId" filterable placeholder="请选择店铺" style="width: 100%;" :disabled="!!storePriceForm.id" @change="onStoreChange">
                                    <el-option
                                        v-for="store in storeList"
                                        :key="store.id"
                                        :label="store.storename"
                                        :value="store.id"
                                        :disabled="isStoreAlreadyAdded(store.id)"
                                        :class="{ 'disabled-option': isStoreAlreadyAdded(store.id) }"
                                    >
                                        <span :style="{ color: isStoreAlreadyAdded(store.id) ? '#c0c4cc' : '#606266' }">
                                            {{ store.storename }}
                                            <span v-if="isStoreAlreadyAdded(store.id)" style="color: #e6a23c; margin-left: 8px;">
                                                <i class="el-icon-check"></i> 已添加
                                            </span>
                                        </span>
                                    </el-option>
                                </el-select>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="销售价格" prop="price">
                                <!-- 根据卡片范围类型控制价格输入 -->
                                <el-input
                                    v-model="storePriceForm.price"
                                    placeholder="请输入销售价格"
                                    type="number"
                                    :disabled="currentCardScopeType && currentCardScopeType !== 1"
                                    @input="validateNumberInput('price', $event, 'store')">
                                    <template slot="append">元</template>
                                </el-input>
                                <!-- 非单店卡的价格提示 -->
                                <div v-if="currentCardScopeType && currentCardScopeType !== 1" style="margin-top: 5px; color: #e6a23c; font-size: 12px;">
                                    <i class="el-icon-warning"></i> {{ getScopeTypeText(currentCardScopeType) }}价格由卡片统一设置，不可修改
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="成本价格" required>
                                <el-input v-model="storePriceForm.costPrice" placeholder="请输入成本价格（可选）" type="number" @input="validateNumberInput('costPrice', $event, 'store')">
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="!isStoreEditExperienceCard">
                            <el-form-item label="有效天数" :required="currentCardScopeType == 1" prop="days">
                                <el-input
                                    v-model="storePriceForm.days"
                                    placeholder="请输入有效天数"
                                    type="number"
                                    step="1"
                                    min="1"
                                    :disabled="currentCardScopeType && currentCardScopeType !== 1"
                                    @input="validateIntegerInput('days', 'storePriceForm')">
                                    <template slot="append">天</template>
                                </el-input>
                                <div v-if="currentCardScopeType && currentCardScopeType !== 1" style="margin-top: 5px; color: #e6a23c; font-size: 12px;">
                                    非单店卡的有效天数由全局设置决定
                                </div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12" v-if="currentCardClassId === 2 && !isStoreEditExperienceCard">
                            <el-form-item label="可用次数" :required="currentCardScopeType == 1" prop="useTimes">
                                <el-input
                                    v-model="storePriceForm.useTimes"
                                    placeholder="请输入可用次数"
                                    type="number"
                                    step="1"
                                    min="1"
                                    :disabled="currentCardScopeType && currentCardScopeType !== 1"
                                    @input="validateIntegerInput('useTimes', 'storePriceForm')">
                                    <template slot="append">次</template>
                                </el-input>
                                <div v-if="currentCardScopeType && currentCardScopeType !== 1" style="margin-top: 5px; color: #e6a23c; font-size: 12px;">
                                    非单店卡的可用次数由全局设置决定
                                </div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="预售时间">
                                <el-date-picker
                                    v-model="storePriceForm.presaleTime"
                                    type="datetime"
                                    disabled
                                    placeholder="选择预售时间（可选）"
                                    value-format="yyyy-MM-dd HH:mm:ss"
                                    style="width: 100%;"
                                ></el-date-picker>
                                <span style="padding-left: 20px; color: #999; font-size: 12px;">注：设置预售时间后，该店铺的会员卡将在指定时间开始销售</span>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-row :gutter="20" v-if="storePriceForm.isAutoRenewal != 1">
                        <el-col :span="12">
                            <el-form-item label="抖音商品ID">
                                <el-input
                                    v-model="storePriceForm.douyinId"
                                    placeholder="请输入抖音商品ID"
                                    :disabled="currentCardClassId === 3 || (currentCardScopeType && currentCardScopeType !== 1)"
                                    @blur="checkDouyinIdUnique('store')"></el-input>
                                <div v-if="currentCardScopeType && currentCardScopeType !== 1" style="margin-top: 5px; color: #e6a23c; font-size: 12px;">
                                    <i class="el-icon-warning"></i> 抖音ID由卡片统一设置
                                </div>
                              <div v-if="currentCardClassId === 3" style="color: #909399; font-size: 12px; margin-top: 4px;">体验卡不支持团购设置</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="美团商品ID">
                                <el-input
                                    v-model="storePriceForm.meituanId"
                                    placeholder="请输入美团商品ID"
                                    :disabled="currentCardClassId === 3 || (currentCardScopeType && currentCardScopeType !== 1)"
                                    @blur="checkMeituanIdUnique('store')"></el-input>
                                <div v-if="currentCardScopeType && currentCardScopeType !== 1" style="margin-top: 5px; color: #e6a23c; font-size: 12px;">
                                    <i class="el-icon-warning"></i> 美团ID由卡片统一设置
                                </div>
                              <div v-if="currentCardClassId === 3" style="color: #909399; font-size: 12px; margin-top: 4px;">体验卡不支持团购设置</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="高德商品ID">
                                <el-input
                                    v-model="storePriceForm.gaodeId"
                                    placeholder="请输入高德商品ID"
                                    :disabled="currentCardClassId === 3 || (currentCardScopeType && currentCardScopeType !== 1)"
                                    @blur="checkGaodeIdUnique('store')"></el-input>
                                <div v-if="currentCardScopeType && currentCardScopeType !== 1" style="margin-top: 5px; color: #e6a23c; font-size: 12px;">
                                    <i class="el-icon-warning"></i> 高德ID由卡片统一设置
                                </div>
                              <div v-if="currentCardClassId === 3" style="color: #909399; font-size: 12px; margin-top: 4px;">体验卡不支持团购设置</div>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <!-- 限购设置区域 -->
                    <div v-if="!isStoreEditExperienceCard && currentCardClassId !== 3" style="background: #fff7e6; border: 1px solid #faad14; padding: 15px; margin: 15px 0; border-radius: 4px; border-left: 4px solid #faad14;">
                        <div style="display: flex; align-items: center; margin-bottom: 10px;">
                            <i class="el-icon-warning" style="color: #faad14; margin-right: 8px; font-size: 16px;"></i>
                            <span style="color: #d48806; font-weight: bold; font-size: 14px;">限购设置限制说明</span>
                        </div>
                        <div style="color: #d48806; font-size: 13px; line-height: 1.5; margin-bottom: 15px;">
                            限购相关设置在卡片创建后不可修改，以下字段仅供查看。
                        </div>

                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="限购类型">
                                    <el-select v-model="storePriceForm.purchaseLimitType" style="width: 100%;" :disabled="isStorePurchaseLimitTypeDisabled()">
                                        <el-option label="无限购" :value="0"></el-option>
                                        <el-option label="总量限购" :value="1"></el-option>
                                        <el-option label="个人限购" :value="2"></el-option>
                                        <el-option label="混合限购" :value="3"></el-option>
                                    </el-select>
                                    <div v-if="storePriceForm.purchaseLimitType === 0" style="color: #67c23a; font-size: 12px; margin-top: 4px;">可以从无限购修改为其他限购类型</div>
                                    <div v-else style="color: #f56c6c; font-size: 12px; margin-top: 4px;">限购类型已设置，无法修改</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" v-if="storePriceForm.purchaseLimitType === 1 || storePriceForm.purchaseLimitType === 3">
                                <el-form-item label="总限购数量">
                                    <el-input v-model="storePriceForm.totalLimit" placeholder="总限购数量" type="number" :disabled="false"></el-input>
                                    <div style="color: #909399; font-size: 12px; margin-top: 4px;">总限购数量不可修改</div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8" v-if="storePriceForm.purchaseLimitType === 2 || storePriceForm.purchaseLimitType === 3">
                                <el-form-item label="个人限购数量">
                                    <el-input v-model="storePriceForm.personalLimit" placeholder="个人限购数量" type="number" :disabled="false"></el-input>
                                    <div style="color: #909399; font-size: 12px; margin-top: 4px;">个人限购数量不可修改</div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <el-row :gutter="20" v-if="!isStoreEditExperienceCard">
                        <!-- <el-col :span="8">
                            <el-form-item label="升级折扣">
                                <el-input v-model="storePriceForm.upgradeDiscount" placeholder="升级折扣百分比" type="number" @input="validateNumberInput('upgradeDiscount', storePriceForm.upgradeDiscount, 'store')">
                                    <template slot="append">%</template>
                                </el-input>
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="8">
                            <el-form-item label="状态">
                                <el-switch v-model="storePriceForm.isActive" :active-value="1" :inactive-value="0" active-text="启用" inactive-text="禁用"></el-switch>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item label="是否显示">
                                <el-switch v-model="storePriceForm.isShow" :active-value="1" :inactive-value="0" active-text="显示" inactive-text="隐藏"></el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <el-form-item label="店铺特定描述">
                        <el-input
                            type="textarea"
                            v-model="storePriceForm.storeDesc"
                            placeholder="该店铺的特定描述信息（可选，最多16个字符）"
                            :rows="3"
                            maxlength="20"
                            show-word-limit
                            @input="validateStoreDesc">
                        </el-input>
                    </el-form-item>
                    <el-form-item label="备注">
                        <el-input v-model="storePriceForm.remark" placeholder="备注信息（可选）"></el-input>
                    </el-form-item>

                    <!-- 自动续费配置区域（编辑时显示，基于当前店铺价格行数据） -->
                    <div v-if="storePriceForm.isAutoRenewal == 1" style="border: 1px solid #e8e8e8; border-radius: 8px; padding: 15px; margin-bottom: 15px; background: #fafafa;">
                        <div style="display: flex; align-items: center; margin-bottom: 10px;">
                            <span style="font-weight: bold; font-size: 14px; margin-right: 16px;">
                                <i class="el-icon-refresh"></i> 自动续费设置
                            </span>
                            <el-tag type="success" size="small">已启用</el-tag>
                            <span style="font-size: 11px; color: #909399; margin-left: 8px;">（来自会员卡设置，不可修改）</span>
                        </div>
                        <el-row :gutter="15">
                            <el-col :span="12">
                                <el-form-item label="续费类型" required>
                                    <el-select v-model="storePriceForm.renewalType" size="small" style="width: 100%;" @change="onStoreRenewalTypeChange">
                                        <el-option
                                            v-for="item in autoRenewalTypes"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="扣款方式" required>
                                    <el-select v-model="storePriceForm.deductMethod" size="small" style="width: 100%;">
                                        <el-option
                                            v-for="item in deductMethods"
                                            :key="item.value"
                                            :label="item.label"
                                            :value="item.value">
                                        </el-option>
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="15">
                            <el-col :span="12">
                                <el-form-item label="扣费周期" required>
                                    <el-input v-model="storePriceForm.deductCycle" type="number" :min="1" :max="36" size="small" style="width: 100%;" @change="onStoreDeductCycleChange">
                                        <template slot="append">{{ batchRenewalUnit }}</template>
                                    </el-input>
                                    <div style="font-size: 11px; color: #909399; margin-top: 2px;">
                                        扣满自动解约，需重新签约（1-36）
                                    </div>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="提前扣款天数" required>
                                    <el-input v-model="storePriceForm.advanceDeductDays" type="number" :min="0" :max="3" size="small" style="width: 100%;">
                                        <template slot="append">天</template>
                                    </el-input>
                                    <div style="font-size: 11px; color: #909399; margin-top: 2px;">
                                        到期前N天发起扣款（0-3）
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="15">
                            <el-col :span="12">
                                <el-form-item label="失败重试次数" required>
                                    <el-input v-model="storePriceForm.retryTimes" type="number" :min="0" :max="7" size="small" style="width: 100%;">
                                        <template slot="append">次</template>
                                    </el-input>
                                    <div style="font-size: 11px; color: #909399; margin-top: 2px;">
                                        每天1次，全部失败后自动解约（0-7）
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <!-- 代扣明细 -->
                        <div style="margin-top: 10px;">
                            <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px;">
                                <span style="font-weight: bold; font-size: 13px;">代扣明细（共{{ storeDeductDetails.length }}期）</span>
                                <el-button size="mini" type="primary" @click="generateStoreDeductDetails">重新生成</el-button>
                            </div>
                            <el-table :data="storeDeductDetails" border size="mini" max-height="250" style="width: 100%;">
                                <el-table-column label="阶段" width="80" align="center">
                                    <template slot-scope="scope">第{{ scope.row.phase }}期</template>
                                </el-table-column>
                                <el-table-column prop="originalPrice" label="原价" align="center">
                                    <template slot-scope="scope">￥{{ scope.row.originalPrice }}</template>
                                </el-table-column>
                                <el-table-column label="优惠价" align="center">
                                    <template slot-scope="scope">
                                        <el-input
                                            v-model="scope.row.actualPrice"
                                            type="number"
                                            size="mini"
                                            style="width: 100px;"
                                            @change="onStoreDeductDetailPriceChange(scope.row)">
                                        </el-input>
                                    </template>
                                </el-table-column>
                                <el-table-column prop="saving" label="每期节省" align="center">
                                    <template slot-scope="scope">
                                        <span style="color: #67c23a;">省￥{{ scope.row.saving }}</span>
                                    </template>
                                </el-table-column>
                            </el-table>
                        </div>
                    </div>
                </el-form>
                <div slot="footer" class="dialog-footer" style="text-align: center; padding: 15px 0;">
                    <el-button size="small" @click="addStorePriceDialogVisible = false" style="margin-right: 10px;">取消</el-button>
                    <el-button type="primary" size="small" @click="saveStorePrice" v-permission="'btn:card:store:price:save'" :loading="storePriceLoading">确定</el-button>
                </div>
            </el-dialog>

            <!-- 🎯 关键功能：全局店铺价格管理弹窗 -->
            <el-dialog
                :title="'统一管理【' + globalStorePriceCardName + '】的店铺价格'"
                :visible.sync="globalStorePriceDialogVisible"
                width="60%"
                top="5vh"
                @close="closeGlobalStorePriceDialog">

                <div style="background: #fff7e6; border: 1px solid #ffd591; padding: 15px; margin-bottom: 20px; border-radius: 4px;">
                    <div style="display: flex; align-items: center; margin-bottom: 10px;">
                        <i class="el-icon-warning" style="color: #fa8c16; margin-right: 8px; font-size: 16px;"></i>
                        <span style="color: #fa8c16; font-weight: 500;">重要提示</span>
                    </div>
                    <div style="color: #8c5e00; font-size: 14px; line-height: 1.5;">
                        此操作将会同步修改该卡片在<strong>所有店铺</strong>的价格信息。<br>
                        <strong style="color: #f56c6c;">⚠️ 除价格外，其他字段不可修改！</strong><br>
                        请谨慎操作，确认无误后再提交。
                    </div>
                </div>

                <el-form :model="globalStorePriceForm" :rules="globalStorePriceFormRules" ref="globalStorePriceFormRef" label-width="120px">
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="统一价格" prop="price">
                                <el-input v-model="globalStorePriceForm.price" placeholder="请输入统一价格" type="number" @input="validateNumberInput('price', $event, 'global')">
                                    <template slot="append">元</template>
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="统一成本价">
                                <el-input v-model="globalStorePriceForm.costPrice" placeholder="成本价不可修改" type="number" :disabled="true">
                                    <template slot="append">元</template>
                                </el-input>
                                <div style="color: #909399; font-size: 12px; margin-top: 4px;">成本价不可修改</div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="有效天数">
                                <el-input v-model="globalStorePriceForm.days" placeholder="有效天数不可修改" type="number" :disabled="true">
                                    <template slot="append">天</template>
                                </el-input>
                                <div style="color: #909399; font-size: 12px; margin-top: 4px;">有效天数不可修改</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="排序权重">
                                <el-input v-model="globalStorePriceForm.sortOrder" placeholder="排序权重不可修改" type="number" :disabled="true">
                                </el-input>
                                <div style="color: #909399; font-size: 12px; margin-top: 4px;">排序权重不可修改</div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="限购类型">
                                <el-select v-model="globalStorePriceForm.purchaseLimitType" style="width: 100%;" :disabled="true">
                                    <el-option label="无限购" :value="0"></el-option>
                                    <el-option label="总量限购" :value="1"></el-option>
                                    <el-option label="个人限购" :value="2"></el-option>
                                    <el-option label="混合限购" :value="3"></el-option>
                                    <el-option label="总限购+个人限购" :value="4"></el-option>
                                </el-select>
                                <div style="color: #909399; font-size: 12px; margin-top: 4px;">限购类型不可修改</div>
                            </el-form-item>
                        </el-col>
                        <!-- <el-col :span="12">
                            <el-form-item label="限购周期">
                                <el-select v-model="globalStorePriceForm.limitPeriod" style="width: 100%;">
                                    <el-option label="永久" :value="1"></el-option>
                                    <el-option label="每日" :value="2"></el-option>
                                    <el-option label="每周" :value="3"></el-option>
                                    <el-option label="每月" :value="4"></el-option>
                                </el-select>
                            </el-form-item>
                        </el-col> -->
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="总限购数量">
                                <el-input v-model="globalStorePriceForm.totalLimit" placeholder="总限购数量不可修改" type="number" :disabled="true">
                                    <template slot="append">张</template>
                                </el-input>
                                <div style="color: #909399; font-size: 12px; margin-top: 4px;">总限购数量不可修改</div>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="个人限购数量">
                                <el-input v-model="globalStorePriceForm.personalLimit" placeholder="个人限购数量不可修改" type="number" :disabled="true">
                                    <template slot="append">张</template>
                                </el-input>
                                <div style="color: #909399; font-size: 12px; margin-top: 4px;">个人限购数量不可修改</div>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <!-- <el-col :span="12">
                            <el-form-item label="升级折扣">
                                <el-input v-model="globalStorePriceForm.upgradeDiscount" placeholder="升级折扣百分比" type="number" @input="validateNumberInput('upgradeDiscount', globalStorePriceForm.upgradeDiscount, 'global')">
                                    <template slot="append">%</template>
                                </el-input>
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="12">
                            <el-form-item label="是否启用">
                                <el-switch
                                    v-model="globalStorePriceForm.isActive"
                                    active-text="启用"
                                    inactive-text="禁用"
                                    :active-value="1"
                                    :inactive-value="0">
                                </el-switch>
                            </el-form-item>
                        </el-col>
                    </el-row>
<!--
                    <el-row :gutter="20">
                        <el-col :span="12">
                            <el-form-item label="限购开始时间">
                                <el-date-picker
                                    v-model="globalStorePriceForm.limitStartTime"
                                    type="datetime"
                                    placeholder="选择限购开始时间"
                                    style="width: 100%;">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="限购结束时间">
                                <el-date-picker
                                    v-model="globalStorePriceForm.limitEndTime"
                                    type="datetime"
                                    placeholder="选择限购结束时间"
                                    style="width: 100%;">
                                </el-date-picker>
                            </el-form-item>
                        </el-col>
                    </el-row> -->

                    <el-row :gutter="20">
                        <!-- <el-col :span="12">
                            <el-form-item label="预售时间">
                                <el-date-picker
                                    v-model="globalStorePriceForm.presaleTime"
                                    type="datetime"
                                    placeholder="选择预售时间"
                                    style="width: 100%;">
                                </el-date-picker>
                            </el-form-item>
                        </el-col> -->
                        <el-col :span="12">
                            <!-- 空列 -->
                        </el-col>
                    </el-row>

                    <el-row :gutter="20" v-if="globalStorePriceForm.isAutoRenewal != 1">
                        <el-col :span="12">
                            <el-form-item label="抖音商品ID">
                                <el-input v-model="globalStorePriceForm.douyinId" placeholder="抖音平台商品ID">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="美团商品ID">
                                <el-input v-model="globalStorePriceForm.meituanId" placeholder="美团平台商品ID">
                                </el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="12">
                            <el-form-item label="高德商品ID">
                                <el-input v-model="globalStorePriceForm.gaodeId" placeholder="高德平台商品ID">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="限购规则说明">
                                <el-input v-model="globalStorePriceForm.limitDesc" placeholder="限购规则说明" type="textarea" :rows="2">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <el-row :gutter="20">
                        <el-col :span="24">
                            <el-form-item label="备注信息">
                                <el-input v-model="globalStorePriceForm.remark" placeholder="备注信息" type="textarea" :rows="2">
                                </el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <!-- 自动续费配置区域（非单店卡统一配置） -->
                    <div style="border: 1px solid #e8e8e8; border-radius: 8px; padding: 15px; margin-bottom: 15px; background: #fafafa;">
                        <div style="display: flex; align-items: center; margin-bottom: 10px;">
                            <span style="font-weight: bold; font-size: 14px; margin-right: 16px;">
                                <i class="el-icon-refresh"></i> 自动续费设置
                            </span>
                            <el-switch
                                v-model="globalStorePriceForm.isAutoRenewal"
                                active-text="启用"
                                inactive-text="关闭"
                                :active-value="1"
                                :inactive-value="0"
                                active-color="#13ce66"
                                disabled>
                            </el-switch>
                            <span style="font-size: 11px; color: #909399; margin-left: 8px;">（来自会员卡设置，不可修改）</span>
                        </div>
                        <div v-if="globalStorePriceForm.isAutoRenewal == 1">
                            <el-row :gutter="15">
                                <el-col :span="12">
                                    <el-form-item label="续费类型" required>
                                        <el-select v-model="globalStorePriceForm.renewalType" size="small" style="width: 100%;">
                                            <el-option
                                                v-for="item in autoRenewalTypes"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="扣款方式" required>
                                        <el-select v-model="globalStorePriceForm.deductMethod" size="small" style="width: 100%;">
                                            <el-option
                                                v-for="item in deductMethods"
                                                :key="item.value"
                                                :label="item.label"
                                                :value="item.value">
                                            </el-option>
                                        </el-select>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="15">
                                <el-col :span="12">
                                    <el-form-item label="扣费周期" required>
                                        <el-input v-model="globalStorePriceForm.deductCycle" type="number" :min="1" :max="36" size="small" style="width: 100%;" @change="generateGlobalDeductDetails">
                                            <template slot="append">期</template>
                                        </el-input>
                                        <div style="font-size: 11px; color: #909399; margin-top: 2px;">
                                            扣满自动解约，需重新签约（1-36）
                                        </div>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="提前扣款天数" required>
                                        <el-input v-model="globalStorePriceForm.advanceDeductDays" type="number" :min="0" :max="3" size="small" style="width: 100%;">
                                            <template slot="append">天</template>
                                        </el-input>
                                        <div style="font-size: 11px; color: #909399; margin-top: 2px;">
                                            到期前N天发起扣款（0-3）
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="15">
                                <el-col :span="12">
                                    <el-form-item label="失败重试次数" required>
                                        <el-input v-model="globalStorePriceForm.retryTimes" type="number" :min="0" :max="7" size="small" style="width: 100%;">
                                            <template slot="append">次</template>
                                        </el-input>
                                        <div style="font-size: 11px; color: #909399; margin-top: 2px;">
                                            每天1次，全部失败后自动解约（0-7）
                                        </div>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <!-- 代扣明细 -->
                            <div style="margin-top: 10px;">
                                <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 8px;">
                                    <span style="font-weight: bold; font-size: 13px;">代扣明细（共{{ globalDeductDetails.length }}期）</span>
                                    <el-button size="mini" type="primary" @click="generateGlobalDeductDetails">重新生成</el-button>
                                </div>
                                <el-table :data="globalDeductDetails" border size="mini" max-height="250" style="width: 100%;">
                                    <el-table-column prop="phase" label="阶段" min-width="80" align="center">
                                        <template slot-scope="scope">
                                            第{{ scope.row.phase }}期
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="originalPrice" label="原价" min-width="120" align="center">
                                        <template slot-scope="scope">
                                            ￥{{ scope.row.originalPrice }}
                                        </template>
                                    </el-table-column>
                                    <el-table-column label="优惠价" min-width="140" align="center">
                                        <template slot-scope="scope">
                                            <el-input
                                                v-model="scope.row.actualPrice"
                                                type="number"
                                                size="mini"
                                                style="width: 100px;"
                                                @change="onGlobalDeductDetailPriceChange(scope.row)">
                                            </el-input>
                                        </template>
                                    </el-table-column>
                                    <el-table-column prop="saving" label="每期节省" min-width="120" align="center">
                                        <template slot-scope="scope">
                                            <span style="color: #67c23a;">省￥{{ scope.row.saving }}</span>
                                        </template>
                                    </el-table-column>
                                </el-table>
                            </div>
                        </div>
                    </div>
                </el-form>

                <div slot="footer" class="dialog-footer" style="text-align: center; padding: 15px 0;">
                    <el-button size="medium" @click="globalStorePriceDialogVisible = false" style="margin-right: 10px;">取消</el-button>
                    <el-button type="danger" size="medium" @click="saveGlobalStorePrice" v-permission="'btn:card:global:store:price:save'" :loading="globalStorePriceLoading">
                        <i class="el-icon-warning" style="margin-right: 5px;"></i>
                        确认统一修改
                    </el-button>
                </div>
            </el-dialog>

        </el-card>
    </div>
</template>
<script>
export default {
    data() {

        return{
          validTimes: null,
            queryInfo: {
                cardname: '',
                cardclassid: '',
                cardScopeType: '',
                days: '',
                douyinid: '',
                meituanid: '',
                pageNum: 1,
                pageSize: 20
            },
            sign:false,
            total:0,
            list: [],
            addDialogVisible:false,
            editDialogVisible:false,
            // Loading状态控制
            addLoading: false,
            editLoading: false,
            priceLoading: false,
            activityLoading: false,
            renewalActivityLoading: false,
            upgradeActivityLoading: false,
            globalStorePriceLoading: false,
            storePriceLoading: false,
            batchPriceLoading: false,
            deletePriceLoading: false,
            addPriceLoading: false,
            showAddStorePriceLoading: false,
            addNormalActivityLoading: false,
            loadStorePricesLoading: false,
          addStoreSearchKeyword: null,
          addStoreList: [],
            addForm:{
                cardname:'',
                carddescribe:'',
                cardclassid:'',
                price:'',
                days:'',
                remark:'',
                douyinid:'',
                meituanid:'',
              startTime: null,
              endTime: null,
                // 新的卡片范围字段
                cardScopeType: 1, // 默认单店卡
                scopeDesc: '',
                scopeCities: [], // 城市通卡选择的城市列表
                scopeStores: [], // 自定义店铺组合选择的店铺列表
                isAutoRenewal: 0  // 是否自动续费：0-否，1-是
            },
             //编辑表单数据
             editForm:{
                id:'',
                cardname:'',
                cardclassid:'',
                carddescribe:'',
                price:'',
                days:'',
                remark:'',
                douyinid:'',
                meituanid:'',
                // 新的卡片范围字段
                cardScopeType: 1,
                scopeDesc: '',
                scopeCities: [],
                scopeStores: [],
                isAutoRenewal: 0
            },
            // 城市列表数据
            cityList: [
                '北京市', '上海市', '广州市', '深圳市', '杭州市', '南京市', '苏州市', '成都市',
                '重庆市', '武汉市', '西安市', '天津市', '青岛市', '大连市', '厦门市', '福州市',
                '郑州市', '长沙市', '沈阳市', '哈尔滨市', '长春市', '石家庄市', '太原市', '呼和浩特市',
                '济南市', '合肥市', '南昌市', '昆明市', '贵阳市', '兰州市', '银川市', '西宁市', '乌鲁木齐市'
            ],

            //添加表单验证规则
            addFormRules:{
                cardname:[
                    { required: true, message: '请输入会员卡名称', trigger: 'blur' }
                ],
                startTime:[],
                cardclassid:[
                    { required: true, message: '请选择会员卡类型', trigger: 'blur' }
                ],
                price:[
                    { required: true, message: '请输入会员卡价格', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (value && (isNaN(value) || parseFloat(value) < 0)) {
                                callback(new Error('价格必须是大于等于0的数字'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                days:[
                    { required: true, message: '请输入天数', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (value && (isNaN(value) || parseInt(value) <= 0)) {
                                callback(new Error('天数必须是大于0的正整数'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                cardScopeType:[
                    { required: true, message: '请选择卡片适用范围', trigger: 'change' }
                ],
                scopeDesc:[
                    { required: true, message: '请输入范围描述', trigger: 'blur' }
                ],
                scopeCities:[
                    {
                        validator: (rule, value, callback) => {
                            if (this.addForm.cardScopeType === 2 && (!value || value.length === 0)) {
                                callback(new Error('城市通卡必须选择至少一个城市'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'change'
                    }
                ],
                scopeStores:[
                    {
                        validator: (rule, value, callback) => {
                            if (this.addForm.cardScopeType === 4 && (!value || value.length === 0)) {
                                callback(new Error('自定义店铺组合必须选择至少一个店铺'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'change'
                    }
                ]
            },
            editFormRules:{
                cardname:[
                    { required: true, message: '请输入会员卡名称', trigger: 'blur' }
                ],
              startTime:[],
                cardclassid:[
                    { required: true, message: '请选择会员卡类型', trigger: 'blur' }
                ],
                price:[
                    { required: true, message: '请输入会员卡价格', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (value !== null && value !== undefined && value !== '') {
                                const numValue = parseFloat(value);
                                if (isNaN(numValue)) {
                                    callback(new Error('价格必须是有效数字'));
                                } else if (numValue < 0) {
                                    callback(new Error('价格不能为负数'));
                                } else {
                                    callback();
                                }
                            } else {
                                callback();
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                days:[
                    { required: true, message: '请输入天数', trigger: 'blur' }
                ]
            },
            classlist:[
                { id: 1, classname: '时间卡' },
                { id: 2, classname: '次卡' },
                { id: 3, classname: '体验卡' },
                { id: 4, classname: '学生卡' },
                { id: 5, classname: '女神卡' },
                { id: 6, classname: '店主卡' },
                { id: 7, classname: '私教卡' },
                { id: 9, classname: '早鸟卡' },
                { id: 8, classname: '其他' }
            ],
            // 价格管理相关数据
            priceDialogVisible: false,
            currentCardId: null,
            currentStoreId: null,
            currentCardClassId: null, // 当前卡片类型，用于体验卡限制判断
            currentCardPrice: null, // 当前卡片价格，用于活动直减验证
            cardPrices: [],
            storeList: [],
            priceForm: {
                cardId: '',
                storeId: '',
                price: '',
                originalPrice: '',
                isActive: 1,
                sortOrder: 0,
                remark: '',
                purchaseLimitType: 1,
                totalLimit: 0,
                soldCount: 0, // 已售数量
                personalLimit: 0,
                limitPeriod: 0,
                limitStartTime: null,
                limitEndTime: null,
                limitDesc: '',
                upgradeDiscount: 0,
                days: 0,
                useTimes: 0,
                douyinId: '',
                meituanId: '',
                gaodeId: '',
                storeDesc: '',
                presaleTime: null
            },
            priceFormRules: {
                cardId: [{ required: true, message: '卡片ID不能为空', trigger: 'blur' }],
                storeId: [{ required: true, message: '请选择店铺', trigger: 'change' }],
                price: [
                    { required: true, message: '请输入价格', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (!value || value === '') {
                                callback(new Error('请输入价格'))
                            } else if (isNaN(value) || parseFloat(value) <= 0) {
                                callback(new Error('价格必须大于0'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ]
            },
            // 活动管理相关数据
            activityDialogVisible: false,
            normalActivityDialogVisible: false,
            renewalActivityDialogVisible: false,
            upgradeActivityDialogVisible: false,
            currentStoreName: '',
            currentCardName: '',
            currentCard: null, // 当前卡片完整信息，含isAutoRenewal等字段
            currentCardScopeType: null, // 当前卡片的范围类型，用于价格编辑权限控制
            activityForm: {
                id: '',
                cardPriceId: '',
                activityName: '',
                activityDesc: '',
                activityType: 1, // 普通活动优惠类型：1-直减，2-折扣，3-满减，4-买N送N，5-限时特价
                activityCategory: 'normal', // 固定为普通活动
                discountAmount: 0,
                discountRate: 0,
                minAmount: 0,
                buyCount: 0,
                giftCount: 0,
                specialPrice: 0,
                targetCardId: null, // 升级活动目标卡片ID
                renewalType: null, // 续费活动优惠类型
                startTime: '',
                endTime: '',
                isLongTerm: 0,
                maxUseCount: 0,
                usedCount: 0,
                // maxPerUser: 0, // 移除活动限购字段
                minUserLevel: 0,
                status: 1,
                isShow: 1,
                priority: 0,
                auditStatus: 2,
                auditRemark: '',
                remark: ''
            },
            activityFormRules: {
                activityName: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
                activityType: [{ required: true, message: '请选择活动类型', trigger: 'change' }],
                startTime: [{ required: true, message: '请选择开始时间', trigger: 'change' }],
                endTime: [{ required: true, message: '请选择结束时间', trigger: 'change' }],
                discountAmount: [{
                    validator: (rule, value, callback) => {
                        // 直减活动验证
                        if (this.activityForm.activityType === 1) {
                            if (!value || value === '') {
                                callback(new Error('请输入直减金额'))
                            } else if (isNaN(value) || parseFloat(value) <= 0) {
                                callback(new Error('直减金额必须大于0'))
                            } else if (this.currentCardPrice && parseFloat(value) > this.currentCardPrice) {
                                callback(new Error(`直减金额不能高于卡片价格 ￥${this.currentCardPrice}`))
                            } else {
                                callback()
                            }
                        }
                        // 满减活动的减免金额验证
                        else if (this.activityForm.activityType === 3) {
                            if (!value || value === '') {
                                callback(new Error('请输入减免金额'))
                            } else if (isNaN(value) || parseFloat(value) <= 0) {
                                callback(new Error('减免金额必须大于0'))
                            } else {
                                callback()
                            }
                        }
                        else {
                            callback()
                        }
                    },
                    trigger: 'blur'
                }],
                discountRate: [{
                    validator: (rule, value, callback) => {
                        if (this.activityForm.activityType === 2) {
                            if (!value || value === '') {
                                callback(new Error('请输入折扣率'))
                            } else if (isNaN(value) || parseFloat(value) <= 0 || parseFloat(value) > 10) {
                                callback(new Error('折扣率必须在0.1-10之间'))
                            } else {
                                callback()
                            }
                        } else {
                            callback()
                        }
                    },
                    trigger: 'blur'
                }],
                targetCardId: [{
                    validator: (rule, value, callback) => {
                        if (this.activityForm.activityType === 6) {
                            if (!value) {
                                callback(new Error('请选择目标卡片'))
                            }
                        }
                        callback()
                    },
                    trigger: 'change'
                }],
                renewalType: [{
                    validator: (rule, value, callback) => {
                        if (this.activityForm.activityType === 7) {
                            if (!value) {
                                callback(new Error('请选择续费优惠类型'))
                            }
                        }
                        callback()
                    },
                    trigger: 'change'
                }],
                minAmount: [{
                    validator: (rule, value, callback) => {
                        if (this.activityForm.activityType === 3) {
                            if (!value || value === '') {
                                callback(new Error('请输入最低消费金额'))
                            } else if (isNaN(value) || parseFloat(value) <= 0) {
                                callback(new Error('最低消费金额必须大于0'))
                            } else {
                                callback()
                            }
                        } else {
                            callback()
                        }
                    },
                    trigger: 'blur'
                }],
                specialPrice: [{
                    validator: (rule, value, callback) => {
                        if (this.activityForm.activityType === 5) {
                            if (!value || value === '') {
                                callback(new Error('请输入限时特价'))
                            } else if (isNaN(value) || parseFloat(value) <= 0) {
                                callback(new Error('限时特价必须大于0'))
                            } else {
                                callback()
                            }
                        } else {
                            callback()
                        }
                    },
                    trigger: 'blur'
                }],
                buyCount: [{
                    validator: (rule, value, callback) => {
                        if (this.activityForm.activityType === 4) {
                            if (!value || value === '') {
                                callback(new Error('请输入购买数量'))
                            } else if (isNaN(value) || !Number.isInteger(Number(value)) || parseInt(value) <= 0) {
                                callback(new Error('购买数量必须为正整数'))
                            } else {
                                callback()
                            }
                        } else {
                            callback()
                        }
                    },
                    trigger: 'blur'
                }],
                giftCount: [{
                    validator: (rule, value, callback) => {
                        if (this.activityForm.activityType === 4) {
                            if (!value || value === '') {
                                callback(new Error('请输入赠送数量'))
                            } else if (isNaN(value) || !Number.isInteger(Number(value)) || parseInt(value) <= 0) {
                                callback(new Error('赠送数量必须为正整数'))
                            } else {
                                callback()
                            }
                        } else {
                            callback()
                        }
                    },
                    trigger: 'blur'
                }]
            },
            // 活动管理相关数据
            activityTabActive: 'normal', // 活动标签页激活状态

            // 续费活动数据 (已移至computed属性)
            // renewalActivities: [], // 移除，避免与computed属性冲突
            renewalActivityForm: {
                id: '',
                activityName: '',
                activityDesc: '',
                cardPriceId: '',
                activityCategory: 'renewal', // 固定为续费活动
                renewalType: null, // 续费优惠类型：1-直减，2-折扣，3-满减
                discountAmount: 0,
                discountRate: 0,
                minAmount: 0,
                renewalCondition: 1, // 1-到期前续费，2-到期后续费，3-任意时间续费
                renewalDaysAdvance: 30, // 到期前多少天可以续费
                renewalDaysAfter: 90, // 到期后多少天可以续费
                startTime: '',
                endTime: '',
                isLongTerm: 0,
                maxUseCount: 0,
                usedCount: 0,
                // maxPerUser: 1, // 移除续费活动限购字段
                minUserLevel: 0,
                status: 1,
                isShow: 1,
                priority: 0,
                remark: ''
            },
            renewalActivityFormRules: {
                activityName: [
                    { required: true, message: '请输入续费活动名称', trigger: 'blur' },
                    { min: 2, max: 50, message: '活动名称长度在 2 到 50 个字符', trigger: 'blur' }
                ],
                renewalType: [
                    { required: true, message: '请选择续费优惠类型', trigger: 'change' }
                ],
                renewalCondition: [
                    { required: true, message: '请选择续费条件', trigger: 'change' }
                ],
                discountAmount: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.renewalActivityForm.renewalType === 1) {
                                if (!value || value === '') {
                                    callback(new Error('请输入直减金额'))
                                } else if (isNaN(value) || parseFloat(value) <= 0) {
                                    callback(new Error('直减金额必须大于0'))
                                } else if (this.currentCardPrice && parseFloat(value) > this.currentCardPrice) {
                                    callback(new Error(`直减金额不能超过卡片价格 ¥${this.currentCardPrice}`))
                                } else {
                                    callback()
                                }
                            } else if (this.renewalActivityForm.renewalType === 3) {
                                // 满减活动的减免金额验证
                                if (!value || value === '') {
                                    callback(new Error('请输入减免金额'))
                                } else if (isNaN(value) || parseFloat(value) <= 0) {
                                    callback(new Error('减免金额必须大于0'))
                                } else {
                                    callback()
                                }
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                discountRate: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.renewalActivityForm.renewalType === 2) {
                                if (!value || value === '') {
                                    callback(new Error('请输入折扣率'))
                                } else if (isNaN(value) || parseFloat(value) <= 0 || parseFloat(value) > 10) {
                                    callback(new Error('折扣率必须在0.1-10之间'))
                                } else {
                                    callback()
                                }
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                minAmount: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.renewalActivityForm.renewalType === 3) {
                                if (!value || value === '') {
                                    callback(new Error('请输入最低续费金额'))
                                } else if (isNaN(value) || parseFloat(value) <= 0) {
                                    callback(new Error('最低续费金额必须大于0'))
                                } else {
                                    callback()
                                }
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ]
            },
            // renewalActivityDialogVisible: false,

            upgradeActivities: [], // 升级活动列表
            // upgradeActivityDialogVisible: false, // 升级活动对话框显示状态
            availableSourceCards: [], // 可作为源卡片的列表
            availableTargetCards: [], // 可作为目标卡片的列表
            upgradeActivityForm: {
                id: '',
                activityName: '',
                activityDesc: '',
                activityCategory: 'upgrade', // 固定为升级活动
                sourceCardIds: [], // 源卡片ID数组
                targetCardId: '', // 目标卡片ID
                upgradePriceType: 1, // 升级价格类型：1-固定费用，2-差价+抵扣，3-目标卡折扣
                upgradeFixedPrice: 0, // 固定升级费用
                originalCardCreditRate: 50, // 原卡抵扣比例
                discountRate: 8.5, // 目标卡折扣率
                applicableStoreIds: [], // 适用店铺ID数组
                upgradeConditions: '', // 升级条件JSON
                startTime: '',
                endTime: '',
                status: 1, // 活动状态：1-启用，2-暂停，3-结束
                isShow: 1, // 是否显示：1-显示，0-隐藏
                remark: ''
            },
            upgradeActivityFormRules: {
                originalCardCreditRate: [{
                    validator: (rule, value, callback) => {
                        if (this.upgradeActivityForm.upgradePriceType === 2) {
                            if (!value || value < 0 || value > 100) {
                                callback(new Error('请输入正确的抵扣比例(0-100)'));
                                return;
                            }
                        }
                        callback();
                    },
                    trigger: 'blur'
                }],
                discountRate: [{
                    validator: (rule, value, callback) => {
                        if (this.upgradeActivityForm.upgradePriceType === 3) {
                            if (!value || value <= 0 || value > 10) {
                                callback(new Error('请输入正确的折扣率(0-10)'));
                                return;
                            }
                        }
                        callback();
                    },
                    trigger: 'blur'
                }]
            },

            // 批量价格设置
            batchPriceDialogVisible: false,
            selectedStores: [],
            boundStores: [], // 已绑定的店铺ID列表
            boundStoreDetails: [], // 已绑定店铺的详细信息
            batchPriceForm: {
                cardId: '',
                price: '',
                costPrice: '',
                isActive: 1, // 🔧 修复：使用Integer类型，1=启用，0=禁用
                isShow: 1, // 是否显示：1=显示，0=隐藏，默认显示
                sortOrder: '',
                remark: '',
                purchaseLimitType: 1,
                totalLimit: 0,
                soldCount: 0, // 已售数量
                personalLimit: 0,
                limitPeriod: 0,
                limitStartTime: null,
                limitEndTime: null,
                limitDesc: '',
                upgradeDiscount: 0,
                days: 0,
                useTimes: 0,
                douyinId: '',
                meituanId: '',
                gaodeId: '',
                storeDesc: '',
                presaleTime: null,
                // 自动续费相关
                isAutoRenewal: 0,
                renewalType: '',
                deductMethod: 'WX_AUTO_DEBIT',
                deductCycle: 1,
                advanceDeductDays: 1,
                retryTimes: 3
            },
            deductDetails: [], // 代扣明细列表
            storeDeductDetails: [], // 单店编辑代扣明细列表
            globalDeductDetails: [], // 全局店铺管理代扣明细列表
            autoRenewalTypes: [
                { value: 'MONTH', label: '连续包月' },
                { value: 'QUARTER', label: '连续包季' },
                { value: 'YEAR', label: '连续包年' }
            ],
            deductMethods: [
                { value: 'WX_AUTO_DEBIT', label: '微信委托代扣' }
            ],
            // 批量价格表单验证规则
            batchPriceFormRules: {
                price: [
                    { required: true, message: '请输入价格', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (!value || value === '') {
                                callback(new Error('请输入价格'))
                            } else if (isNaN(value) || parseFloat(value) <= 0) {
                                callback(new Error('价格必须大于0'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                costPrice: [
                    { required: true, message: '请输入成本价格', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (value && value !== '' && (isNaN(value) || parseFloat(value) <= 0)) {
                                callback(new Error('成本价必须大于0'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                days: [
                    {
                        validator: (rule, value, callback) => {
                            if (value && value !== '' && (isNaN(value) || !Number.isInteger(Number(value)) || parseInt(value) <= 0)) {
                                callback(new Error('有效期必须为正整数'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ]
            },
            // 店铺搜索和分页相关
            storeSearchKeyword: '',
            filteredStoreList: [],
            storeCurrentPage: 1,
            storePageSize: 20,
            totalStoreCount: 0,
            storeListLoading: false,
            // 店铺价格管理
            storePriceDialogVisible: false,
            storePriceList: [],
            filteredStorePriceList: [], // 过滤后的店铺价格列表
            storePriceSearchText: '', // 店铺价格搜索文本
            storePriceMDSearchText: '', // 店铺价格搜索文本(美团抖音)
          storePriceDaySearchText: '', // 店铺价格搜索文本(有效天数)
            // 店铺价格分页相关
            storePriceCurrentPage: 1, // 当前页码
            storePricePageSize: 10, // 每页显示数量
            storePriceForm: {
                id: '',
                cardId: '',
                storeId: '',
                storeName: '',
                price: '',
                costPrice: '',
                days: '',
                useTimes: '',
                douyinId: '',
                meituanId: '',
                gaodeId: '',
                storeDesc: '',
                purchaseLimitType: 0,
                totalLimit: 0,
                soldCount: 0, // 已售数量
                personalLimit: 0,
                upgradeDiscount: 0,
                isActive: 1,
                isShow: 1,
                presaleTime: '',
                remark: '',
                // 自动续费
                isAutoRenewal: 0,
                renewalType: '',
                deductMethod: 'WX_AUTO_DEBIT',
                deductCycle: 1,
                advanceDeductDays: 1,
                retryTimes: 3
            },
            storePriceFormRules: {
                storeId: [{ required: true, message: '请选择店铺', trigger: 'change' }],
                price: [
                    { required: true, message: '请输入价格', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (!value || value === '') {
                                callback(new Error('请输入价格'))
                            } else if (isNaN(value) || parseFloat(value) <= 0) {
                                callback(new Error('价格必须大于0'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                costPrice: [
                     { required: true, message: '请输入成本价', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (value && value !== '' && (isNaN(value) || parseFloat(value) <= 0)) {
                                callback(new Error('成本价必须大于0'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                days: [
                    {
                        validator: (rule, value, callback) => {
                            // 单店卡时间卡的有效天数为必填
                            if (this.currentCardScopeType == 1) {
                                if (!value || value === '') {
                                    callback(new Error('请输入有效天数'))
                                } else if (isNaN(value) || !Number.isInteger(Number(value)) || parseInt(value) <= 0) {
                                    callback(new Error('有效天数必须为正整数'))
                                } else {
                                    callback()
                                }
                            } else {
                                // 非单店卡可以为空，但如果有值则必须是正整数
                                if (value && value !== '' && (isNaN(value) || !Number.isInteger(Number(value)) || parseInt(value) <= 0)) {
                                    callback(new Error('有效天数必须为正整数'))
                                } else {
                                    callback()
                                }
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                useTimes: [
                    {
                        validator: (rule, value, callback) => {
                            if (this.currentCardClassId !== 2) {
                                callback()
                                return
                            }
                            if (this.currentCardScopeType == 1) {
                                if (!value || value === '') {
                                    callback(new Error('请输入可用次数'))
                                } else if (isNaN(value) || !Number.isInteger(Number(value)) || parseInt(value) <= 0) {
                                    callback(new Error('可用次数必须为正整数'))
                                } else {
                                    callback()
                                }
                            } else if (value && value !== '' && (isNaN(value) || !Number.isInteger(Number(value)) || parseInt(value) <= 0)) {
                                callback(new Error('可用次数必须为正整数'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                storeDesc: [
                    {
                        validator: (rule, value, callback) => {
                            if (value && value.length > 20) {
                                callback(new Error('店铺特定描述不能超过20个字符'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ]
            },
            // 店铺特定描述验证状态
            storeDescValidation: { valid: true, message: '' },
            addStorePriceDialogVisible: false,

            // 🎯 关键功能：全局店铺价格管理相关数据
            globalStorePriceDialogVisible: false,
            globalStorePriceCardId: null,
            globalStorePriceCardName: '',
            globalStorePriceForm: {
                price: '',
                costPrice: '',
                days: '',
                sortOrder: 0,
                purchaseLimitType: 1,
                limitPeriod: 0,
                totalLimit: 0,
                soldCount: 0, // 已售数量
                personalLimit: 0,
                upgradeDiscount: 0,
                isActive: 1,
                limitStartTime: null,
                limitEndTime: null,
                presaleTime: null,
                douyinId: '',
                meituanId: '',
                gaodeId: '',
                limitDesc: '',
                remark: '',
                isAutoRenewal: 0,
                renewalType: 'MONTH',
                deductMethod: 'WX_AUTO_DEBIT',
                deductCycle: 1,
                advanceDeductDays: 1,
                retryTimes: 3
            },
            globalStorePriceFormRules: {
                price: [
                    { required: true, message: '请输入统一价格', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (!value || value === '') {
                                callback(new Error('请输入统一价格'))
                            } else if (isNaN(value) || parseFloat(value) <= 0) {
                                callback(new Error('统一价格必须大于0'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                costPrice: [
                     { required: true, message: '请输入成本价', trigger: 'blur' },
                    {
                        validator: (rule, value, callback) => {
                            if (value && value !== '' && (isNaN(value) || parseFloat(value) <= 0)) {
                                callback(new Error('成本价必须大于0'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ],
                days: [
                    {
                        validator: (rule, value, callback) => {
                            if (value && value !== '' && (isNaN(value) || !Number.isInteger(Number(value)) || parseInt(value) <= 0)) {
                                callback(new Error('有效期必须为正整数'))
                            } else {
                                callback()
                            }
                        },
                        trigger: 'blur'
                    }
                ]
            },
          cardActivities: []
        }
    },
    created() {
        this.getList()
    },
    mounted(){
        this.addForm.admin_token = window.sessionStorage.getItem('admin_token')
        // 加载店铺列表，用于自定义店铺组合选择
        this.loadStoreListForScope()
    },
    computed: {
        // 计算分页后的店铺价格数据
        paginatedStorePriceList() {
            const start = (this.storePriceCurrentPage - 1) * this.storePricePageSize;
            const end = start + this.storePricePageSize;
            return this.filteredStorePriceList.slice(start, end);
        },
        // 判断当前卡片是否为体验卡
        isExperienceCard() {
            // 在添加卡片时检查addForm，在活动管理时检查currentCardClassId
            return this.addForm.cardclassid === 3 || this.editForm.cardclassid === 3 || this.currentCardClassId === 3;
        },
        batchRenewalUnit() {
            const map = { MONTH: '个月', QUARTER: '个季', YEAR: '个年' }
            return map[this.batchPriceForm.renewalType] || '个月'
        },
        // 判断店铺价格编辑时是否为体验卡
        isStoreEditExperienceCard() {
            // 在店铺价格管理中，通过currentCardClassId判断
            return this.currentCardClassId === 3;
        },
        // 过滤普通活动
        normalActivities() {
            return this.cardActivities.filter(activity =>
                activity.activityCategory === 'normal' ||
                activity.activityCategory === null ||
                activity.activityCategory === ''
            );
        },
        // 过滤续费活动
        renewalActivities() {
            return this.cardActivities.filter(activity =>
                activity.activityCategory === 'renewal'
            );
        },
        // 过滤升级活动
        // upgradeActivities() {
        //     return this.cardActivities.filter(activity =>
        //         activity.activityCategory === 'upgrade'
        //     );
        // }
    },
    watch: {
        selectedStores: {
            handler(newVal, oldVal) {
                console.log('selectedStores changed:', '新值:', newVal, '旧值:', oldVal);
            },
            deep: true
        }
    },
    methods:{
      formatDate(date) {
        if (typeof date == 'string') {
          date = new Date(date);
        }
        return (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ":"
        + (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes())
      },
        // ========== 字符串验证方法 ==========

        // 验证店铺特定描述
        validateStoreDesc() {
            const value = this.batchPriceForm.storeDesc;
            if (!value) {
                this.storeDescValidation = { valid: true, message: '' };
                return;
            }

            if (value.length > 20) {
                this.storeDescValidation = {
                    valid: false,
                    message: '店铺特定描述不能超过20个字符'
                };
            } else {
                this.storeDescValidation = { valid: true, message: '' };
            }
        },

        // ========== 整数验证方法 ==========

        parseUseTimesValue(value) {
            if (value === null || value === undefined || value === '') {
                return null
            }
            const parsed = parseInt(value, 10)
            return Number.isNaN(parsed) ? null : parsed
        },

        // 验证整数输入，只允许正整数
        validateIntegerInput(field, formName) {
            const form = this[formName];
            let value = form[field];

            // 如果输入为空，直接返回
            if (!value) return;

            // 转换为字符串处理
            value = String(value);

            // 移除所有非数字字符（包括小数点）
            value = value.replace(/[^\d]/g, '');

            // 如果结果为空字符串，设置为空
            if (value === '') {
                form[field] = '';
                return;
            }

            // 转换为整数
            const intValue = parseInt(value, 10);

            // 确保是正整数
            if (intValue > 0) {
                form[field] = intValue;
            } else {
                form[field] = '';
            }
        },

        // ========== 字符长度验证方法 ==========
        // 验证店铺特殊说明字符长度（价格表单）
        validatePriceFormStoreDesc(value) {
            if (value && value.length > 20) {
                this.$message.warning('店铺特殊说明不能超过16个字符');
                // 截取前16个字符
                this.priceForm.storeDesc = value.substring(0, 16);
            }
        },

        // ========== 限购类型控制方法 ==========

        // 判断限购类型选择器是否应该被禁用（批量设置）
        isPurchaseLimitTypeDisabled() {
            // 如果当前已经设置了限购类型（不是0-无限购），则禁用选择器
            // 只有当前是无限购（0）时才允许修改为其他类型
            return this.batchPriceForm.purchaseLimitType !== 0;
        },

        // 判断店铺价格限购类型选择器是否应该被禁用
        isStorePurchaseLimitTypeDisabled() {
            // 如果当前已经设置了限购类型（不是0-无限购），则禁用选择器
            // 只有当前是无限购（0）时才允许修改为其他类型
            return this.storePriceForm.purchaseLimitType !== 0;
        },

        // ========== 续费活动管理相关方法 ==========

        // 刷新续费活动列表
        async refreshRenewalActivities() {
            try {
                console.log('refreshRenewalActivities - currentCardId:', this.currentCardId);
                console.log('refreshRenewalActivities - currentStoreId:', this.currentStoreId);
                console.log('refreshRenewalActivities - currentCardPriceId:', this.currentCardPriceId);

                // 构建查询参数，严格过滤undefined和null值
                const params = [];

                // 优先使用 currentCardId 和 currentStoreId
                if (this.currentCardId !== undefined && this.currentCardId !== null) {
                    params.push(`cardId=${this.currentCardId}`);
                }
                if (this.currentStoreId !== undefined && this.currentStoreId !== null) {
                    params.push(`storeId=${this.currentStoreId}`);
                }

                // 如果没有cardId或storeId，尝试从当前cardPriceId获取
                if ((!this.currentCardId || !this.currentStoreId) && this.currentCardPriceId) {
                    console.log('refreshRenewalActivities - 尝试从cardPriceId获取参数');
                    const storePriceItem = this.storePriceList.find(item => item.id === this.currentCardPriceId);
                    if (storePriceItem) {
                        if (!this.currentCardId && storePriceItem.cardId) {
                            params.push(`cardId=${storePriceItem.cardId}`);
                            console.log('refreshRenewalActivities - 从storePriceItem获取cardId:', storePriceItem.cardId);
                        }
                        if (!this.currentStoreId && storePriceItem.storeId) {
                            params.push(`storeId=${storePriceItem.storeId}`);
                            console.log('refreshRenewalActivities - 从storePriceItem获取storeId:', storePriceItem.storeId);
                        }
                    }
                }

                let url = 'cardactivity/renewal';
                if (params.length > 0) {
                    url += '?' + params.join('&');
                }

                console.log('refreshRenewalActivities - 最终请求URL:', url);
                console.log('refreshRenewalActivities - 请求参数:', params);

                const { data: res } = await this.$http.get(url);
                if (res.status === 0) {
                    // 更新cardActivities数组中的续费活动数据
                    const renewalActivitiesData = (res.data || []).map(activity => ({
                        ...activity,
                        status: parseInt(activity.status) ?? 1,
                        isShow: parseInt(activity.isShow) || 0,
                        activityType: parseInt(activity.activityType) ?? 1,
                        renewalCondition: parseInt(activity.renewalCondition) ?? 1
                    }));

                    // 移除原有的续费活动，添加新的续费活动
                    this.cardActivities = this.cardActivities.filter(activity =>
                        activity.activityCategory !== 'renewal'
                    ).concat(renewalActivitiesData);

                    console.log('续费活动数据处理后:', renewalActivitiesData);
                    console.log('续费活动数量:', renewalActivitiesData.length);
                    // 移除成功提示，避免频繁弹窗
                    // if (this.renewalActivities.length > 0) {
                    //     this.$message.success(`续费活动列表刷新成功，共${this.renewalActivities.length}个活动`);
                    // } else {
                    //     this.$message.info('暂无续费活动');
                    // }
                } else {
                    this.$message.error(res.message || '获取续费活动列表失败');
                }
            } catch (error) {
                console.error('获取续费活动列表失败:', error);
                this.$message.error('获取续费活动列表失败');
            }
        },

        // 添加续费活动
        addRenewalActivity() {
            this.resetRenewalActivityForm();
            this.renewalActivityForm.cardPriceId = this.currentCardPriceId;
            this.renewalActivityDialogVisible = true;
        },

        // 编辑续费活动
        editRenewalActivity(activity) {
            // 根据activityType反推renewalType
            let renewalType = null;
            if (activity.activityType === 1) {
                renewalType = 1; // 直减
            } else if (activity.activityType === 2) {
                renewalType = 2; // 折扣
            } else if (activity.activityType === 3) {
                renewalType = 3; // 满减
            }

            this.renewalActivityForm = {
                id: activity.id,
                activityName: activity.activityName,
                activityDesc: activity.activityDesc,
                cardPriceId: activity.cardPriceId,
                activityType: activity.activityType,
                activityCategory: 'renewal',
                renewalType: renewalType, // 设置续费优惠类型
                discountAmount: activity.discountAmount || 0,
                discountRate: activity.discountRate || 0,
                minAmount: activity.minAmount || 0,
                buyCount: activity.buyCount || 0,
                giftCount: activity.giftCount || 0,
                specialPrice: activity.specialPrice || 0,
                renewalCondition: activity.renewalCondition || 1,
                renewalDaysAdvance: activity.renewalDaysAdvance || 30,
                renewalDaysAfter: activity.renewalDaysAfter || 90,
                startTime: activity.startTime,
                endTime: activity.endTime,
                isLongTerm: activity.isLongTerm !== undefined ? parseInt(activity.isLongTerm) : 0,
                maxUseCount: activity.maxUseCount || 0,
                usedCount: activity.usedCount || 0,
                // maxPerUser: activity.maxPerUser || 1, // 移除活动限购字段
                minUserLevel: activity.minUserLevel || 0,
                status: activity.status || 1,
                isShow: activity.isShow !== undefined ? activity.isShow : 1,
                priority: activity.priority || 0,
                remark: activity.remark || ''
            };

            console.log('编辑续费活动数据回显:', {
                activityType: activity.activityType,
                renewalType: renewalType,
                discountAmount: activity.discountAmount,
                discountRate: activity.discountRate,
                minAmount: activity.minAmount,
                isLongTerm: activity.isLongTerm,
                isLongTermParsed: parseInt(activity.isLongTerm)
            });

            this.renewalActivityDialogVisible = true;
        },

        // 保存续费活动
        async saveRenewalActivity() {
            this.renewalActivityLoading = true
            try {
                // 表单验证
                await this.$refs.renewalActivityFormRef.validate();

                // 准备提交数据
                const submitData = { ...this.renewalActivityForm };
                submitData.cardPriceId = this.currentCardPriceId;
                submitData.activityCategory = 'renewal';

                // 时间格式处理：确保时间格式为 yyyy-MM-dd HH:mm:ss
                if (submitData.startTime) {
                    submitData.startTime = this.formatDateTime(submitData.startTime);
                }
                if (submitData.endTime) {
                    submitData.endTime = this.formatDateTime(submitData.endTime);
                }

                // 验证时间范围：确保开始时间早于结束时间
                if (submitData.startTime && submitData.endTime) {
                    const startDate = new Date(submitData.startTime);
                    const endDate = new Date(submitData.endTime);
                    if (startDate >= endDate) {
                        this.$message.error('开始时间必须早于结束时间');
                        return;
                    }
                }

                // 根据renewalType映射activityType
                if (submitData.renewalType === 1) {
                    submitData.activityType = 1; // 直减
                } else if (submitData.renewalType === 2) {
                    submitData.activityType = 2; // 折扣
                } else if (submitData.renewalType === 3) {
                    submitData.activityType = 3; // 满减
                }

                // 验证activityType是否设置
                if (!submitData.activityType) {
                    this.$message.error('请选择续费优惠类型');
                    this.renewalActivityLoading = false;
                    return;
                }

                // 根据续费优惠类型验证必填字段
                if (submitData.renewalType === 1) {
                    // 直减金额验证
                    if (!submitData.discountAmount || submitData.discountAmount <= 0) {
                        this.$message.error('请输入正确的续费直减金额');
                        this.renewalActivityLoading = false;
                        return;
                    }
                    // 直减金额不能超过卡片价格
                    if (this.currentCardPrice && submitData.discountAmount > this.currentCardPrice) {
                        this.$message.error(`直减金额不能超过卡片价格 ¥${this.currentCardPrice}`);
                        this.renewalActivityLoading = false;
                        return;
                    }
                } else if (submitData.renewalType === 2) {
                    // 折扣率验证
                    if (!submitData.discountRate || submitData.discountRate <= 0 || submitData.discountRate >= 10) {
                        this.$message.error('请输入正确的续费折扣率(0-10)');
                        this.renewalActivityLoading = false;
                        return;
                    }
                } else if (submitData.renewalType === 3) {
                    // 满减验证
                    if (!submitData.minAmount || submitData.minAmount <= 0) {
                        this.$message.error('请输入正确的满减条件金额');
                        this.renewalActivityLoading = false;
                        return;
                    }
                    if (!submitData.discountAmount || submitData.discountAmount <= 0) {
                        this.$message.error('请输入正确的减免金额');
                        this.renewalActivityLoading = false;
                        return;
                    }
                    // 满减金额不能超过卡片价格
                    if (this.currentCardPrice && submitData.discountAmount > this.currentCardPrice) {
                        this.$message.error(`减免金额不能超过卡片价格 ¥${this.currentCardPrice}`);
                        this.renewalActivityLoading = false;
                        return;
                    }
                }

                // 时间验证
                if (!submitData.isLongTerm) {
                    if (!submitData.startTime || !submitData.endTime) {
                        this.$message.error('请选择活动开始和结束时间');
                        this.renewalActivityLoading = false;
                        return;
                    }
                    if (new Date(submitData.startTime) >= new Date(submitData.endTime)) {
                        this.$message.error('开始时间必须早于结束时间');
                        this.renewalActivityLoading = false;
                        return;
                    }
                }

                // 使用驼峰命名，符合Java Bean标准
                const backendData = {
                    activityName: submitData.activityName,
                    activityDesc: submitData.activityDesc || '',
                    cardPriceId: parseInt(submitData.cardPriceId),
                    activityType: parseInt(submitData.activityType),
                    discountAmount: parseFloat(submitData.discountAmount) || 0,
                    discountRate: parseFloat(submitData.discountRate) || 0,
                    minAmount: parseFloat(submitData.minAmount) || 0,
                    renewalCondition: parseInt(submitData.renewalCondition) || 1,
                    renewalDaysAdvance: parseInt(submitData.renewalDaysAdvance) || 30,
                    renewalDaysAfter: parseInt(submitData.renewalDaysAfter) || 90,
                    startTime: submitData.startTime || null,
                    endTime: submitData.endTime || null,
                    isLongTerm: parseInt(submitData.isLongTerm) || 0,
                    maxUseCount: parseInt(submitData.maxUseCount) || 0,
                    usedCount: parseInt(submitData.usedCount) || 0,
                    // maxPerUser: parseInt(submitData.maxPerUser) || 1, // 移除活动限购字段
                    minUserLevel: parseInt(submitData.minUserLevel) || 0,
                    status: parseInt(submitData.status) || 1,
                    isShow: parseInt(submitData.isShow) || 1,
                    priority: parseInt(submitData.priority) || 0,
                    remark: submitData.remark || ''
                };

                // 如果是更新操作，添加id字段
                if (submitData.id && submitData.id !== '') {
                    backendData.id = parseInt(submitData.id);
                }

                // 调试：打印发送的数据
                console.log('发送续费活动数据:', JSON.stringify(backendData, null, 2));

                let res;
                if (submitData.id) {
                    // 更新续费活动
                    res = await this.$http.post('cardactivity/renewal/update', backendData);
                } else {
                    // 添加续费活动
                    res = await this.$http.post('cardactivity/renewal/add', backendData);
                }

                if (res.data.status === 0) {
                    this.$message.success(submitData.id ? '更新续费活动成功' : '添加续费活动成功');
                    this.renewalActivityDialogVisible = false;
                    await this.refreshRenewalActivities();
                } else {
                    this.$message.error(res.data.message || '保存续费活动失败');
                }
            } catch (error) {
                if (error.message && error.message.includes('validate')) {
                    this.$message.error('请检查表单填写是否正确');
                } else {
                    console.error('保存续费活动失败:', error);
                    this.$message.error('保存续费活动失败');
                }
            } finally {
                this.renewalActivityLoading = false;
            }
        },

        // 删除续费活动
        async deleteRenewalActivity(activityId) {
            try {
                await this.$confirm('此操作将永久删除该续费活动, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                });

                const { data: res } = await this.$http.post('cardactivity/renewal/delete', { id: activityId });
                if (res.status === 0) {
                    this.$message.success('删除续费活动成功');
                    await this.refreshRenewalActivities();
                } else {
                    this.$message.error(res.message || '删除续费活动失败');
                }
            } catch (error) {
                if (error !== 'cancel') {
                    console.error('删除续费活动失败:', error);
                    this.$message.error('删除续费活动失败');
                }
            }
        },

        // 切换续费活动显示状态
        async toggleRenewalActivityShow(activity) {
            try {
                const { data: res } = await this.$http.post('cardactivity/renewal/toggle-show', {
                    id: activity.id,
                    isShow: activity.isShow
                });
                if (res.status === 0) {
                    this.$message.success('更新显示状态成功');
                } else {
                    this.$message.error(res.message || '更新显示状态失败');
                    // 回滚状态
                    activity.isShow = !activity.isShow;
                }
            } catch (error) {
                console.error('更新显示状态失败:', error);
                this.$message.error('更新显示状态失败');
                // 回滚状态
                activity.isShow = !activity.isShow;
            }
        },

        // 处理续费活动命令
        async handleRenewalActivityCommand(command) {
            if (command.action === 'status') {
                // 找到要更新的活动
                const activity = this.renewalActivities.find(item => item.id === command.id);
                if (!activity) {
                    this.$message.error('找不到要更新的活动');
                    return;
                }

                // 保存原始状态用于回滚
                const originalStatus = activity.status;

                try {
                    // 乐观更新：先更新UI
                    activity.status = command.status;

                    const { data: res } = await this.$http.post('cardactivity/renewal/update-status', {
                        id: command.id,
                        status: command.status
                    });
                    if (res.status === 0) {
                        this.$message.success('更新活动状态成功');
                        // 确保数据同步，重新加载列表
                        await this.refreshRenewalActivities();
                    } else {
                        // API失败，回滚UI状态
                        activity.status = originalStatus;
                        this.$message.error(res.message || '更新活动状态失败');
                    }
                } catch (error) {
                    // 网络错误，回滚UI状态
                    activity.status = originalStatus;
                    console.error('更新活动状态失败:', error);
                    this.$message.error('更新活动状态失败');
                }
            }
        },

        // 切换升级活动显示状态
        async toggleUpgradeActivityShow(activity) {
            try {
                const { data: res } = await this.$http.post('cardactivity/upgrade/toggle-show', {
                    id: activity.id,
                    isShow: activity.isShow
                });
                if (res.status === 0) {
                    this.$message.success('更新显示状态成功');
                } else {
                    this.$message.error(res.message || '更新显示状态失败');
                    // 回滚状态
                    activity.isShow = !activity.isShow;
                }
            } catch (error) {
                console.error('更新显示状态失败:', error);
                this.$message.error('更新显示状态失败');
                // 回滚状态
                activity.isShow = !activity.isShow;
            }
        },

        // 处理升级活动命令
        async handleUpgradeActivityCommand(command) {
            const { action, activity } = command;
            let status;
            let statusText;

            switch (action) {
                case 'enable':
                    status = 1;
                    statusText = '启用';
                    break;
                case 'pause':
                    status = 2;
                    statusText = '暂停';
                    break;
                case 'end':
                    status = 3;
                    statusText = '结束';
                    break;
                default:
                    return;
            }

            try {
                const { data: res } = await this.$http.post('cardactivity/upgrade/update-status', {
                    id: activity.id,
                    status: status
                });
                if (res.status === 0) {
                    this.$message.success(`${statusText}活动成功`);
                    await this.refreshUpgradeActivities();
                } else {
                    this.$message.error(res.message || `${statusText}活动失败`);
                }
            } catch (error) {
                console.error(`${statusText}活动失败:`, error);
                this.$message.error(`${statusText}活动失败`);
            }
        },

        // 重置续费活动表单
        resetRenewalActivityForm() {
            this.renewalActivityForm = {
                id: '',
                activityName: '',
                activityDesc: '',
                cardPriceId: '',
                activityCategory: 'renewal', // 固定为续费活动
                renewalType: null, // 续费优惠类型
                discountAmount: 0,
                discountRate: 0,
                minAmount: 0,
                renewalCondition: 1,
                renewalDaysAdvance: 30,
                renewalDaysAfter: 90,
                startTime: '',
                endTime: '',
                isLongTerm: 0,
                maxUseCount: 0,
                usedCount: 0,
                // maxPerUser: 1, // 移除续费活动限购字段
                minUserLevel: 0,
                status: 1,
                isShow: 1,
                priority: 0,
                remark: ''
            };
            // 清除表单验证
            if (this.$refs.renewalActivityFormRef) {
                this.$refs.renewalActivityFormRef.clearValidate();
            }
        },

        // 续费优惠类型变化处理
        onRenewalTypeChange() {
            // 清空相关的价格字段
            this.renewalActivityForm.discountAmount = 0;
            this.renewalActivityForm.discountRate = 0;
            this.renewalActivityForm.minAmount = 0;
        },

        // ========== 升级活动管理相关方法 ==========

        // 刷新升级活动列表
        async refreshUpgradeActivities() {
            try {
                console.log('refreshUpgradeActivities - currentStoreId:', this.currentStoreId);

                // 构建请求URL，如果有storeId则传递
                let url = 'cardactivity/upgrade';
                if (this.currentStoreId) {
                    url += `?storeId=${this.currentStoreId}`;
                }

                console.log('refreshUpgradeActivities - 请求URL:', url);

                const { data: res } = await this.$http.get(url);
                if (res.status === 0) {
                    // 确保数据类型正确，特别是status字段
                    this.upgradeActivities = (res.data || []).map(activity => ({
                        ...activity,
                        status: parseInt(activity.status) ?? 1,
                        isShow: parseInt(activity.isShow) || 0,
                        activityType: parseInt(activity.activityType) ?? 1,
                        upgradePriceType: parseInt(activity.upgradePriceType) ?? 1,
                        targetCardId: parseInt(activity.targetCardId) || null
                    }));
                    console.log('升级活动数据处理后:', this.upgradeActivities);
                    console.log('升级活动列表刷新成功，共', this.upgradeActivities.length, '条记录');
                } else {
                    this.$message.error(res.message || '获取升级活动列表失败');
                }
            } catch (error) {
                console.error('获取升级活动列表失败:', error);
                this.$message.error('获取升级活动列表失败');
            }
        },

        // 添加升级活动
        async addUpgradeActivity() {
            console.log('=== addUpgradeActivity 开始 ===');
            console.log('初始 currentStoreId:', this.currentStoreId);
            console.log('upgradeActivities 数量:', this.upgradeActivities ? this.upgradeActivities.length : 0);
            console.log('storePriceList 数量:', this.storePriceList ? this.storePriceList.length : 0);

            // 确保有店铺上下文
            if (!this.currentStoreId) {
                console.log('currentStoreId 为空，尝试获取...');

                // 尝试从当前显示的升级活动列表中获取店铺ID
                if (this.upgradeActivities && this.upgradeActivities.length > 0) {
                    const firstActivity = this.upgradeActivities[0];
                    console.log('第一个升级活动:', firstActivity);
                    if (firstActivity.storeId) {
                        this.currentStoreId = firstActivity.storeId;
                        console.log('addUpgradeActivity - 从升级活动列表获取storeId:', this.currentStoreId);
                    }
                }

                // 如果还是没有，尝试从店铺价格列表获取
                if (!this.currentStoreId && this.storePriceList && this.storePriceList.length > 0) {
                    const firstStorePrice = this.storePriceList[0];
                    console.log('第一个店铺价格:', firstStorePrice);
                    if (firstStorePrice.storeId) {
                        this.currentStoreId = firstStorePrice.storeId;
                        console.log('addUpgradeActivity - 从店铺价格列表获取storeId:', this.currentStoreId);
                    }
                }

                // 如果仍然没有店铺ID，提示用户
                if (!this.currentStoreId) {
                    console.log('无法获取有效的storeId，提示用户');
                    this.$message.warning('请先选择一个店铺或从活动管理页面进入');
                    return;
                }
            }

            console.log('addUpgradeActivity - 最终使用storeId:', this.currentStoreId);
            console.log('storeId 类型:', typeof this.currentStoreId);

            // 重置表单
            this.resetUpgradeActivityForm();

            // 加载可用的源卡片和目标卡片
            await this.loadAvailableCards();

            // 显示对话框
            this.upgradeActivityDialogVisible = true;
            console.log('=== addUpgradeActivity 结束 ===');
        },

        // 编辑升级活动
        async editUpgradeActivity(activity) {
            console.log('=== editUpgradeActivity 开始 ===');
            console.log('编辑的活动:', activity);
            console.log('当前 currentStoreId:', this.currentStoreId);

            // 确保有店铺上下文（编辑时应该已经通过ManageActivities设置了currentStoreId）
            if (!this.currentStoreId) {
                console.warn('editUpgradeActivity - 缺少currentStoreId，尝试从活动数据获取');

                // 尝试从当前升级活动列表中获取店铺ID
                if (this.upgradeActivities && this.upgradeActivities.length > 0) {
                    const firstActivity = this.upgradeActivities[0];
                    if (firstActivity.storeId) {
                        this.currentStoreId = firstActivity.storeId;
                        console.log('editUpgradeActivity - 从升级活动列表获取storeId:', this.currentStoreId);
                    }
                }

                // 如果仍然没有，提示用户
                if (!this.currentStoreId) {
                    console.log('editUpgradeActivity - 无法获取有效的storeId');
                    this.$message.warning('请先选择一个店铺或从活动管理页面进入');
                    return;
                }
            }

            console.log('editUpgradeActivity - 使用storeId:', this.currentStoreId);

            // 加载可用的源卡片和目标卡片
            await this.loadAvailableCards();

            // 填充表单数据
            this.upgradeActivityForm = {
                id: activity.id,
                activityName: activity.activityName,
                activityDesc: activity.activityDesc,
                activityType: activity.activityType || 6, // 确保升级活动类型为6
                activityCategory: activity.activityCategory || 2, // 确保活动类别为升级活动
                sourceCardIds: activity.sourceCardIds ? JSON.parse(activity.sourceCardIds) : [],
                targetCardId: activity.targetCardId,
                upgradePriceType: activity.upgradePriceType,
                upgradeFixedPrice: activity.upgradeFixedPrice,
                originalCardCreditRate: activity.originalCardCreditRate,
                discountRate: activity.discountRate,
                applicableStoreIds: activity.applicableStoreIds ? JSON.parse(activity.applicableStoreIds) : [],
                upgradeConditions: activity.upgradeConditions || '',
                startTime: activity.startTime,
                endTime: activity.endTime,
                status: activity.status,
                isShow: activity.isShow !== undefined ? activity.isShow : 1, // 确保isShow字段存在
                remark: activity.remark || ''
            };

            // 显示对话框
            this.upgradeActivityDialogVisible = true;
            console.log('=== editUpgradeActivity 结束 ===');
        },

        // 删除升级活动
        async deleteUpgradeActivity(activityId) {
            try {
                await this.$confirm('此操作将永久删除该升级活动，是否继续？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                });

                const { data: res } = await this.$http.post('cardactivity/upgrade/delete', { id: activityId });
                if (res.status === 0) {
                    this.$message.success('删除升级活动成功');
                    await this.refreshUpgradeActivities();
                } else {
                    this.$message.error(res.message || '删除升级活动失败');
                }
            } catch (error) {
                if (error !== 'cancel') {
                    console.error('删除升级活动失败:', error);
                    this.$message.error('删除升级活动失败');
                }
            }
        },

        // 保存升级活动
        async saveUpgradeActivity() {
            this.upgradeActivityLoading = true
            try {
                // 表单验证
                await this.$refs.upgradeActivityFormRef.validate();

                // 准备提交数据
                const submitData = {
                    ...this.upgradeActivityForm,
                    activityCategory: 'upgrade', // 设置活动类别为升级活动
                    sourceCardIds: JSON.stringify(this.upgradeActivityForm.sourceCardIds),
                    applicableStoreIds: this.upgradeActivityForm.applicableStoreIds.length > 0
                        ? JSON.stringify(this.upgradeActivityForm.applicableStoreIds)
                        : null
                };

                // 时间格式处理：确保时间格式为 yyyy-MM-dd HH:mm:ss
                if (submitData.startTime) {
                    submitData.startTime = this.formatDateTime(submitData.startTime);
                }
                if (submitData.endTime) {
                    submitData.endTime = this.formatDateTime(submitData.endTime);
                }

                // 验证时间范围：确保开始时间早于结束时间
                if (submitData.startTime && submitData.endTime) {
                    const startDate = new Date(submitData.startTime);
                    const endDate = new Date(submitData.endTime);
                    if (startDate >= endDate) {
                        this.$message.error('开始时间必须早于结束时间');
                        return;
                    }
                }

                // 对于升级活动，cardPriceId应该设置为源卡片（当前卡片）对应的card_price.id
                console.log('=== 开始设置cardPriceId ===');
                console.log('currentCardId:', this.currentCardId);
                console.log('availableSourceCards:', this.availableSourceCards);

                if (this.currentCardId) {
                    // 从availableSourceCards中找到当前卡片，使用其card_price.id
                    const sourceCard = this.availableSourceCards.find(card => card.id === this.currentCardId);
                    console.log('找到的源卡片:', sourceCard);

                    if (sourceCard && sourceCard.cardPriceId) {
                        submitData.cardPriceId = sourceCard.cardPriceId;
                        console.log('saveUpgradeActivity - 成功设置cardPriceId:', sourceCard.cardPriceId);
                        console.log('=== cardPriceId设置完成，不需要额外API调用 ===');

                        // 验证升级价格是否合理
                        if (submitData.upgradePriceType === 1) { // 固定价格
                            if (submitData.upgradeFixedPrice <= 0) {
                                this.$message.error('请输入正确的固定升级价格');
                                return;
                            }
                            // 固定升级价格不能超过目标卡片价格
                            const targetCard = this.availableTargetCards.find(card => card.id === submitData.targetCardId);
                            if (targetCard && targetCard.price && submitData.upgradeFixedPrice > targetCard.price) {
                                this.$message.error(`固定升级价格不能超过目标卡片价格 ¥${targetCard.price}`);
                                return;
                            }
                        } else if (submitData.upgradePriceType === 3) { // 折扣率
                            if (!submitData.discountRate || submitData.discountRate <= 0 || submitData.discountRate > 10) {
                                this.$message.error('请输入正确的折扣率(0.1-10)');
                                return;
                            }
                        }
                    } else {
                        console.error('源卡片或cardPriceId缺失:', { sourceCard, cardPriceId: sourceCard?.cardPriceId });
                        this.$message.error('无法获取源卡片价格信息，请重新加载卡片数据');
                        return;
                    }
                } else {
                    console.error('currentCardId缺失');
                    this.$message.error('缺少源卡片信息');
                    return;
                }

                const isEdit = !!this.upgradeActivityForm.id;
                const endpoint = isEdit ? 'cardactivity/upgrade/update' : 'cardactivity/upgrade/add';

                const { data: res } = await this.$http.post(endpoint, submitData);
                if (res.status === 0) {
                    this.$message.success(isEdit ? '修改升级活动成功' : '添加升级活动成功');
                    this.upgradeActivityDialogVisible = false;
                    await this.refreshUpgradeActivities();
                } else {
                    this.$message.error(res.message || (isEdit ? '修改升级活动失败' : '添加升级活动失败'));
                }
            } catch (error) {
                if (error !== 'cancel') {
                    console.error('保存升级活动失败:', error);
                    this.$message.error('保存升级活动失败');
                }
            }
        },

        // 重置升级活动表单
        resetUpgradeActivityForm() {
            this.upgradeActivityForm = {
                id: '',
                activityName: '',
                activityDesc: '',
                activityCategory: 'upgrade', // 固定为升级活动
                sourceCardIds: [],
                targetCardId: '',
                upgradePriceType: 1,
                upgradeFixedPrice: 0,
                originalCardCreditRate: 50,
                discountRate: 8.5,
                applicableStoreIds: [],
                upgradeConditions: '',
                startTime: '',
                endTime: '',
                status: 1,
                isShow: 1, // 是否显示，默认为1（显示）
                remark: ''
            };

            if (this.$refs.upgradeActivityFormRef) {
                this.$refs.upgradeActivityFormRef.resetFields();
            }
        },

        // 加载可用的源卡片和目标卡片
        async loadAvailableCards() {
            try {
                // 检查是否有当前店铺ID
                if (!this.currentStoreId || this.currentStoreId === null || this.currentStoreId === undefined) {
                    console.warn('loadAvailableCards - 缺少有效的currentStoreId:', this.currentStoreId);
                    this.$message.warning('请先选择店铺');
                    return;
                }

                // 确保storeId是数字类型
                const storeId = parseInt(this.currentStoreId);
                if (isNaN(storeId) || storeId <= 0) {
                    console.warn('loadAvailableCards - currentStoreId不是有效数字:', this.currentStoreId);
                    this.$message.warning('店铺ID无效，请重新选择店铺');
                    return;
                }

                console.log('loadAvailableCards - 使用有效的storeId:', storeId);
                console.log('loadAvailableCards - 当前卡片ID:', this.currentCardId);

                // 从card_price表中加载该店铺下的所有卡片（包括源卡片和目标卡片）
                const { data: storeCardsRes } = await this.$http.get(`cardprice/store/${storeId}`);
                if (storeCardsRes.status === 0) {
                    const storeCards = (storeCardsRes.data || []).filter(cardPrice => {
                        // isActive可能是布尔值true或数字1，都表示启用状态
                        return cardPrice.isActive === true || cardPrice.isActive === 1;
                    }).map(cardPrice => ({
                        id: cardPrice.cardId,           // 卡片ID，用于前端选择
                        cardPriceId: cardPrice.id,      // card_price表的ID，用于后端存储
                        cardname: cardPrice.cardname,
                        cardclassid: cardPrice.cardclassid,
                        price: cardPrice.price,
                        storeName: cardPrice.storeName
                    }));

                    // 设置源卡片：从card_price表中找到当前卡片
                    if (this.currentCardId) {
                        const sourceCard = storeCards.find(card => card.id === this.currentCardId);
                        if (sourceCard) {
                            this.availableSourceCards = [sourceCard];
                            // 自动设置源卡片为当前卡片
                            this.upgradeActivityForm.sourceCardIds = [sourceCard.id];
                            console.log('loadAvailableCards - 源卡片设置为当前卡片:', sourceCard.cardname, 'cardPriceId:', sourceCard.cardPriceId);
                        } else {
                            this.availableSourceCards = [];
                            console.warn('loadAvailableCards - 在card_price表中未找到当前卡片:', this.currentCardId);
                        }
                    } else {
                        this.availableSourceCards = [];
                        console.warn('loadAvailableCards - 缺少当前卡片ID');
                    }

                    // 设置目标卡片：过滤掉当前卡片，只显示其他可升级的目标卡片
                    this.availableTargetCards = storeCards.filter(card => card.id !== this.currentCardId);
                    console.log('loadAvailableCards - 源卡片加载成功:', this.availableSourceCards.length);
                    console.log('loadAvailableCards - 目标卡片加载成功:', this.availableTargetCards.length);
                    console.log('loadAvailableCards - 源卡片数据:', this.availableSourceCards);
                    console.log('loadAvailableCards - 目标卡片数据:', this.availableTargetCards);
                } else {
                    this.availableTargetCards = [];
                    console.error('loadAvailableCards - 目标卡片加载失败:', storeCardsRes.message);
                }
            } catch (error) {
                console.error('加载可用卡片失败:', error);
                if (error.response && error.response.status === 400) {
                    this.$message.error('请求参数错误，请检查店铺ID是否正确');
                } else {
                    this.$message.error('加载可用卡片失败: ' + (error.message || '未知错误'));
                }
            }
        },

        // 源卡片选择变化处理
        onSourceCardsChange(selectedIds) {
            console.log('选择的源卡片:', selectedIds);
        },

        // 目标卡片选择变化处理
        onTargetCardChange(targetCardId) {
            console.log('选择的目标卡片:', targetCardId);
        },

        // 升级价格类型变化处理
        onUpgradePriceTypeChange(priceType) {
            // 根据价格类型重置相关字段
            if (priceType === 1) {
                this.upgradeActivityForm.originalCardCreditRate = 0;
                this.upgradeActivityForm.discountRate = 0;
            } else if (priceType === 2) {
                this.upgradeActivityForm.upgradeFixedPrice = 0;
                this.upgradeActivityForm.discountRate = 0;
                this.upgradeActivityForm.originalCardCreditRate = 50;
            } else if (priceType === 3) {
                this.upgradeActivityForm.upgradeFixedPrice = 0;
                this.upgradeActivityForm.originalCardCreditRate = 0;
                this.upgradeActivityForm.discountRate = 8.5;
            }
        },

        // 获取源卡片名称列表
        getSourceCardNames(sourceCardIds) {
            if (!sourceCardIds) return [];

            try {
                // 如果已经是数组，直接使用
                let cardIds = sourceCardIds;
                if (typeof sourceCardIds === 'string') {
                    cardIds = JSON.parse(sourceCardIds);
                }

                if (!Array.isArray(cardIds)) {
                    console.warn('源卡片ID不是数组格式:', sourceCardIds);
                    return [];
                }

                return cardIds.map(id => {
                    const card = this.availableSourceCards.find(c => c.id === parseInt(id));
                    return card ? card.cardname : `卡片${id}`;
                });
            } catch (error) {
                console.error('解析源卡片ID失败:', error, '原始数据:', sourceCardIds);
                return [];
            }
        },

        // 获取目标卡片名称
        getTargetCardName(targetCardId) {
            if (!targetCardId) return '未设置';

            const card = this.availableTargetCards.find(c => c.id === parseInt(targetCardId));
            return card ? card.cardname : `卡片${targetCardId}`;
        },

        // 获取适用店铺数量
        getApplicableStoreCount(applicableStoreIds) {
            if (!applicableStoreIds) return 0;

            try {
                const storeIds = JSON.parse(applicableStoreIds);
                return storeIds.length;
            } catch (error) {
                console.error('解析适用店铺ID失败:', error);
                return 0;
            }
        },

        // 获取范围类型文本
        getScopeTypeText(scopeType) {
            const typeMap = {
                1: '单店卡',
                2: '城市通卡',
                3: '全国通卡',
                4: '自定义店铺组合'
            };
            return typeMap[scopeType] || '未知';
        },

        // 获取范围类型标签类型
        getScopeTypeTagType(scopeType) {
            const typeMap = {
                1: 'success',
                2: 'warning',
                3: 'danger',
                4: 'info'
            };
            return typeMap[scopeType] || 'info';
        },

        getRenewalTypeLabel(type) {
            const typeMap = {
                'MONTH': '连续包月',
                'QUARTER': '连续包季',
                'YEAR': '连续包年'
            };
            return typeMap[type] || type || '连续包月';
        },

        getDeductMethodLabel(method) {
            const methodMap = {
                'WX_AUTO_DEBIT': '微信委托代扣'
            };
            return methodMap[method] || method || '微信委托代扣';
        },

        // 加载店铺列表用于范围选择
        async loadStoreListForScope() {
            try {
                // 使用正确的API接口和参数
                const { data: res } = await this.$http.get('storelist/', {
                    params: {
                        pagesize: 1000, // 设置足够大的页面大小
                        page: 1
                    }
                });

                // 根据实际API返回结构处理数据
                if (res.status === 1 && res.data && res.data.list) {
                    this.storeList = res.data.list.map(store => ({
                        id: store.id,
                        storename: store.storename || '未知店铺',
                        city: store.city || '',
                        county: store.county || ''
                    }));
                    this.addStoreList = [...this.storeList];

                    // 同时生成城市列表
                    const citySet = new Set();
                    this.storeList.forEach(store => {
                        if (store.city) {
                            citySet.add(store.city);
                        }
                    });
                    this.cityList = Array.from(citySet).sort();

                    console.log('加载店铺列表成功，共', this.storeList.length, '个店铺');
                } else {
                    console.error('加载店铺列表失败:', res.message || '未知错误');
                    this.storeList = [];
                    this.addStoreList = []
                    this.cityList = [];
                }
            } catch (error) {
                console.error('加载店铺列表失败:', error);
                this.storeList = [];
                this.cityList = [];
            }
        },

        async getList() {
           const { data: res } = await this.$http.get('cardlist/', { params: this.queryInfo })
           if (res.code === 0 || res.status === 0) {
                this.total = res.totalSize || 0
                this.list = res.data || []
                this.loadPriceConfigStats()
           }
        },
        handleSizeChange(newSize){
           this.queryInfo.pageSize = newSize
           this.getList()
       },
       handleCurrentChange(newPage){
           this.queryInfo.pageNum = newPage
           this.getList()
       },
       addDialogClosed(){
            this.$refs.addFormRef.resetFields()
            // 重置新的卡片范围字段
            this.addForm.cardScopeType = 1
            this.addForm.scopeDesc = ''
            this.addForm.scopeCities = []
            this.addForm.scopeStores = []
            this.addForm.isAutoRenewal = 0
       },
       ChangeCardClass(){
          this.validTimes = null
         this.addForm.startTime = null
         this.addForm.endTime = null
         this.addFormRules.startTime = []
            if(this.addForm.cardclassid == 3){
                // 体验卡默认为单店卡
                this.addForm.cardScopeType = 1
                this.addForm.scopeDesc = '仅限单个店铺使用'
                this.sign = true

                // 体验卡重置价格表单中的限制字段
                if(this.priceForm) {
                    this.priceForm.purchaseLimitType = 0 // 无限购
                    this.priceForm.totalLimit = 0
                    this.priceForm.personalLimit = 0
                    this.priceForm.upgradeDiscount = 0
                    this.priceForm.douyinId = ''
                    this.priceForm.meituanId = ''
                    this.priceForm.gaodeId = ''
                }
            }else{
              if (this.addForm.cardclassid == 9) {
                this.addFormRules.startTime = [
                  { required: true, message: '请选择有效时间', trigger: 'blur' }
                ]
              }
                this.sign = false
            }
       },

       // 卡片适用范围类型变化处理
       onScopeTypeChange(scopeType) {
           // 清空之前的选择
           this.addForm.scopeCities = []
           this.addForm.scopeStores = []
           this.addForm.scopeDesc = ''

           // 根据类型设置默认描述
           switch(scopeType) {
               case 1:
                   this.addForm.scopeDesc = '仅限单个店铺使用'
                   break
               case 2:
                   this.addForm.scopeDesc = '同城店铺通用'
                   break
               case 3:
                   this.addForm.scopeDesc = '全国店铺通用'
                   break
               case 4:
                   this.addForm.scopeDesc = '指定店铺组合使用'
                   break
           }
       },

       // 编辑表单的卡片适用范围类型变化处理
       onEditScopeTypeChange(scopeType) {
           // 清空之前的选择
           this.editForm.scopeCities = []
           this.editForm.scopeStores = []
           this.editForm.scopeDesc = ''

           // 根据类型设置默认描述
           switch(scopeType) {
               case 1:
                   this.editForm.scopeDesc = '仅限单个店铺使用'
                   break
               case 2:
                   this.editForm.scopeDesc = '同城店铺通用'
                   break
               case 3:
                   this.editForm.scopeDesc = '全国店铺通用'
                   break
               case 4:
                   this.editForm.scopeDesc = '指定店铺组合使用'
                   break
           }
       },

       async AddInfo(){
            this.addLoading = true
            try {
              this.$refs.addFormRef.validate( async valid=>{
                if (!valid) {
                    this.addLoading = false
                    return
                }

                // 处理新的卡片范围字段
                const submitData = { ...this.addForm }

                // 根据范围类型设置 scopeConfig 字段
                if (submitData.cardScopeType === 2 && submitData.scopeCities.length > 0) {
                    // 城市通卡：存储城市列表
                    submitData.scopeConfig = JSON.stringify({
                        type: 'cities',
                        data: submitData.scopeCities
                    })
                } else if (submitData.cardScopeType === 4 && submitData.scopeStores.length > 0) {
                    // 自定义店铺组合：存储店铺 ID 列表
                    submitData.scopeConfig = JSON.stringify({
                        type: 'stores',
                        data: submitData.scopeStores
                    })
                } else {
                    // 单店卡和全国通卡不需要特殊配置
                    submitData.scopeConfig = null
                }

                // 根据卡类型设置 istong 字段
                if (submitData.cardScopeType === 1) {
                    // 单店卡
                    submitData.istong = 0
                } else {
                    // 通卡或自定义组合
                    submitData.istong = 1
                }

                if (submitData.cardclassid === 3) {
                  submitData.days = 0
                }

                // 移除临时字段，避免传递到后端
                delete submitData.scopeCities
                delete submitData.scopeStores

                const { data:res } = await this.$http.post('cardadd/', submitData)
                this.addLoading = false
                if(res.status===0)
                {
                    this.$message.success('添加成功！')
                    this.addDialogVisible = false
                    this.getList()
                } else {
                  this.$message.error(res.message)
                }
              })
            } catch (error) {
                this.addLoading = false
                this.$message.error('添加会员卡失败')
            }
       },
      handleDeleteCard(row) {
        this.$confirm(`确定会员卡 ${row.cardname} 2月内无人购买并且团购信息已经对应删除或转移，进行移除后会员卡即刻开始无法使用？`, '确认移除', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
          try {
            const { data: res } = await this.$http.post('carddel/', {
              id: row.id
            })

            if (res.status === 0) {
              this.$message.success('移除成功')
              this.getList()
            } else {
              this.$message.error(res.message || '移除失败')
            }
          } catch (error) {
            console.error('移除会员卡失败:', error)
            this.$message.error('移除失败')
          }
        }).catch(() => {
          // 用户取消操作
        })
      },
       async ShowEditDialog(id) {
            this.EditInfo(id)
        },

        async EditInfo(id){
            const { data: res } = await this.$http.get('cardinfo/'+id)

            // 处理返回的数据，支持新的卡片范围字段
            this.editForm = {
                ...res,
                admin_token: window.sessionStorage.getItem('admin_token'),
                // 处理卡片范围类型
                cardScopeType: res.cardScopeType || 1,
                scopeDesc: res.scopeDesc || res.scope_desc || '',
                scopeCities: [],
                scopeStores: [],
                // 保存原始值，用于判断是否真的修改了范围类型
                originalCardScopeType: res.cardScopeType || 1,
                originalScopeConfig: res.scopeConfig || res.scope_config || null
            }

            // 解析 scope_config 字段
            if (res.scopeConfig || res.scope_config) {
                try {
                    const scopeConfig = JSON.parse(res.scopeConfig || res.scope_config)
                    if (scopeConfig.type === 'cities' && scopeConfig.data) {
                        this.editForm.scopeCities = scopeConfig.data
                    } else if (scopeConfig.type === 'stores' && scopeConfig.data) {
                        this.editForm.scopeStores = scopeConfig.data
                    }
                } catch (error) {
                    console.error('解析 scope_config 失败:', error)
                }
            }

            this.validTimes = null
            this.editFormRules.startTime = []
            if (res.cardclassid == 9) {
              this.editFormRules.startTime = [
                { required: true, message: '请选择有效时间', trigger: 'blur' }
              ]
              this.validTimes = [new Date(res.startTime), new Date(res.endTime)]
            }

            this.editDialogVisible = true
        },
       EditInfoSave(id){
           this.editLoading = true
           try {
           this.$refs.editFormRef.validate(async valid => {
                if (!valid) {
                    this.editLoading = false
                    return
                }

                // 处理新的卡片范围字段
                const submitData = { ...this.editForm }

                // 智能处理 scopeConfig 字段：只有在范围类型真的改变时才更新
                const scopeTypeChanged = submitData.cardScopeType !== submitData.originalCardScopeType;
                console.log('范围类型是否改变:', scopeTypeChanged, '原:', submitData.originalCardScopeType, '新:', submitData.cardScopeType);

                if (submitData.cardScopeType === 2) {
                    // 城市通卡：存储城市列表
                    if (submitData.scopeCities.length > 0) {
                        submitData.scopeConfig = JSON.stringify({
                            type: 'cities',
                            data: submitData.scopeCities
                        })
                    } else if (scopeTypeChanged) {
                        // 只有在类型改变时才清空配置
                        submitData.scopeConfig = null
                    }
                    // 如果类型没变且没有选择城市，保持原有配置
                } else if (submitData.cardScopeType === 4) {
                    // 自定义店铺组合：存储店铺 ID 列表
                    if (submitData.scopeStores.length > 0) {
                        submitData.scopeConfig = JSON.stringify({
                            type: 'stores',
                            data: submitData.scopeStores
                        })
                    } else if (scopeTypeChanged) {
                        // 只有在类型改变时才清空配置
                        submitData.scopeConfig = null
                    }
                    // 如果类型没变且没有选择店铺，保持原有配置
                } else {
                    // 单店卡和全国通卡
                    if (scopeTypeChanged) {
                        // 如果从其他类型切换到单店卡/全国通卡，清空配置
                        submitData.scopeConfig = null
                        console.log('从其他类型切换到单店卡/全国通卡，清空 scopeConfig');
                    } else {
                        // 如果类型没变，保持原有配置（包括null值）
                        submitData.scopeConfig = submitData.originalScopeConfig;
                        console.log('保留原有 scopeConfig 配置:', submitData.scopeConfig);
                    }
                }

                // 移除临时字段，避免传递到后端
                delete submitData.scopeCities
                delete submitData.scopeStores
                delete submitData.originalCardScopeType
                delete submitData.originalScopeConfig

             if (submitData.cardclassid === 3) {
               submitData.days = 0
             }

                console.log('提交到后端的完整数据:', JSON.stringify(submitData, null, 2));
                console.log('特别关注 scopeConfig 字段:', submitData.scopeConfig);

                const { data: res } = await this.$http.post('cardedit/' + id, submitData)
             this.editLoading = false
                if (res.status === 0) {
                    this.$message.success('修改成功')
                    this.editDialogVisible = false
                    this.getList()
                } else {
                  this.$message.error(res.message)
                }
            })
           } catch (error) {
               this.editLoading = false
               this.$message.error('修改会员卡失败')
           }
       },
       editDialogClosed(){
            this.$refs.editFormRef.resetFields()
            // 重置新的卡片范围字段
            this.editForm.cardScopeType = 1
            this.editForm.scopeDesc = ''
            this.editForm.scopeCities = []
            this.editForm.scopeStores = []
       },
       async DelInfo(id){
                const confirmResult = await this.$confirm('是否要删除此信息吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                    }).catch(err => err)

                    if (confirmResult !== 'confirm'){
                        return this.$message.info('已取消删除！')
                    }
                    const { data: res } = await this.$http.get('carddel/'+ id,{ params:{admin_token:this.addForm.admin_token} })

                    if (res.status === 0) {
                        this.$message({message: '删除成功！',type: 'success'})
                    }
                    this.getList()

       },

       // ========== 价格管理相关方法 ==========
       async ManagePrices(cardId) {
           console.log('ManagePrices - 传入的 cardId:', cardId)
            this.currentCardId = cardId
            console.log('ManagePrices - 设置后的 currentCardId:', this.currentCardId)
                        // 获取会员卡信息
             const cardInfo = this.list.find(item => item.id === cardId)
             this.currentCard = cardInfo || null
             this.currentCardName = cardInfo ? cardInfo.cardname : ''
             // 设置当前卡片的范围类型，用于价格编辑权限控制
             this.currentCardScopeType = cardInfo ? cardInfo.cardScopeType : 1
             this.currentCardClassId = cardInfo ? cardInfo.cardclassid : null
             console.log('ManagePrices - cardInfo:', cardInfo)
             console.log('ManagePrices - cardInfo所有字段:', {
                 id: cardInfo?.id,
                 cardname: cardInfo?.cardname,
                 cardScopeType: cardInfo?.cardScopeType,
                 card_scope_type: cardInfo?.card_scope_type,
                 scopeType: cardInfo?.scopeType
             })
             console.log('ManagePrices - currentCardScopeType:', this.currentCardScopeType)

           // 获取店铺列表
           await this.getStoreList()

           // 获取该会员卡的价格配置
           await this.getCardPrices(cardId)

           this.priceDialogVisible = true
       },

       async getStoreList() {
            try {
                const { data: res } = await this.$http.get('storelist/')
                if (res.status === 0 || res.status === 1) {
                    this.storeList = res.data.list || res.data || []
                }
            } catch (error) {
                console.error('获取店铺列表失败:', error)
                this.$message.error('获取店铺列表失败')
            } finally {
                this.loadStorePricesLoading = false
            }
        },

        // 获取所有店铺数据（用于批量价格设置）
        async getAllStores() {
            try {
                const { data: res } = await this.$http.get('storelist/', {
                    params: {
                        pagesize: 1000, // 设置足够大的页面大小
                        page: 1
                    }
                });

                if (res.status === 1 && res.data && res.data.list) {
                    this.storeList = res.data.list.map(store => ({
                        id: store.id,
                        storename: store.storename || '未知店铺',
                        city: store.city || '',
                        county: store.county || ''
                    }));

                    // 初始化过滤后的店铺列表
                    this.filteredStoreList = [...this.storeList];
                    this.totalStoreCount = this.storeList.length;

                    console.log('批量设置价格 - 加载店铺列表成功，共', this.storeList.length, '个店铺');
                } else {
                    console.error('获取店铺列表失败:', res.message || '未知错误');
                    this.storeList = [];
                    this.filteredStoreList = [];
                    this.totalStoreCount = 0;
                    this.$message.error('获取店铺列表失败');
                }
            } catch (error) {
                console.error('获取店铺列表失败:', error);
                this.storeList = [];
                this.filteredStoreList = [];
                this.totalStoreCount = 0;
                this.$message.error('获取店铺列表失败');
            }
        },

        // ...

        async deletePrice(priceId) {
            this.deletePriceLoading = true
            try {
                const confirmResult = await this.$confirm('确定要删除此价格配置吗？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).catch(err => err)

                if (confirmResult !== 'confirm') {
                    return this.$message.info('已取消删除')
                }

                try {
                    const { data: res } = await this.$http.delete(`cardprice/${priceId}`)
                    if (res.status === 0) {
                        this.$message.success('删除成功')
                        await this.getCardPrices(this.currentCardId)
                    } else {
                        this.$message.error(res.message || '删除失败')
                    }
                } catch (error) {
                    console.error('删除价格配置失败:', error)
                    this.$message.error('删除价格配置失败')
                } finally {
                    this.deletePriceLoading = false
                }
            } catch (error) {
                this.deletePriceLoading = false
                this.$message.error('删除操作失败')
            }
        },

        // ...

        // 批量自动续费切换
        onBatchAutoRenewalToggle(val) {
            if (val == 1) {
                // 开启自动续费时清空抖音/美团ID
                this.batchPriceForm.douyinId = ''
                this.batchPriceForm.meituanId = ''
                this.batchPriceForm.gaodeId = ''
                // 自动生成代扣明细
                if (this.batchPriceForm.price) {
                    this.generateDeductDetails()
                }
            } else {
                this.deductDetails = []
            }
        },
        onBatchRenewalTypeChange() {
            this.generateDeductDetails()
        },
        onDeductCycleChange() {
            this.generateDeductDetails()
        },
        generateDeductDetails() {
            const cycle = parseInt(this.batchPriceForm.deductCycle) || 1
            const originalPrice = parseFloat(this.batchPriceForm.price) || 0
            const details = []
            for (let i = 1; i <= cycle; i++) {
                // 第一期优惠价默认设为价格的一半，后续期默认为原价
                const actualPrice = i === 1 ? parseFloat((originalPrice * 0.9).toFixed(2)) : originalPrice
                details.push({
                    phase: i,
                    originalPrice: originalPrice,
                    actualPrice: actualPrice,
                    saving: parseFloat((originalPrice - actualPrice).toFixed(2))
                })
            }
            this.deductDetails = details
        },
        onDeductDetailPriceChange(row) {
            row.actualPrice = parseFloat(row.actualPrice) || 0
            if (row.actualPrice > row.originalPrice) {
                this.$message.warning('优惠价不能大于原价')
                row.actualPrice = row.originalPrice
            }
            row.saving = parseFloat((row.originalPrice - row.actualPrice).toFixed(2))
        },
        // 单店编辑弹窗 - 自动续费相关方法
        onStoreRenewalTypeChange() {
            this.generateStoreDeductDetails()
        },
        onStoreDeductCycleChange() {
            this.generateStoreDeductDetails()
        },
        generateStoreDeductDetails() {
            const cycle = parseInt(this.storePriceForm.deductCycle) || 1
            const originalPrice = parseFloat(this.storePriceForm.price) || 0
            const details = []
            for (let i = 1; i <= cycle; i++) {
                const actualPrice = i === 1 ? parseFloat((originalPrice * 0.9).toFixed(2)) : originalPrice
                details.push({
                    phase: i,
                    originalPrice: originalPrice,
                    actualPrice: actualPrice,
                    saving: parseFloat((originalPrice - actualPrice).toFixed(2))
                })
            }
            this.storeDeductDetails = details
        },
        onStoreDeductDetailPriceChange(row) {
            row.actualPrice = parseFloat(row.actualPrice) || 0
            if (row.actualPrice > row.originalPrice) {
                this.$message.warning('优惠价不能大于原价')
                row.actualPrice = row.originalPrice
            }
            row.saving = parseFloat((row.originalPrice - row.actualPrice).toFixed(2))
        },

        // 全局店铺管理 - 代扣明细相关方法
        generateGlobalDeductDetails() {
            const cycle = parseInt(this.globalStorePriceForm.deductCycle) || 1
            const originalPrice = parseFloat(this.globalStorePriceForm.price) || 0
            const details = []
            for (let i = 1; i <= cycle; i++) {
                const actualPrice = i === 1 ? parseFloat((originalPrice * 0.9).toFixed(2)) : originalPrice
                details.push({
                    phase: i,
                    originalPrice: originalPrice,
                    actualPrice: actualPrice,
                    saving: parseFloat((originalPrice - actualPrice).toFixed(2))
                })
            }
            this.globalDeductDetails = details
        },
        onGlobalDeductDetailPriceChange(row) {
            row.actualPrice = parseFloat(row.actualPrice) || 0
            if (row.actualPrice > row.originalPrice) {
                this.$message.warning('优惠价不能大于原价')
                row.actualPrice = row.originalPrice
            }
            row.saving = parseFloat((row.originalPrice - row.actualPrice).toFixed(2))
        },

        async openBatchPriceDialog(cardId) {
            this.currentCardId = cardId

            // 获取当前卡片信息
            const currentCard = this.list.find(card => card.id === cardId)
            if (currentCard) {
                this.currentCardName = currentCard.cardname
                this.currentCardScopeType = currentCard.cardScopeType
                this.currentCardClassId = currentCard.cardclassid
            }

            // 重置绑定状态和用户选择的店铺
            this.selectedStores.splice(0, this.selectedStores.length)  // 强制清空数组，保持响应式
            this.boundStores = []
            this.boundStoreDetails = []
            console.log('打开批量价格对话框，已清空店铺选择')

            // 重置批量价格表单
            this.batchPriceForm = {
                cardId: cardId,
                price: '',
                costPrice: '',
                originalPrice: '',
                discountRate: '',
                totalLimit: '',
                personalLimit: '',
                days: '',
                useTimes: '',
                sortOrder: '', // 添加排序权重字段
                soldCount: 0,
                presaleTime: null,
                purchaseLimitType: 0,
                isActive: 1,
                isShow: 1,
                douyinId: '',
                meituanId: '',
                gaodeId: '',
                remark: '',
                storeDesc: '',
                totalLimitValidation: { valid: true, message: '' },
                personalLimitValidation: { valid: true, message: '' },
                // 自动续费（从会员卡数据同步，不可修改）
                isAutoRenewal: currentCard ? (currentCard.isAutoRenewal || 0) : 0,
                renewalType: '',
                deductMethod: 'WX_AUTO_DEBIT',
                deductCycle: 1,
                advanceDeductDays: 1,
                retryTimes: 3
            }
            this.deductDetails = []

            // 加载店铺列表
            await this.getAllStores()

            // 获取已绑定的店铺信息
            await this.getBoundStores(cardId)

            // 打开批量价格设置对话框
            this.batchPriceDialogVisible = true

            // 延迟检查选择状态，确保对话框完全打开后再验证
            this.$nextTick(() => {
                console.log('对话框打开后，selectedStores状态:', this.selectedStores)
                console.log('对话框打开后，selectedStores长度:', this.selectedStores.length)
            })
        },

        // 获取已绑定的店铺信息
        async getBoundStores(cardId) {
            try {
                const { data: res } = await this.$http.get(`cardprice/card/${cardId}`)
                if (res.status === 0 && res.data && res.data.length > 0) {
                    // 提取已绑定的店铺ID和详细信息
                    this.boundStores = res.data.map(item => item.storeId)
                    this.boundStoreDetails = res.data.map(item => {
                        // 从storeList中查找真实的店铺名称
                        const storeInfo = this.storeList.find(store => store.id === item.storeId)
                        return {
                            storeId: item.storeId,
                            storeName: storeInfo ? storeInfo.storename : (item.storeName || '未知店铺'),
                            price: item.price || 0
                        }
                    })

                    // 回显第一个店铺的价格数据到批量表单作为参考值
                    // 用户可以基于这些值进行修改，修改后的值将统一应用到所有店铺
                    const firstStorePrice = res.data[0]
                    if (firstStorePrice) {
                        this.batchPriceForm.price = firstStorePrice.price || ''
                        this.batchPriceForm.costPrice = firstStorePrice.costPrice || ''
                        this.batchPriceForm.originalPrice = firstStorePrice.originalPrice || ''
                        this.batchPriceForm.discountRate = firstStorePrice.discountRate || ''
                        this.batchPriceForm.totalLimit = firstStorePrice.totalLimit || ''
                        this.batchPriceForm.personalLimit = firstStorePrice.personalLimit || ''
                        this.batchPriceForm.days = firstStorePrice.days || ''
                        this.batchPriceForm.sortOrder = firstStorePrice.sortOrder || ''
                        this.batchPriceForm.soldCount = firstStorePrice.soldCount || 0
                        this.batchPriceForm.presaleTime = firstStorePrice.presaleTime || null
                        this.batchPriceForm.purchaseLimitType = firstStorePrice.purchaseLimitType || 0
                        this.batchPriceForm.isActive = firstStorePrice.isActive !== undefined ? firstStorePrice.isActive : 1
                        this.batchPriceForm.isShow = firstStorePrice.isShow !== undefined ? firstStorePrice.isShow : 1
                        this.batchPriceForm.douyinId = firstStorePrice.douyinId || ''
                        this.batchPriceForm.meituanId = firstStorePrice.meituanId || ''
                        this.batchPriceForm.gaodeId = firstStorePrice.gaodeId || ''
                        this.batchPriceForm.remark = firstStorePrice.remark || ''
                        this.batchPriceForm.storeDesc = firstStorePrice.storeDesc || ''

                        // 回显自动续费/代扣设置
                        if (firstStorePrice.isAutoRenewal == 1) {
                            this.batchPriceForm.renewalType = firstStorePrice.renewalType || ''
                            this.batchPriceForm.deductMethod = firstStorePrice.deductMethod || 'WX_AUTO_DEBIT'
                            this.batchPriceForm.deductCycle = firstStorePrice.deductCycle || 1
                            this.batchPriceForm.advanceDeductDays = firstStorePrice.advanceDeductDays == null ? 1 : firstStorePrice.advanceDeductDays
                            this.batchPriceForm.retryTimes = firstStorePrice.retryTimes == null ? 3 : firstStorePrice.retryTimes
                            this.deductDetails = firstStorePrice.deductDetails || []
                        }

                        console.log('DEBUG - 回显数据中的storeDesc:', firstStorePrice.storeDesc)
                        console.log('DEBUG - 设置到表单的storeDesc:', this.batchPriceForm.storeDesc)
                    }
                } else {
                    this.boundStores = []
                    this.boundStoreDetails = []

                    // 如果没有已绑定的店铺价格，保持表单为空，让用户输入新的价格
                    console.log('该卡片暂无店铺价格配置，批量设置表单保持空白状态')
                }
            } catch (error) {
                console.error('获取已绑定店铺失败:', error)
                this.boundStores = []
                this.boundStoreDetails = []
            }
        },

        // 显示店铺价格管理对话框
        async showStorePrices(cardId) {
            try {
                this.currentCardClassId = null
                this.currentCardId = cardId;
                // 获取卡片信息
                const cardInfo = this.list.find(card => card.id === cardId);
                this.currentCard = cardInfo || null
                if (cardInfo) {
                    this.currentCardName = cardInfo.cardname;
                    this.currentCardScopeType = cardInfo.cardScopeType;
                    this.currentCardClassId = cardInfo.cardclassid;
                }

                // 加载店铺价格列表
                await this.loadStorePrices();

                // 显示店铺价格管理对话框
                this.storePriceDialogVisible = true;
            } catch (error) {
                console.error('打开店铺价格管理失败:', error);
                this.$message.error('打开店铺价格管理失败');
            }
        },

        // 添加价格配置
        addPrice() {
            this.resetStorePriceForm()
            if (this.currentCard && this.currentCard.isAutoRenewal == 1) {
                this.storePriceForm.isAutoRenewal = 1
                this.storePriceForm.renewalType = this.currentCard.renewalType || ''
                this.storePriceForm.deductMethod = this.currentCard.deductMethod || 'WX_AUTO_DEBIT'
                this.storePriceForm.deductCycle = this.currentCard.deductCycle || 1
                this.storePriceForm.advanceDeductDays = this.currentCard.advanceDeductDays == null ? 1 : this.currentCard.advanceDeductDays
                this.storePriceForm.retryTimes = this.currentCard.retryTimes == null ? 3 : this.currentCard.retryTimes
                this.storeDeductDetails = this.currentCard.deductDetails || []
            }
            if (this.currentCardClassId === 3) {
                this.storePriceForm.days = 0
            }
            this.addStorePriceDialogVisible = true;
        },

        // 过滤店铺
        filterStores() {
            if (!this.storeSearchKeyword) {
                this.filteredStoreList = this.storeList;
            } else {
                this.filteredStoreList = this.storeList.filter(store =>
                    store.storename.toLowerCase().includes(this.storeSearchKeyword.toLowerCase())
                );
            }
        },

        // 过滤店铺
        filterAddStores() {
            if (!this.addStoreSearchKeyword) {
                this.addStoreList = [...this.storeList];
            } else {
                this.addStoreList = this.storeList.filter(store =>
                    store.storename.toLowerCase().includes(this.addStoreSearchKeyword.toLowerCase())
                );
            }
        },

        // 全选店铺
        selectAllStores() {
            // 选择所有未绑定的店铺ID
            this.selectedStores = this.filteredStoreList
                .filter(store => !this.boundStores.includes(store.id))
                .map(store => store.id);
        },

        // 清空选择的店铺
        clearAllStores() {
            this.selectedStores.splice(0, this.selectedStores.length);  // 强制清空数组，保持响应式
        },

        // 反选店铺
        reverseSelectStores() {
            const currentSelected = new Set(this.selectedStores);
            this.selectedStores = this.filteredStoreList
                .filter(store => !this.boundStores.includes(store.id))
                .filter(store => !currentSelected.has(store.id))
                .map(store => store.id);
        },

        // 切换店铺选择状态
        toggleStoreSelection(storeId) {
            // 检查是否为已绑定的店铺，已绑定的不允许取消选择
            if (this.boundStores.includes(storeId)) {
                return;
            }

            const index = this.selectedStores.indexOf(storeId);
            if (index > -1) {
                // 如果已选中，则取消选择
                this.selectedStores.splice(index, 1);
            } else {
                // 如果未选中，则添加到选择列表
                this.selectedStores.push(storeId);
            }
        },

        // 处理店铺项点击事件
        handleStoreItemClick(storeId, event) {
            // 如果点击的是checkbox或其子元素，不处理
            if (event.target.closest('.el-checkbox')) {
                return;
            }

            // 如果是已绑定的店铺，不允许操作
            if (this.boundStores.includes(storeId)) {
                return;
            }

            // 切换选择状态
            const index = this.selectedStores.indexOf(storeId);
            if (index > -1) {
                this.selectedStores.splice(index, 1);
            } else {
                this.selectedStores.push(storeId);
            }

            console.log('handleStoreItemClick:', storeId, '当前选择:', this.selectedStores);
        },

        // 获取店铺名称
        getStoreName(storeId) {
            const store = this.storeList.find(s => s.id === storeId);
            return store ? store.storename : '未知店铺';
        },

        // 移除已选店铺
        removeSelectedStore(storeId) {
            const index = this.selectedStores.indexOf(storeId);
            if (index > -1) {
                this.selectedStores.splice(index, 1);
            }
        },

        addNormalActivity() {
            this.addNormalActivityLoading = true
            try {
                // 调试信息
                console.log('addNormalActivity - currentCardId:', this.currentCardId);
                console.log('addNormalActivity - currentCardPriceId:', this.currentCardPriceId);
                console.log('addNormalActivity - currentStoreName:', this.currentStoreName);

                // 检查必要的参数
                if (!this.currentCardId || !this.currentCardPriceId) {
                    this.$message.error('缺少必要的卡片或价格信息，请重新选择');
                    this.addNormalActivityLoading = false;
                    return;
                }

                // 重置表单，保持完整的数据结构
                this.activityForm = {
                    id: '',
                    cardId: this.currentCardId,
                    cardPriceId: this.currentCardPriceId,
                    activityName: '',
                    activityDesc: '',
                    activityType: 1, // 普通活动优惠类型：1-直减，2-折扣，3-满减，4-买N送N，5-限时特价
                    activityCategory: 'normal', // 固定为普通活动
                    discountAmount: 0,
                    discountRate: 0,
                    minAmount: 0,
                    buyCount: 0,
                    giftCount: 0,
                    specialPrice: 0,
                    targetCardId: null, // 升级活动目标卡片ID
                    renewalType: null, // 续费活动优惠类型
                    startTime: '',
                    endTime: '',
                    isLongTerm: 0,
                    maxUseCount: 0,
                    usedCount: 0,
                    minUserLevel: 0,
                    status: 1,
                    isShow: 1,
                    priority: 0,
                    auditStatus: 2,
                    auditRemark: '',
                    remark: ''
                }

                console.log('addNormalActivity - activityForm.cardPriceId:', this.activityForm.cardPriceId);

                this.normalActivityDialogVisible = true
                this.addNormalActivityLoading = false
            } catch (error) {
                this.addNormalActivityLoading = false
                this.$message.error('打开添加活动对话框失败')
            }
        },

        // ...

        async saveStorePrice() {
            this.storePriceLoading = true
            try {
                this.$refs.storePriceFormRef.validate(async valid => {
                    if (!valid) {
                        this.storePriceLoading = false
                        return
                    }

                    // ...

                    // 检查 cardId 是否为空
                    if (!this.storePriceForm.cardId) {
                        console.error('saveStorePrice - cardId 为空！')
                        this.$message.error('卡片ID不能为空')
                        this.storePriceLoading = false
                        return
                    }

                    // 提交前进行价格和折扣率验证
                    const priceValidation = this.validatePriceAndDiscount('store')
                    if (!priceValidation.valid) {
                        this.$message.error(priceValidation.message)
                        this.storePriceLoading = false
                        return
                    }

                    // 提交前进行ID唯一性验证
                    if (this.storePriceForm.douyinId && this.storePriceForm.douyinId.trim() !== '') {
                        const douyinValid = await this.validateIdBeforeSubmit('douyin', 'store')
                        if (!douyinValid) {
                            this.$message.error('抖音商品ID已被其他店铺绑定，请修改后再提交')
                            this.storePriceLoading = false
                            return
                        }
                    }

                    if (this.storePriceForm.meituanId && this.storePriceForm.meituanId.trim() !== '') {
                        const meituanValid = await this.validateIdBeforeSubmit('meituan', 'store')
                        if (!meituanValid) {
                            this.$message.error('美团商品ID已被其他店铺绑定，请修改后再提交')
                            this.storePriceLoading = false
                            return
                        }
                    }

                    if (this.storePriceForm.gaodeId && this.storePriceForm.gaodeId.trim() !== '') {
                        const gaodeValid = await this.validateIdBeforeSubmit('gaode', 'store')
                        if (!gaodeValid) {
                            this.$message.error('高德商品ID已被其他店铺绑定，请修改后再提交')
                            this.storePriceLoading = false
                            return
                        }
                    }

                // 自动续费参数校验
                const autoRenewalValidation = this.validateAutoRenewal('store')
                if (!autoRenewalValidation.valid) {
                    this.storePriceLoading = false
                    return this.$message.error(autoRenewalValidation.message)
                }

                // 使用驼峰命名匹配后端CardPrice实体类
                const submitData = {
                    cardId: this.storePriceForm.cardId,
                    storeId: this.storePriceForm.storeId,
                    storeName: this.storePriceForm.storeName,
                    price: this.storePriceForm.price,
                    costPrice: this.storePriceForm.costPrice,
                    isActive: this.storePriceForm.isActive !== undefined ? this.storePriceForm.isActive : 1,
                    isShow: this.storePriceForm.isShow !== undefined ? this.storePriceForm.isShow : 1,
                    sortOrder: this.storePriceForm.sortOrder || 0,
                    remark: this.storePriceForm.remark || '',
                    purchaseLimitType: this.storePriceForm.purchaseLimitType,
                    totalLimit: this.storePriceForm.totalLimit,
                    soldCount: this.storePriceForm.soldCount || 0,
                    personalLimit: this.storePriceForm.personalLimit,
                    limitPeriod: this.storePriceForm.limitPeriod,
                    limitStartTime: this.storePriceForm.limitStartTime,
                    limitEndTime: this.storePriceForm.limitEndTime,
                    limitDesc: this.storePriceForm.limitDesc,
                    upgradeFromCards: this.storePriceForm.upgradeFromCards || null,
                    upgradeDiscount: this.storePriceForm.upgradeDiscount,
                    days: this.storePriceForm.days,
                    useTimes: this.parseUseTimesValue(this.storePriceForm.useTimes),
                    douyinId: this.storePriceForm.douyinId,
                    meituanId: this.storePriceForm.meituanId,
                    gaodeId: this.storePriceForm.gaodeId,
                    storeDesc: this.storePriceForm.storeDesc,
                    presaleTime: this.storePriceForm.presaleTime,
                    // 自动续费相关
                    isAutoRenewal: this.storePriceForm.isAutoRenewal,
                    renewalType: this.storePriceForm.renewalType,
                    deductMethod: this.storePriceForm.deductMethod,
                    deductCycle: this.storePriceForm.deductCycle,
                    advanceDeductDays: this.storePriceForm.advanceDeductDays,
                    retryTimes: this.storePriceForm.retryTimes,
                    deductDetails: this.storeDeductDetails
                }

                // 如果是编辑模式，添加 id
                if (this.storePriceForm.id) {
                    submitData.id = this.storePriceForm.id
                }

                console.log('saveStorePrice - 提交数据:', submitData)
                console.log('saveStorePrice - JSON.stringify:', JSON.stringify(submitData))

                    try {
                        const url = this.storePriceForm.id ? 'cardprice/update' : 'cardprice/add'
                        const response = await this.$http.post(url, submitData)
                        const res = response.data

                        if (res.status === 0) {
                            this.$message.success(this.storePriceForm.id ? '更新成功' : '添加成功')
                            this.addStorePriceDialogVisible = false
                            await this.loadStorePrices()
                            await this.getList() // 刷新主列表显示的价格配置状态
                        } else {
                            // 显示后端返回的错误信息
                            this.$message.error(res.msg || res.message || '保存失败')
                        }
                    } catch (error) {
                        console.error('保存店铺价格失败:', error)

                        // 处理HTTP错误响应（如500状态码）
                        if (error.response) {
                            // 服务器返回了错误响应
                            const errorData = error.response.data
                            console.log('错误响应数据:', errorData)

                            if (errorData && (errorData.msg || errorData.message)) {
                                this.$message.error(errorData.msg || errorData.message)
                            } else {
                                this.$message.error(`服务器错误 (${error.response.status})`)
                            }
                        } else if (error.request) {
                            // 请求已发送但没有收到响应
                            this.$message.error('网络错误，请检查网络连接')
                        } else {
                            // 其他错误
                            this.$message.error('操作失败：' + error.message)
                        }
                    } finally {
                        this.storePriceLoading = false
                    }
                })
            } catch (error) {
                this.storePriceLoading = false
                this.$message.error('保存失败')
            }
        },

        // 店铺选择变化时自动填充店铺名称
        onStoreChange(storeId) {
            if (storeId && this.storeList) {
                const selectedStore = this.storeList.find(store => store.id === storeId)
                if (selectedStore) {
                    this.storePriceForm.storeName = selectedStore.storename
                } else {
                    this.storePriceForm.storeName = ''
                }
            } else {
                this.storePriceForm.storeName = ''
            }
        },

        // 删除店铺价格
        async deleteStorePrice(id) {
           const confirmResult = await this.$confirm('确定要删除此店铺价格吗？', '提示', {
               confirmButtonText: '确定',
               cancelButtonText: '取消',
               type: 'warning'
           }).catch(err => err)

           if (confirmResult !== 'confirm') {
               return this.$message.info('已取消删除')
           }

           try {
               const { data: res } = await this.$http.post('cardprice/delete', { id })
               if (res.status === 0) {
                   this.$message.success('删除成功')
                   await this.loadStorePrices()
                   await this.getList() // 刷新主列表显示的价格配置状态
               } else {
                   this.$message.error(res.message || '删除失败')
               }
           } catch (error) {
               console.error('删除店铺价格失败:', error)
               this.$message.error('删除失败')
           }
       },

       // 切换店铺价格状态
        async toggleStorePriceStatus(row) {
            // el-switch 组件在触发 change 事件时，已经更新了 v-model 的值
            // 所以 row.isActive 已经是新的状态值
            const newStatus = row.isActive
            const statusText = newStatus === 1 ? '启用' : '禁用'

            try {
                const { data: res } = await this.$http.post('cardprice/toggle', {
                    id: row.id,
                    isActive: newStatus
                })

                if (res.status === 0) {
                    this.$message.success(`${statusText}成功`)
                    // 移除 loadStorePrices() 调用，保持当前页码不变
                } else {
                    this.$message.error(res.message || `${statusText}失败`)
                    // 如果操作失败，需要恢复开关状态
                    row.isActive = newStatus === 1 ? 0 : 1
                }
            } catch (error) {
                console.error(`${statusText}店铺价格失败:`, error)
                this.$message.error(`${statusText}失败`)
                // 如果操作失败，需要恢复开关状态
                row.isActive = newStatus === 1 ? 0 : 1
            }
        },

        // 切换店铺价格显示状态
        async toggleStorePriceShow(row) {
            // el-switch 组件在触发 change 事件时，已经更新了 v-model 的值
            // 所以 row.isShow 已经是新的状态值
            const newShowStatus = row.isShow
            const showText = newShowStatus === 1 ? '显示' : '隐藏'

            try {
                const { data: res } = await this.$http.post('cardprice/toggle-hide', {
                    id: row.id,
                    isShow: newShowStatus
                })

                if (res.status === 0) {
                    this.$message.success(`设置为${showText}成功`)
                    // 移除 loadStorePrices() 调用，保持当前页码不变
                } else {
                    this.$message.error(res.message || `设置为${showText}失败`)
                    // 如果操作失败，需要恢复开关状态
                    row.isShow = newShowStatus === 1 ? 0 : 1
                }
            } catch (error) {
                console.error(`设置为${showText}失败:`, error)
                this.$message.error(`设置为${showText}失败`)
                // 如果操作失败，需要恢复开关状态
                row.isShow = newShowStatus === 1 ? 0 : 1
            }
        },

       // 切换店铺价格隐藏状态
        async toggleStorePriceHideStatus(row) {
            // el-switch 组件在触发 change 事件时，已经更新了 v-model 的值
            // 所以 row.isActive 已经是新的状态值
            const newStatus = row.isShow
            const statusText = newStatus === 0 ? '隐藏' : '显示'

            try {
                const { data: res } = await this.$http.post('cardprice/toggleHide', {
                    id: row.id,
                    isShow: newStatus
                })

                if (res.status === 0) {
                    this.$message.success(`${statusText}成功`)
                    await this.loadStorePrices()
                } else {
                    this.$message.error(res.message || `${statusText}失败`)
                    // 如果操作失败，需要恢复开关状态
                    row.isActive = newStatus === 1 ? 0 : 1
                }
            } catch (error) {
                console.error(`${statusText}店铺价格失败:`, error)
                this.$message.error(`${statusText}失败`)
                // 如果操作失败，需要恢复开关状态
                row.isActive = newStatus === 1 ? 0 : 1
            }
        },

       // ==================== 店铺价格分页相关方法 ====================

       // 处理每页显示数量变化
       handleStorePriceSizeChange(newSize) {
           this.storePricePageSize = newSize;
           this.storePriceCurrentPage = 1; // 重置到第一页
       },
       // 处理当前页码变化
       handleStorePriceCurrentChange(newPage) {
           this.storePriceCurrentPage = newPage;
       },

       // 重置分页到第一页（在搜索或刷新时调用）
       resetStorePricePagination() {
           this.storePriceCurrentPage = 1;
       },

       // 数字输入验证
       validateNumberInput(field, value, formType = 'batch') {
           // 确保 value是字符串
           const inputValue = String(value || '');

           // 移除非数字字符，保留数字、小数点和负号（仅在开头）
           let numericValue = inputValue.replace(/[^0-9.-]/g, '');

           // 确保负号只能在开头
           if (numericValue.indexOf('-') > 0) {
               numericValue = numericValue.replace(/-/g, '');
           }

           // 防止多个小数点
           const parts = numericValue.split('.');
           let validValue = parts[0];
           if (parts.length > 1) {
               validValue += '.' + parts.slice(1).join('');
           }

           // 转换为数字进行验证（只在有值时验证）
           if (validValue && validValue !== '' && validValue !== '.') {
               const numValue = parseFloat(validValue);

               // 价格字段不能为负数
               if (['price', 'costPrice'].includes(field) && numValue < 0) {
                   this.$message.warning(`${field === 'price' ? '价格' : '成本价'}不能为负数`);
                   validValue = validValue.replace('-', '');
               }

               // 数量字段不能为负数（排序权重允许负数）
               if (['totalLimit', 'personalLimit', 'days', 'soldCount'].includes(field) && numValue < 0) {
                   const fieldNames = {
                       'totalLimit': '总限购数量',
                       'personalLimit': '个人限购数量',
                       'days': '有效天数',
                       'soldCount': '已售数量'
                   };
                   this.$message.warning(`${fieldNames[field]}不能为负数`);
                   validValue = '0';
               }

               // 排序权重字段特殊处理（允许负数，用于排序）
               if (field === 'sortOrder') {
                   // 排序权重允许负数，但限制范围 -9999 到 9999
                   if (numValue < -9999) {
                       this.$message.warning('排序权重不能小于-9999');
                       validValue = '-9999';
                   } else if (numValue > 9999) {
                       this.$message.warning('排序权重不能大于9999');
                       validValue = '9999';
                   }
               }

               // 总限购数量不能小于已售数量
               if (field === 'totalLimit') {
                   let soldCount = 0;
                   if (formType === 'store') {
                       soldCount = this.storePriceForm.soldCount || 0;
                   } else if (formType === 'batch') {
                       soldCount = this.batchPriceForm.soldCount || 0;
                   } else if (formType === 'global') {
                       soldCount = this.globalStorePriceForm.soldCount || 0;
                   } else if (formType === 'price') {
                       soldCount = this.priceForm.soldCount || 0;
                   }

                   if (numValue > 0 && numValue < soldCount) {
                       this.$message.warning(`总限购数量不能小于已售数量(${soldCount})`);
                       validValue = '';
                   }
               }

               // 升级折扣率限制（0.00-999.99）
               if (field === 'upgradeDiscount') {
                   if (numValue < 0) {
                       this.$message.warning('升级折扣率不能为负数');
                       validValue = '0';
                   } else if (numValue > 999.99) {
                       this.$message.warning('升级折扣率不能超过999.99');
                       validValue = '999.99';
                   }
               }
           }

           // 只在值发生变化时才更新表单字段值，避免干扰用户输入
           if (validValue !== inputValue) {
               if (formType === 'batch') {
                   this.batchPriceForm[field] = validValue;
               } else if (formType === 'store') {
                   this.storePriceForm[field] = validValue;
               } else if (formType === 'global') {
                   this.globalStorePriceForm[field] = validValue;
               } else if (formType === 'price') {
                   this.priceForm[field] = validValue;
               }
           }
       },

       // 校验抖音商品ID唯一性
       async checkDouyinIdUnique(formType) {
           const douyinId = formType === 'batch' ? this.batchPriceForm.douyinId : this.storePriceForm.douyinId;

           if (!douyinId || douyinId.trim() === '') {
               return;
           }

           try {
               // 获取店铺ID，批量设置时使用第一个选中的店铺
               let storeId;
               if (formType === 'batch') {
                   if (this.selectedStores.length === 0) {
                       this.$message.warning('请先选择店铺');
                       return;
                   }
                   storeId = this.selectedStores[0].id;
               } else {
                   storeId = this.storePriceForm.storeId;
               }

               if (!storeId) {
                   this.$message.warning('请先选择店铺');
                   return;
               }

               const { data: res } = await this.$http.get('cardprice/check-douyin-id', {
                   params: {
                       douyinId: douyinId.trim(),
                       storeId: storeId
                   }
               });

               if (res.status === 0 && res.data === true) {
                   this.$message.error(`抖音商品ID "${douyinId}" 已被其他店铺绑定，不允许重复绑定`);
                   // 清空输入框
                   if (formType === 'batch') {
                       this.batchPriceForm.douyinId = '';
                   } else {
                       this.storePriceForm.douyinId = '';
                   }
               }
           } catch (error) {
               console.error('校验抖音商品ID失败:', error);
               this.$message.error('校验抖音商品ID失败，请稍后重试');
           }
       },

       // 校验美团商品ID唯一性
       async checkMeituanIdUnique(formType) {
           const meituanId = formType === 'batch' ? this.batchPriceForm.meituanId : this.storePriceForm.meituanId;

           if (!meituanId || meituanId.trim() === '') {
               return;
           }

           try {
               // 获取店铺ID，批量设置时使用第一个选中的店铺
               let storeId;
               if (formType === 'batch') {
                   if (this.selectedStores.length === 0) {
                       this.$message.warning('请先选择店铺');
                       return;
                   }
                   storeId = this.selectedStores[0].id;
               } else {
                   storeId = this.storePriceForm.storeId;
               }

               if (!storeId) {
                   this.$message.warning('请先选择店铺');
                   return;
               }

               const { data: res } = await this.$http.get('cardprice/check-meituan-id', {
                   params: {
                       meituanId: meituanId.trim(),
                       storeId: storeId
                   }
               });

               if (res.status === 0 && res.data === true) {
                   this.$message.error(`美团商品ID "${meituanId}" 已被其他店铺绑定，不允许重复绑定`);
                   // 清空输入框
                   if (formType === 'batch') {
                       this.batchPriceForm.meituanId = '';
                   } else {
                       this.storePriceForm.meituanId = '';
                   }
               }
           } catch (error) {
               console.error('校验美团商品ID失败:', error);
               this.$message.error('校验美团商品ID失败，请稍后重试');
           }
       },

       // 校验高德商品ID唯一性
       async checkGaodeIdUnique(formType) {
           const gaodeId = formType === 'batch' ? this.batchPriceForm.gaodeId : this.storePriceForm.gaodeId;

           if (!gaodeId || gaodeId.trim() === '') {
               return;
           }

           try {
               // 获取店铺ID，批量设置时使用第一个选中的店铺
               let storeId;
               if (formType === 'batch') {
                   if (this.selectedStores.length === 0) {
                       this.$message.warning('请先选择店铺');
                       return;
                   }
                   storeId = this.selectedStores[0].id;
               } else {
                   storeId = this.storePriceForm.storeId;
               }

               if (!storeId) {
                   this.$message.warning('请先选择店铺');
                   return;
               }

               const { data: res } = await this.$http.get('cardprice/check-gaode-id', {
                   params: {
                       gaodeId: gaodeId.trim(),
                       storeId: storeId
                   }
               });

               if (res.status === 0 && res.data === true) {
                   this.$message.error(`高德商品ID "${gaodeId}" 已被其他店铺绑定，不允许重复绑定`);
                   // 清空输入框
                   if (formType === 'batch') {
                       this.batchPriceForm.gaodeId = '';
                   } else {
                       this.storePriceForm.gaodeId = '';
                   }
               }
           } catch (error) {
               console.error('校验高德商品ID失败:', error);
               this.$message.error('校验高德商品ID失败，请稍后重试');
           }
       },

       // 提交前的ID唯一性验证（返回true表示可以提交，false表示不可以提交）
       async validateIdBeforeSubmit(idType, formType) {
           try {
               const idMap = {
                   douyin: formType === 'batch' ? this.batchPriceForm.douyinId : this.storePriceForm.douyinId,
                   meituan: formType === 'batch' ? this.batchPriceForm.meituanId : this.storePriceForm.meituanId,
                   gaode: formType === 'batch' ? this.batchPriceForm.gaodeId : this.storePriceForm.gaodeId,
               };
               const id = idMap[idType];

               if (!id || id.trim() === '') {
                   return true; // 空值不需要验证
               }

               // 获取店铺ID
               let storeId;
               if (formType === 'batch') {
                   // 批量设置时，优先使用已绑定店铺，如果没有则使用选中店铺
                   if (this.boundStores.length > 0) {
                       storeId = this.boundStores[0];
                   } else if (this.selectedStores.length > 0) {
                       storeId = this.selectedStores[0];  // selectedStores是ID数组，不是对象数组
                   } else {
                       return false;
                   }
               } else {
                   storeId = this.storePriceForm.storeId;
               }

               if (!storeId) {
                   return false;
               }

               const endpointMap = {
                   douyin: 'cardprice/check-douyin-id',
                   meituan: 'cardprice/check-meituan-id',
                   gaode: 'cardprice/check-gaode-id',
               };
               const paramNameMap = {
                   douyin: 'douyinId',
                   meituan: 'meituanId',
                   gaode: 'gaodeId',
               };
               const endpoint = endpointMap[idType];
               const paramName = paramNameMap[idType];

               const { data: res } = await this.$http.get(endpoint, {
                   params: {
                       [paramName]: id.trim(),
                       storeId: storeId
                   }
               });

               // 返回true表示已存在（不可以提交），返回false表示不存在（可以提交）
               return !(res.status === 0 && res.data === true);
           } catch (error) {
               console.error(`提交前验证${idType}ID失败:`, error);
               // 验证失败时为了安全起见，不允许提交
               return false;
           }
       },

       // 价格和折扣率验证
       validatePriceAndDiscount(formType) {
           let form;
           if (formType === 'batch') {
               form = this.batchPriceForm;
           } else if (formType === 'global') {
               form = this.globalStorePriceForm;
           } else {
               form = this.storePriceForm;
           }

           // 验证价格不能为负数
           if (form.price && parseFloat(form.price) < 0) {
               return { valid: false, message: '价格不能为负数' };
           }

           // 验证成本价不能为负数
           if (form.costPrice && parseFloat(form.costPrice) < 0) {
               return { valid: false, message: '成本价不能为负数' };
           }

           // 验证数量字段不能为负数
           const quantityFields = {
               'totalLimit': '总限购数量',
               'personalLimit': '个人限购数量',
               'days': '有效天数',
               'soldCount': '已售数量'
           };

           for (const [fieldName, displayName] of Object.entries(quantityFields)) {
               if (form[fieldName] !== undefined && form[fieldName] !== null && form[fieldName] !== '') {
                   const value = parseFloat(form[fieldName]);
                   if (!isNaN(value) && value < 0) {
                       return { valid: false, message: `${displayName}不能为负数` };
                   }
               }
           }

           // 验证升级折扣率范围（0.00-999.99）
           if (form.upgradeDiscount !== undefined && form.upgradeDiscount !== null && form.upgradeDiscount !== '') {
               const discount = parseFloat(form.upgradeDiscount);
               if (isNaN(discount)) {
                   return { valid: false, message: '升级折扣率必须是数字' };
               }
               if (discount < 0) {
                   return { valid: false, message: '升级折扣率不能为负数' };
               }
               if (discount > 999.99) {
                   return { valid: false, message: '升级折扣率不能超过999.99' };
               }
           }

           return { valid: true, message: '' };
       },

       // 自动续费参数校验
       validateAutoRenewal(formType) {
           let form;
           if (formType === 'batch') {
               form = this.batchPriceForm;
           } else if (formType === 'global') {
               form = this.globalStorePriceForm;
           } else {
               form = this.storePriceForm;
           }

           if (form.isAutoRenewal != 1) {
               return { valid: true, message: '' };
           }

           const deductCycle = parseInt(form.deductCycle);
           if (isNaN(deductCycle) || deductCycle < 1 || deductCycle > 36) {
               return { valid: false, message: '扣费周期必须在1-36之间' };
           }

           const advanceDeductDays = parseInt(form.advanceDeductDays);
           if (isNaN(advanceDeductDays) || advanceDeductDays < 0 || advanceDeductDays > 3) {
               return { valid: false, message: '提前扣款天数必须在0-3之间' };
           }

           const retryTimes = parseInt(form.retryTimes);
           if (isNaN(retryTimes) || retryTimes < 0 || retryTimes > 7) {
               return { valid: false, message: '失败重试次数必须在0-7之间' };
           }

           if (!form.renewalType) {
               return { valid: false, message: '请选择续费类型' };
           }

           return { valid: true, message: '' };
       },

       // 🎯 关键方法：判断是否为非单店卡
       isNonSingleStoreCard(cardScopeType) {
           // cardScopeType: 1=单店卡, 2=城市通卡, 3=全国通卡, 4=店铺自定义卡
           return cardScopeType && cardScopeType !== 1;
       },

       // ==================== 全局店铺价格管理相关方法 ====================

       /**
        * 打开全局店铺价格管理弹窗
        * @param {Number} cardId 卡片ID
        */
       async openGlobalStorePriceDialog(cardId) {
           try {
               // 获取卡片信息
               const { data: cardInfo } = await this.$http.get(`cardinfo/${cardId}`);
               if (!cardInfo) {
                   this.$message.error('获取卡片信息失败');
                   return;
               }

               // 检查是否为非单店卡
               if (!this.isNonSingleStoreCard(cardInfo.cardScopeType)) {
                   this.$message.warning('只有非单店卡才可使用全局店铺价格管理功能');
                   return;
               }

               // 设置弹窗信息
               this.globalStorePriceCardId = cardId;
               this.globalStorePriceCardName = cardInfo.cardname || '未知卡片';

               // 从 card_info 获取默认值并填充表单
               this.globalStorePriceForm = {
                   price: cardInfo.price || '',
                   costPrice: '',
                   days: cardInfo.days || '',
                   sortOrder: 0,
                   purchaseLimitType: 0,
                   limitPeriod: 0,
                   totalLimit: 0,
                   personalLimit: 0,
                   upgradeDiscount: 0,
                   isActive: 1,
                   limitStartTime: null,
                   limitEndTime: null,
                   presaleTime: null,
                   douyinId: cardInfo.douyinid || '',
                   meituanId: cardInfo.meituanid || '',
                   gaodeId: cardInfo.gaodeid || '',
                   limitDesc: '',
                   remark: '',
                   isAutoRenewal: cardInfo.isAutoRenewal || 0,
                   renewalType: cardInfo.renewalType || 'MONTH',
                   deductMethod: cardInfo.deductMethod || 'WX_AUTO_DEBIT',
                   deductCycle: cardInfo.deductCycle || 1,
                   advanceDeductDays: cardInfo.advanceDeductDays == null ? 1 : cardInfo.advanceDeductDays,
                   retryTimes: cardInfo.retryTimes == null ? 3 : cardInfo.retryTimes
               };

               // 回显代扣明细
               this.globalDeductDetails = (cardInfo.deductDetails && cardInfo.deductDetails.length > 0)
                   ? JSON.parse(JSON.stringify(cardInfo.deductDetails))
                   : [];

               // 显示弹窗
               this.globalStorePriceDialogVisible = true;

               console.log('打开全局店铺价格管理弹窗: cardId=', cardId, 'cardName=', cardInfo.cardname);

           } catch (error) {
               console.error('打开全局店铺价格管理弹窗失败:', error);
               this.$message.error('打开全局店铺价格管理弹窗失败');
           }
       },

       /**
        * 关闭全局店铺价格管理弹窗
        */
       closeGlobalStorePriceDialog() {
           this.globalStorePriceDialogVisible = false;
           this.globalStorePriceCardId = null;
           this.globalStorePriceCardName = '';

           // 重置表单
           this.globalStorePriceForm = {
               price: '',
               costPrice: '',
               days: '',
               sortOrder: 0,
               purchaseLimitType: 0,
               limitPeriod: 0,
               totalLimit: 0,
               personalLimit: 0,
               upgradeDiscount: 0,
               isActive: 1,
               limitStartTime: null,
               limitEndTime: null,
               presaleTime: null,
               douyinId: '',
               meituanId: '',
               gaodeId: '',
               limitDesc: '',
               remark: '',
               isAutoRenewal: 0,
               renewalType: 'MONTH',
               deductMethod: 'WX_AUTO_DEBIT',
               deductCycle: 1,
               advanceDeductDays: 1,
               retryTimes: 3
           };

           // 重置代扣明细
           this.globalDeductDetails = [];

           // 清除表单验证
           if (this.$refs.globalStorePriceFormRef) {
               this.$refs.globalStorePriceFormRef.clearValidate();
           }
       },

       /**
        * 保存全局店铺价格设置
        */
       async saveGlobalStorePrice() {
           this.globalStorePriceLoading = true
           try {
               // 表单验证
               const valid = await new Promise(resolve => {
                   this.$refs.globalStorePriceFormRef.validate(resolve);
               });

               if (!valid) {
                   this.$message.error('请检查表单填写是否正确');
                   this.globalStorePriceLoading = false;
                   return;
               }

               // 价格验证
               const priceValidation = this.validatePriceAndDiscount('global');
               if (!priceValidation.valid) {
                   this.$message.error(priceValidation.message);
                   this.globalStorePriceLoading = false;
                   return;
               }

               // 自动续费参数校验
               const autoRenewalValidation = this.validateAutoRenewal('global');
               if (!autoRenewalValidation.valid) {
                   this.$message.error(autoRenewalValidation.message);
                   this.globalStorePriceLoading = false;
                   return;
               }

               // 二次确认
               try {
                   await this.$confirm(
                       `此操作将会同步修改【${this.globalStorePriceCardName}】在所有店铺的价格信息。\n\n请确认您要继续此操作？`,
                       '重要提示',
                       {
                           confirmButtonText: '确认修改',
                           cancelButtonText: '取消',
                           type: 'warning',
                           dangerouslyUseHTMLString: true
                       }
                   );
               } catch {
                   this.globalStorePriceLoading = false;
                   return; // 用户取消
               }

               try {
                   // 准备请求数据（含代扣明细），直接以 DTO 格式发送
                   const requestData = {
                       cardId: this.globalStorePriceCardId,
                       ...this.globalStorePriceForm
                   };
                   if (requestData.isAutoRenewal == 1 && this.globalDeductDetails.length > 0) {
                       requestData.deductDetails = this.globalDeductDetails.map(d => ({
                           phase: d.phase,
                           originalPrice: d.originalPrice,
                           actualPrice: d.actualPrice,
                           saving: d.saving
                       }));
                   }

                   console.log('全局店铺价格设置 - 请求数据:', requestData);

                   // 发送请求
                   const { data: res } = await this.$http.post('cardprice/globalupdate', requestData);

                   console.log('全局店铺价格设置 - 响应结果:', res);

                   if (res.status === 0) {
                       // 成功情况
                       const message = res.message || '全局店铺价格设置成功';

                       // 如果消息包含换行符，使用通知框显示详细信息
                       if (message.includes('\n')) {
                           this.$notify({
                               title: '全局修改结果',
                               message: message.replace(/\n/g, '<br>'),
                               type: 'success',
                               duration: 10000,
                               dangerouslyUseHTMLString: true,
                               position: 'top-right'
                           });
                       } else {
                           this.$message.success(message);
                       }

                       // 关闭弹窗
                       this.closeGlobalStorePriceDialog();

                       // 刷新列表
                       await this.getList();

                   } else {
                       // 失败情况
                       const message = res.message || '全局店铺价格设置失败';
                       this.$message.error(message);
                   }

               } catch (error) {
                   console.error('全局店铺价格设置失败:', error);

                   // 处理HTTP错误响应
                   if (error.response && error.response.data) {
                       const errorData = error.response.data;
                       const message = errorData.message || errorData.msg || '全局店铺价格设置失败';
                       this.$message.error(message);
                   } else {
                       this.$message.error('全局店铺价格设置失败，请稍后重试');
                   }
               } finally {
                   this.globalStorePriceLoading = false;
               }
           } catch (error) {
               this.globalStorePriceLoading = false;
               this.$message.error('统一修改失败');
           }
       },

       // ========== 活动管理相关方法 ==========
       async ManageActivities(cardId, cardPriceId, storeName) {
           this.currentCardId = cardId
           this.currentCardPriceId = cardPriceId
           this.currentStoreName = storeName

           // 打开活动管理对话框
           this.activityDialogVisible = true

           // 加载活动数据
           await this.getCardActivities(cardId, cardPriceId)
       },

       // 加载价格配置统计信息（优化版本）
       async loadPriceConfigStats() {
           try {
               // 批量获取所有卡片的价格配置统计
               const cardIds = this.list.map(card => card.id);
               if (cardIds.length === 0) {
                   return;
               }

               // 先设置loading状态，避免用户看到空白
               this.list.forEach(card => {
                   if (!card.hasOwnProperty('priceConfigCount')) {
                       this.$set(card, 'priceConfigCount', null); // null表示加载中
                       this.$set(card, 'priceRange', '');
                   }
               });

               const { data: res } = await this.$http.post('cardprice/stats', { cardIds });
               if (res.status === 0) {
                   // 使用Map提高查找效率
                   const statsMap = res.data;

                   // 批量更新数据，减少响应式更新次数
                   this.list.forEach(card => {
                       const stats = statsMap[card.id];
                       if (stats) {
                           this.$set(card, 'priceConfigCount', stats.count || 0);
                           if (stats.minPrice !== undefined && stats.maxPrice !== undefined) {
                               if (stats.minPrice === stats.maxPrice) {
                                   this.$set(card, 'priceRange', `¥${stats.minPrice}`);
                               } else {
                                   this.$set(card, 'priceRange', `¥${stats.minPrice} - ¥${stats.maxPrice}`);
                               }
                           } else {
                               this.$set(card, 'priceRange', '');
                           }
                       } else {
                           this.$set(card, 'priceConfigCount', 0);
                           this.$set(card, 'priceRange', '');
                       }
                   });
               }
           } catch (error) {
               console.error('加载价格配置统计失败:', error);
               // 设置默认值
               this.list.forEach(card => {
                   this.$set(card, 'priceConfigCount', 0);
                   this.$set(card, 'priceRange', '');
               });
           }
       },

       // 获取卡片活动数据
       async getCardActivities(cardId, cardPriceId) {
           try {
               // 从storePriceList中找到对应的storeId
               let storeId = null
               if (this.storePriceList && this.storePriceList.length > 0) {
                   const priceItem = this.storePriceList.find(item => item.id === cardPriceId)
                   if (priceItem) {
                       storeId = priceItem.storeId
                   }
               }

               // 构建请求参数，后端只接受cardId和storeId
               const params = {}

               // 如果找到了storeId，传递cardId和storeId
               if (storeId) {
                   params.storeId = storeId
                   params.cardId = cardId
               } else {
                   console.warn('无法找到对应的storeId，cardPriceId:', cardPriceId)
                   this.cardActivities = []
                   return
               }

               // 加载普通活动
               const { data: res } = await this.$http.get(`cardactivity/list`, {
                   params: params
               })
               if (res.status === 0) {
                   this.cardActivities = res.data || []
                   console.log('获取到的活动数据:', this.cardActivities)
                   console.log('续费活动数量:', this.renewalActivities.length)
                   console.log('普通活动数量:', this.normalActivities.length)
               } else {
                   this.cardActivities = []
                   console.error('获取卡片活动失败:', res.message)
               }
           } catch (error) {
               console.error('获取卡片活动失败:', error)
               this.cardActivities = []
           }
       },

       // 保存价格配置
       async savePrice() {
           this.priceLoading = true
           try {
               const valid = await new Promise(resolve => {
                   this.$refs.priceFormRef.validate(resolve);
               });
               if (!valid) {
                   this.priceLoading = false;
                   return;
               }

               const payload = {
                   ...this.priceForm,
                   useTimes: this.parseUseTimesValue(this.priceForm.useTimes)
               }
               const { data: res } = await this.$http.post('cardprice/add', payload)
               if (res.status === 0) {
                   this.$message.success('添加价格配置成功')
                   this.addPriceDialogVisible = false
                   await this.getCardPrices(this.currentCardId)
               } else {
                   this.$message.error(res.message || '添加价格配置失败')
               }
           } catch (error) {
               console.error('添加价格配置失败:', error)
               this.$message.error('添加价格配置失败')
           } finally {
               this.priceLoading = false
           }
       },

       // 重置价格表单
       resetPriceForm() {
           this.priceForm = {
               cardId: this.currentCardId,
               storeId: '',
               price: '',
               originalPrice: '',
               discountRate: '',
               totalLimit: '',
               personalLimit: '',
               presaleTime: null,
               remark: ''
           }
           if (this.$refs.priceFormRef) {
               this.$refs.priceFormRef.clearValidate()
           }
       },

       // 店铺分页处理
       handleStorePageChange(page) {
           this.storeCurrentPage = page
           this.loadStorePrices()
       },

        // 批量保存价格
        async saveBatchPrice() {
            this.batchPriceLoading = true
            try {
                // 验证选择的店铺 - 对于非单店卡，不需要验证店铺选择
                if (this.currentCardScopeType === 1 && (!this.selectedStores || this.selectedStores.length === 0)) {
                    this.batchPriceLoading = false
                    return this.$message.error('请至少选择一个店铺')
                }

                // 验证价格
                if (!this.batchPriceForm.price || parseFloat(this.batchPriceForm.price) <= 0) {
                    this.batchPriceLoading = false
                    return this.$message.error('请输入有效的价格')
                }

                if (this.currentCardClassId === 2) {
                    const useTimes = parseInt(this.batchPriceForm.useTimes)
                    if (!useTimes || useTimes <= 0) {
                        this.batchPriceLoading = false
                        return this.$message.error('次卡请输入有效的可用次数')
                    }
                }

                // 验证总限购数量不能小于已售出的总数量
                if (this.batchPriceForm.totalLimit && parseInt(this.batchPriceForm.totalLimit) > 0) {
                    const totalLimit = parseInt(this.batchPriceForm.totalLimit)
                    const soldCount = parseInt(this.batchPriceForm.soldCount) || 0

                    if (totalLimit < soldCount) {
                        this.batchPriceLoading = false
                        return this.$message.error(`总限购数量(${totalLimit})不能小于已售出数量(${soldCount})`)
                    }
                }

                // 自动续费参数校验
                const autoRenewalValidation = this.validateAutoRenewal('batch')
                if (!autoRenewalValidation.valid) {
                    this.batchPriceLoading = false
                    return this.$message.error(autoRenewalValidation.message)
                }

                // 构建请求数据 - 处理空字符串转换为null或默认值
                const requestData = {
                    cardId: this.batchPriceForm.cardId,
                    price: this.batchPriceForm.price || null,
                    costPrice: this.batchPriceForm.costPrice || null,
                    originalPrice: this.batchPriceForm.originalPrice || null,
                    discountRate: this.batchPriceForm.discountRate || null,
                    totalLimit: this.batchPriceForm.totalLimit || null,
                    personalLimit: this.batchPriceForm.personalLimit || null,
                    days: this.batchPriceForm.days || null,
                    useTimes: this.parseUseTimesValue(this.batchPriceForm.useTimes),
                    sortOrder: this.batchPriceForm.sortOrder || null,
                    presaleTime: this.batchPriceForm.presaleTime || null,
                    purchaseLimitType: this.batchPriceForm.purchaseLimitType || 0,
                    isActive: this.batchPriceForm.isActive !== undefined ? this.batchPriceForm.isActive : 1,
                    isShow: this.batchPriceForm.isShow !== undefined ? this.batchPriceForm.isShow : 1,
                    douyinId: this.batchPriceForm.douyinId || null,
                    meituanId: this.batchPriceForm.meituanId || null,
                    gaodeId: this.batchPriceForm.gaodeId || null,
                    remark: this.batchPriceForm.remark || null,
                    storeDesc: this.batchPriceForm.storeDesc || null,
                    // 自动续费
                    isAutoRenewal: this.batchPriceForm.isAutoRenewal || 0,
                    renewalType: this.batchPriceForm.renewalType || null,
                    deductMethod: this.batchPriceForm.deductMethod || null,
                    deductCycle: this.batchPriceForm.deductCycle || null,
                    advanceDeductDays: this.batchPriceForm.advanceDeductDays != null ? this.batchPriceForm.advanceDeductDays : 1,
                    retryTimes: this.batchPriceForm.retryTimes != null ? this.batchPriceForm.retryTimes : 3
                }

                // 代扣明细
                if (this.batchPriceForm.isAutoRenewal == 1 && this.deductDetails.length > 0) {
                    requestData.deductDetails = this.deductDetails.map(d => ({
                        phase: d.phase,
                        originalPrice: d.originalPrice,
                        actualPrice: d.actualPrice,
                        saving: d.saving
                    }))
                }

                // 使用用户选择的店铺ID
                console.log('DEBUG: selectedStores =', this.selectedStores);
                console.log('DEBUG: selectedStores.length =', this.selectedStores ? this.selectedStores.length : 'undefined');

                if (this.selectedStores && this.selectedStores.length > 0) {
                    // 使用用户选择的店铺
                    requestData.storeIds = this.selectedStores
                    requestData.applyToAllStores = false
                    console.log('使用用户选择的店铺:', this.selectedStores)
                } else {
                    // 如果没有选择店铺，根据卡片类型处理
                    if (this.currentCardScopeType === 1) {
                        // 单店卡必须选择店铺
                        this.batchPriceLoading = false
                        return this.$message.error('请选择要设置价格的店铺')
                    } else {
                        // 非单店卡：使用已绑定的店铺列表，如果没有则让后端根据卡片范围自动处理
                        if (this.boundStores && this.boundStores.length > 0) {
                            // 如果有已绑定的店铺，使用这些店铺ID
                            requestData.storeIds = this.boundStores
                            requestData.applyToAllStores = false
                            console.log('使用已绑定店铺列表:', this.boundStores)
                        } else {
                            // 如果没有已绑定店铺，让后端根据卡片范围自动获取
                            requestData.storeIds = []
                            requestData.applyToAllStores = true
                            console.log('让后端自动获取店铺列表，applyToAllStores=true')
                        }
                    }
                }

                // 确保参数有效 - 单店卡需要选择店铺，非单店卡使用applyToAllStores标记
                if (this.currentCardScopeType === 1 && (!requestData.storeIds || requestData.storeIds.length === 0)) {
                    this.batchPriceLoading = false
                    return this.$message.error('请选择要设置价格的店铺')
                }

                console.log('批量设置价格 - 请求数据:', JSON.stringify(requestData, null, 2))
                console.log('批量设置价格 - 店铺数量:', requestData.storeIds.length)
                console.log('批量设置价格 - currentCardScopeType:', this.currentCardScopeType)
                console.log('批量设置价格 - applyToAllStores:', requestData.applyToAllStores)
                console.log('批量设置价格 - storeDesc字段:', this.batchPriceForm.storeDesc)

                const { data: res } = await this.$http.post('cardprice/batchadd', requestData)
                if (res.status === 0) {
                    this.$message.success('批量设置价格成功')
                    this.batchPriceDialogVisible = false

                    // 清空用户选择的店铺，避免下次打开时显示缓存的选择
                    this.selectedStores.splice(0, this.selectedStores.length)  // 强制清空数组，保持响应式
                    console.log('批量设置价格成功，已清空店铺选择')

                    await this.getList()
                } else {
                    this.$message.error(res.message || '批量设置价格失败')
                }
            } catch (error) {
                console.error('批量设置价格失败:', error)
                this.$message.error('批量设置价格失败')
            } finally {
                this.batchPriceLoading = false
            }
        },

        // 批量价格对话框关闭事件
        onBatchPriceDialogClose() {
            // 清空用户选择的店铺，避免下次打开时显示缓存的选择
            this.selectedStores.splice(0, this.selectedStores.length)  // 强制清空数组，保持响应式
            // 重置验证状态
            this.storeDescValidation = { valid: true, message: '' }
            console.log('批量价格对话框关闭，已清空店铺选择')
        },

       // 重置活动表单
       resetActivityForm() {
           this.activityForm = {
               id: '',
               cardId: this.currentCardId,
               cardPriceId: this.currentCardPriceId,
               activityName: '',
               activityType: 1,
               discountValue: '',
               giftValue: '',
               startTime: '',
               endTime: '',
               remark: ''
           }
           // 重置loading状态
           this.activityLoading = false
           this.isEditMode = false
           if (this.$refs.activityFormRef) {
               this.$refs.activityFormRef.clearValidate()
           }
       },

       // 活动类型变化处理
       onActivityTypeChange(value) {
           // 重置相关字段
           this.activityForm.discountValue = ''
           this.activityForm.giftValue = ''

           // 清除验证
           if (this.$refs.activityFormRef) {
               this.$refs.activityFormRef.clearValidate(['discountValue', 'giftValue'])
           }
       },

       // 保存活动
       async saveActivity() {
           this.activityLoading = true
           try {
               const valid = await new Promise(resolve => {
                   this.$refs.activityFormRef.validate(resolve);
               });

               if (!valid) {
                   this.activityLoading = false;
                   return;
               }

               // 准备提交数据，确保cardPriceId正确设置
               console.log('saveActivity - 提交前检查:');
               console.log('saveActivity - this.currentCardId:', this.currentCardId);
               console.log('saveActivity - this.currentCardPriceId:', this.currentCardPriceId);
               console.log('saveActivity - this.activityForm.cardPriceId:', this.activityForm.cardPriceId);

               const submitData = {
                   ...this.activityForm,
                   cardId: this.currentCardId,
                   cardPriceId: this.currentCardPriceId,
                   // 确保isLongTerm是Integer类型
                   isLongTerm: this.activityForm.isLongTerm ? 1 : 0,
                   // 确保其他数值字段也是正确类型
                   activityType: parseInt(this.activityForm.activityType) || 1,
                   maxUseCount: parseInt(this.activityForm.maxUseCount) || 0,
                   usedCount: parseInt(this.activityForm.usedCount) || 0,
                   maxPerUser: parseInt(this.activityForm.maxPerUser) || 1,
                   minUserLevel: parseInt(this.activityForm.minUserLevel) || 0
               };

               console.log('saveActivity - submitData.cardPriceId:', submitData.cardPriceId);
               console.log('saveActivity - 完整的submitData:', submitData);

               // 如果是长期活动，设置开始时间为当前时间，结束时间为null
               if (submitData.isLongTerm === 1) {
                   submitData.startTime = this.formatDateTime(new Date());
                   submitData.endTime = null;
               } else {
                   // 非长期活动需要验证时间
                   if (!submitData.startTime || !submitData.endTime) {
                       this.$message.error('请选择活动开始和结束时间');
                       this.activityLoading = false;
                       return;
                   }
                   // 格式化时间
                   submitData.startTime = this.formatDateTime(submitData.startTime);
                   submitData.endTime = this.formatDateTime(submitData.endTime);
               }

               // 根据是否有ID判断是添加还是编辑
               const apiUrl = submitData.id ? 'cardactivity/update' : 'cardactivity/add';
               const { data: res } = await this.$http.post(apiUrl, submitData)
               if (res.status === 0) {
                   this.$message.success('保存活动成功')
                   this.normalActivityDialogVisible = false
                   await this.getCardActivities(this.currentCardId, this.currentCardPriceId)
               } else {
                   this.$message.error(res.message || '保存活动失败')
               }
           } catch (error) {
               console.error('saveActivity error:', error)
               this.$message.error('保存活动失败: ' + (error.message || error))
           } finally {
               this.activityLoading = false
           }
       },

       // 切换普通活动显示状态
       async toggleActivityShow(activity) {
           try {
               const { data: res } = await this.$http.post('cardactivity/update', {
                   id: activity.id,
                   isShow: activity.isShow
               });
               if (res.status === 0) {
                   this.$message.success('更新显示状态成功');
               } else {
                   this.$message.error(res.message || '更新显示状态失败');
                   // 回滚状态
                   activity.isShow = activity.isShow === 1 ? 0 : 1;
               }
           } catch (error) {
               console.error('更新显示状态失败:', error);
               this.$message.error('更新显示状态失败');
               // 回滚状态
               activity.isShow = activity.isShow === 1 ? 0 : 1;
           }
       },

       // 删除活动
       async deleteActivity(activityId) {
           try {
               await this.$confirm('确定要删除这个活动吗？', '提示', {
                   confirmButtonText: '确定',
                   cancelButtonText: '取消',
                   type: 'warning'
               });

               const { data: res } = await this.$http.post('cardactivity/delete', null, {
                   params: { id: activityId }
               });
               if (res.status === 0) {
                   this.$message.success('删除活动成功');
                   // 重新加载活动列表
                   await this.getCardActivities(this.currentCardId, this.currentCardPriceId);
               } else {
                   this.$message.error(res.message || '删除活动失败');
               }
           } catch (error) {
               if (error !== 'cancel') {
                   console.error('删除活动失败:', error);
                   this.$message.error('删除活动失败');
               }
           }
       },

       // 编辑普通活动
       editNormalActivity(activity) {
           // 复制活动数据到表单
           this.activityForm = {
               id: activity.id,
               activityName: activity.activityName,
               activityDesc: activity.activityDesc || '',
               activityType: activity.activityType,
               discountAmount: activity.discountAmount || 0,
               discountRate: activity.discountRate || 0,
               minAmount: activity.minAmount || 0,
               buyCount: activity.buyCount || 0,
               giftCount: activity.giftCount || 0,
               specialPrice: activity.specialPrice || 0,
               startTime: activity.startTime,
               endTime: activity.endTime,
               isLongTerm: activity.isLongTerm || false,
               maxUseCount: activity.maxUseCount || 0,
               maxPerUser: activity.maxPerUser || 1,
               minUserLevel: activity.minUserLevel || 0,
               status: activity.status || 1,
               isShow: activity.isShow || 1,
               priority: activity.priority || 0,
               remark: activity.remark || '',
               cardPriceId: activity.cardPriceId
           }

           // 设置编辑模式
           this.isEditMode = true

           // 显示对话框
           this.normalActivityDialogVisible = true
       },

       // 过滤店铺价格
       filterStorePrices() {
           let filtered = this.storePriceList;

           // 根据店铺名称搜索
           if (this.storePriceSearchText && this.storePriceSearchText.trim() !== '') {
               const searchText = this.storePriceSearchText.trim().toLowerCase();
               filtered = filtered.filter(item =>
                   item.storeName && item.storeName.toLowerCase().includes(searchText)
               );
           }

           // 根据美团/抖音ID搜索
           if (this.storePriceMDSearchText && this.storePriceMDSearchText.trim() !== '') {
               const searchText = this.storePriceMDSearchText.trim().toLowerCase();
               filtered = filtered.filter(item =>
                   (item.meituanId && item.meituanId.toString().toLowerCase().includes(searchText)) ||
                   (item.douyinId && item.douyinId.toString().toLowerCase().includes(searchText)) ||
                   (item.gaodeId && item.gaodeId.toString().toLowerCase().includes(searchText))
               );
           }

           // 根据有效天数搜索
           if (this.storePriceDaySearchText && this.storePriceDaySearchText.trim() !== '') {
               const searchText = this.storePriceDaySearchText.trim().toLowerCase();
               filtered = filtered.filter(item =>
                   item.days == searchText
               );
           }

           this.filteredStorePriceList = filtered;
           // 重置到第一页
           this.storePriceCurrentPage = 1;
       },

       // 加载店铺价格
       async loadStorePrices() {
           this.loadStorePricesLoading = true
           try {
               const { data: res } = await this.$http.get(`cardprice/card/${this.currentCardId}`)
               if (res.status === 0) {
                   // 处理店铺价格数据，补充真实店铺名称
                   this.storePriceList = (res.data || []).map(item => {
                       // 从storeList中查找真实的店铺名称
                       const storeInfo = this.storeList.find(store => store.id === item.storeId)
                       return {
                           ...item,
                           storeName: storeInfo ? storeInfo.storename : (item.storeName || '未知店铺')
                       }
                   })
                   // 加载完数据后应用当前的搜索过滤条件
                   this.filterStorePrices()
               } else {
                   this.storePriceList = []
                   this.filteredStorePriceList = []
                   this.$message.error(res.message || '加载店铺价格失败')
               }
           } catch (error) {
               this.storePriceList = []
               this.filteredStorePriceList = []
               this.$message.error('加载店铺价格失败')
           } finally {
               this.loadStorePricesLoading = false
           }
       },

       // 格式化日期时间为 yyyy-MM-dd HH:mm:ss 格式
       formatDateTime(dateTime) {
           if (!dateTime) return '';

           // 如果已经是正确格式，直接返回
           if (typeof dateTime === 'string' && /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(dateTime)) {
               return dateTime;
           }

           let date;
           if (typeof dateTime === 'string') {
               // 处理各种字符串格式
               if (dateTime.includes('T')) {
                   // ISO格式或带T的格式
                   date = new Date(dateTime);
               } else {
                   date = new Date(dateTime);
               }
           } else if (dateTime instanceof Date) {
               date = dateTime;
           } else {
               return '';
           }

           // 检查日期是否有效
           if (isNaN(date.getTime())) {
               return '';
           }

           // 格式化为 yyyy-MM-dd HH:mm:ss
           const year = date.getFullYear();
           const month = String(date.getMonth() + 1).padStart(2, '0');
           const day = String(date.getDate()).padStart(2, '0');
           const hours = String(date.getHours()).padStart(2, '0');
           const minutes = String(date.getMinutes()).padStart(2, '0');
           const seconds = String(date.getSeconds()).padStart(2, '0');

           return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
       },

    //    // 添加价格配置
    //    addPrice() {
    //        this.addStorePriceDialogVisible = true
    //        this.resetStorePriceForm()
    //    },

    //    // 店铺搜索过滤
    //    filterStores() {
    //        if (!this.storeSearchKeyword) {
    //            this.filteredStoreList = this.storeList
    //        } else {
    //            this.filteredStoreList = this.storeList.filter(store =>
    //                store.storename.toLowerCase().includes(this.storeSearchKeyword.toLowerCase())
    //            )
    //        }
    //    },

    //    // 全选店铺
    //    selectAllStores() {
    //        if (this.currentCardScopeType === 1) {
    //            this.selectedStores = this.filteredStoreList.map(store => store.id)
    //        }
    //    },

    //    // 清空选择
    //    clearAllStores() {
    //        this.selectedStores = []
    //    },

    //    // 反选店铺
    //    reverseSelectStores() {
    //        if (this.currentCardScopeType === 1) {
    //            const currentSelected = new Set(this.selectedStores)
    //            this.selectedStores = this.filteredStoreList
    //                .filter(store => !currentSelected.has(store.id))
    //                .map(store => store.id)
    //        }
    //    },

       // 编辑店铺价格
       editStorePrice(row) {
           this.storePriceForm = {
               id: row.id,
               cardId: row.cardId,
               storeId: row.storeId,
               storeName: row.storeName || '',
               price: row.price,
               costPrice: row.costPrice,
               days: row.days,
               useTimes: row.useTimes != null ? row.useTimes : row.use_times,
               sortOrder: row.sortOrder || 0,
               purchaseLimitType: row.purchaseLimitType || 0,
               limitPeriod: row.limitPeriod || 0,
               personalLimit: row.personalLimit || 0,
               totalLimit: row.totalLimit || 0,
               soldCount: row.soldCount || 0,
               limitStartTime: row.limitStartTime || '',
               limitEndTime: row.limitEndTime || '',
               limitDesc: row.limitDesc || '',
               upgradeFromCards: row.upgradeFromCards || '',
               upgradeDiscount: row.upgradeDiscount || 0,
               douyinId: row.douyinId || '',
               meituanId: row.meituanId || '',
               gaodeId: row.gaodeId || '',
               remark: row.remark || '',
               storeDesc: row.storeDesc || '',
               // 🔧 修复：添加状态和显示字段的回显
               isActive: row.isActive !== undefined ? row.isActive : 1,
               isShow: row.isShow !== undefined ? row.isShow : 1,
               presaleTime: row.presaleTime || null,
               // 自动续费相关
               isAutoRenewal: row.isAutoRenewal !== undefined ? row.isAutoRenewal : 0,
               renewalType: row.renewalType || '',
               deductMethod: row.deductMethod || 'WX_AUTO_DEBIT',
               deductCycle: row.deductCycle || 1,
               advanceDeductDays: row.advanceDeductDays !== undefined ? row.advanceDeductDays : 1,
               retryTimes: row.retryTimes !== undefined ? row.retryTimes : 3
           }
           this.storeDeductDetails = row.deductDetails || []
           this.addStorePriceDialogVisible = true
           // 确保店铺列表已加载
           if (!this.storeList || this.storeList.length === 0) {
               this.loadStoreListForScope()
           }
       },

       // 显示添加店铺价格对话框
       showAddStorePriceDialog() {
           this.addStorePriceDialogVisible = true
           this.resetStorePriceForm()

         if (this.currentCardClassId === 3) {
           this.storePriceForm.days = 0
         }
           // 如果当前卡片启用了自动续费，添加时继承自动续费配置
           if (this.currentCard && this.currentCard.isAutoRenewal == 1) {
               this.storePriceForm.isAutoRenewal = 1
               this.storePriceForm.renewalType = this.currentCard.renewalType || ''
               this.storePriceForm.deductMethod = this.currentCard.deductMethod || 'WX_AUTO_DEBIT'
               this.storePriceForm.deductCycle = this.currentCard.deductCycle || 1
               this.storePriceForm.advanceDeductDays = this.currentCard.advanceDeductDays == null ? 1 : this.currentCard.advanceDeductDays
               this.storePriceForm.retryTimes = this.currentCard.retryTimes == null ? 3 : this.currentCard.retryTimes
               this.storeDeductDetails = this.currentCard.deductDetails || []
           }
           // 确保店铺列表已加载
           if (!this.storeList || this.storeList.length === 0) {
               this.loadStoreListForScope()
           }
       },

       // 检查店铺是否已经添加过价格配置
       isStoreAlreadyAdded(storeId) {
           if (!this.storePriceList || this.storePriceList.length === 0) {
               return false
           }
           return this.storePriceList.some(item => item.storeId === storeId)
       },

       // 重置店铺价格表单
       resetStorePriceForm() {
           this.storePriceForm = {
               id: '',
               cardId: this.currentCardId,
               storeId: '',
               price: '',
               costPrice: '',
               days: '',
               useTimes: '',
               sortOrder: 0,
               purchaseLimitType: 0,
               limitPeriod: 0,
               totalLimit: 0,
               personalLimit: 0,
               upgradeDiscount: 0,
               isActive: 1,
               isShow: 1,
               limitStartTime: null,
               limitEndTime: null,
               presaleTime: null,
               douyinId: '',
               meituanId: '',
               gaodeId: '',
               limitDesc: '',
               storeDesc: '',
               remark: '',
               // 自动续费相关
               isAutoRenewal: 0,
               renewalType: '',
               deductMethod: 'WX_AUTO_DEBIT',
               deductCycle: 1,
               advanceDeductDays: 1,
               retryTimes: 3
           }
           this.storeDeductDetails = []
           // 清除表单验证
           if (this.$refs.storePriceFormRef) {
               this.$refs.storePriceFormRef.clearValidate()
           }
       },

       // 总限购数量输入处理 - 限制为非负整数
       onTotalLimitInput(formType) {
           let form;
           if (formType === 'batch') {
               form = this.batchPriceForm;
           } else if (formType === 'price') {
               form = this.priceForm;
           } else {
               return;
           }

           // 获取当前输入值
           let value = form.totalLimit;
           if (value === null || value === undefined) {
               return;
           }

           // 转换为字符串处理
           value = String(value);

           // 移除非数字字符，只保留数字
           let cleanValue = value.replace(/[^0-9]/g, '');

           // 如果清理后为空，设置为空字符串
           if (cleanValue === '') {
               form.totalLimit = '';
               return;
           }

           // 转换为整数
           let intValue = parseInt(cleanValue);

           // 限制最大值为999999
           if (intValue > 999999) {
               intValue = 999999;
           }

           // 更新表单值
           form.totalLimit = intValue.toString();
       },

       // 总限购数量失焦处理
       onTotalLimitBlur(formType) {
           let form;
           if (formType === 'batch') {
               form = this.batchPriceForm;
           } else if (formType === 'price') {
               form = this.priceForm;
           } else {
               return;
           }

           // 验证总限购数量
           if (form.totalLimit !== '' && form.totalLimit !== null && form.totalLimit !== undefined) {
               const value = parseInt(form.totalLimit);
               if (isNaN(value) || value < 0) {
                   form.totalLimit = '';
                   form.totalLimitValidation = {
                       valid: false,
                       message: '总限购数量必须为非负整数'
                   };
               } else {
                   form.totalLimitValidation = {
                       valid: true,
                       message: ''
                   };
               }
           } else {
               form.totalLimitValidation = {
                   valid: true,
                   message: ''
               };
           }
       },

      handleTimeChange(form) {
         if (this.validTimes) {
           form.startTime = this.validTimes[0]
           form.endTime = this.validTimes[1]
         } else {
           form.startTime = null
           form.endTime = null
         }
      }
    }
}

</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }
    el-table__row>td {
    border: none;
    }

    /* 批量价格设置弹窗样式 */
    .batch-price-dialog {
        border-radius: 8px;
    }

    .batch-price-dialog .el-dialog__body {
        padding: 20px;
    }

    /* 店铺价格弹窗样式 - 禁用拖动 */
    .store-price-dialog {
        border-radius: 8px;
    }

    .store-price-dialog .el-dialog__header {
        cursor: default !important;
        -webkit-user-select: none;
        -moz-user-select: none;
        -ms-user-select: none;
        user-select: none;
    }

    .store-price-dialog .el-dialog__headerbtn {
        cursor: pointer !important;
    }

    /* 全局禁用所有对话框的拖动功能 */
    .el-dialog__header {
        cursor: default !important;
    }

    .el-dialog.is-draggable .el-dialog__header {
        cursor: default !important;
    }

    /* 面板通用样式 */
    .store-selection-panel,
    .selected-stores-panel,
    .price-form-panel {
        background: #f8f9fa;
        border-radius: 8px;
        padding: 15px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
        transition: all 0.3s ease;
    }

    .store-selection-panel {
        width: 25%; /* 原35%减少30% = 25% */
        border: 2px solid #e4e7ed;
    }

    .selected-stores-panel {
        width: 22.5%; /* 原25%减少10% = 22.5% */
        border: 2px solid #409eff;
        display: flex;
        flex-direction: column;
        min-height: 0;
        overflow: hidden;
    }

    .price-form-panel {
        width: 48%; /* 原40%增加20% = 48% */
        border: 2px solid #67c23a;
    }

    .panel-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 15px;
        padding-bottom: 10px;
        border-bottom: 1px solid #e4e7ed;
        gap: 15px;
    }

    .panel-header h4 {
        margin: 0;
        font-size: 14px;
        font-weight: 600;
        color: #303133;
        display: flex;
        align-items: center;
        gap: 8px;
        white-space: nowrap;
        min-width: fit-content;
        flex-shrink: 0;
    }

    /* 搜索容器样式 */
    .search-container {
        flex: 1;
        max-width: 180px;
        margin-left: 10px;
    }

    .store-search-input {
        width: 100%;
    }

    .store-search-input .el-input__inner {
        border-radius: 16px;
        border: 1px solid #dcdfe6;
        background-color: #f5f7fa;
        font-size: 12px;
        height: 28px;
        line-height: 28px;
        transition: all 0.3s ease;
    }

    .store-search-input .el-input__inner:focus {
        border-color: #409eff;
        background-color: #ffffff;
        box-shadow: 0 0 0 2px rgba(64, 158, 255, 0.1);
    }

    .store-search-input .el-input__inner::placeholder {
        color: #c0c4cc;
        font-size: 12px;
    }

    .store-search-input .el-input__prefix {
        left: 8px;
    }

    .store-search-input .el-input__suffix {
        right: 8px;
    }

    .panel-header h4 i {
        font-size: 16px;
        color: #409eff;
    }

    .panel-actions {
        margin-bottom: 15px;
        display: flex;
        gap: 8px;
        flex-wrap: wrap;
    }

    /* 店铺列表样式 */
    .store-list {
        height: 400px;
        overflow-y: auto;
        border: 1px solid #dcdfe6;
        border-radius: 6px;
        padding: 10px;
        background: white;
    }

    .store-item {
        padding: 8px 12px;
        margin-bottom: 6px;
        border-radius: 6px;
        cursor: pointer;
        transition: all 0.3s ease;
        border: 1px solid transparent;
    }

    .store-item:hover {
        background: #f0f9ff;
        border-color: #409eff;
        transform: translateX(2px);
    }

    .store-item.selected {
        background: linear-gradient(135deg, #e6f4ff 0%, #bae0ff 100%);
        color: #1890ff;
        border-color: #91caff;
        transform: scale(1.02);
        font-weight: 600;
    }

    .store-item.selected .el-checkbox__input.is-checked .el-checkbox__inner {
        background-color: #1890ff;
        border-color: #1890ff;
    }

    .store-item.selected .el-checkbox__input.is-checked .el-checkbox__inner::after {
        border-color: white;
    }

    .store-item.selected .el-checkbox__label {
        color: #1890ff !important;
    }

    .store-name {
        font-weight: 500;
        font-size: 13px;
    }

    /* 已绑定店铺样式 */
    .store-item.bound {
        background: #f0f9ff;
        border-color: #91caff;
        opacity: 0.7;
        cursor: not-allowed;
    }

    .store-item.bound .el-checkbox {
        cursor: not-allowed;
    }

    .store-item.bound .el-checkbox__input.is-disabled .el-checkbox__inner {
        background-color: #f5f5f5;
        border-color: #d9d9d9;
    }

    .store-item.bound .el-checkbox__label {
        color: #999 !important;
    }

    .bound-tag {
        margin-left: 8px;
        color: #52c41a;
        font-size: 11px;
        font-weight: 600;
        background: #f6ffed;
        border: 1px solid #b7eb8f;
        border-radius: 10px;
        padding: 1px 6px;
        display: inline-flex;
        align-items: center;
        gap: 2px;
    }

    .bound-tag i {
        font-size: 10px;
    }

    /* 禁用面板样式 */
    .disabled-panel {
        opacity: 0.6;
        pointer-events: none;
    }

    .disabled-panel .store-item {
        cursor: not-allowed !important;
    }

    /* 自动选择标签样式 */
    .auto-selected-tag {
        margin-left: 8px;
        color: #1890ff;
        font-size: 11px;
        font-weight: 600;
        background: #e6f7ff;
        border: 1px solid #91d5ff;
        border-radius: 10px;
        padding: 1px 6px;
        display: inline-flex;
        align-items: center;
        gap: 2px;
    }

    .auto-selected-tag i {
        font-size: 10px;
    }

    .store-city {
        font-size: 11px;
        opacity: 0.8;
        margin-left: 8px;
    }

    /* 已选店铺列表样式 */
    .selected-store-list {
        flex: 1;
        min-height: 0;
        overflow-y: auto;
        overflow-x: hidden;
        border: 1px solid #dcdfe6;
        border-radius: 6px;
        padding: 10px;
        background: white;
        box-sizing: border-box;
        /* 自定义滚动条样式 */
        scrollbar-width: thin;
        scrollbar-color: #c1c1c1 #f1f1f1;
    }

    /* Webkit浏览器滚动条样式 */
    .selected-store-list::-webkit-scrollbar {
        width: 6px;
    }

    .selected-store-list::-webkit-scrollbar-track {
        background: #f1f1f1;
        border-radius: 3px;
    }

    .selected-store-list::-webkit-scrollbar-thumb {
        background: #c1c1c1;
        border-radius: 3px;
    }

    .selected-store-list::-webkit-scrollbar-thumb:hover {
        background: #a8a8a8;
    }

    .selected-store-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 10px 12px;
        margin-bottom: 8px;
        background: linear-gradient(135deg, #67c23a 0%, #85ce61 100%);
        color: white;
        border-radius: 6px;
        transition: all 0.3s ease;
        animation: slideInRight 0.3s ease;
    }

    .selected-store-item:hover {
        transform: translateY(-2px);
        box-shadow: 0 4px 12px rgba(103, 194, 58, 0.3);
    }

    .store-info {
        display: flex;
        align-items: center;
        gap: 8px;
        font-size: 13px;
        font-weight: 500;
    }

    .remove-btn {
        color: white !important;
        opacity: 0.8;
        transition: all 0.2s ease;
    }

    .remove-btn:hover {
        opacity: 1;
        transform: scale(1.2);
    }

    /* 已绑定店铺信息面板样式 */
    .bound-stores-info {
        margin-bottom: 15px;
        background: #fff7e6;
        border: 1px solid #ffd591;
        border-radius: 6px;
        padding: 10px;
    }

    .bound-header {
        display: flex;
        align-items: center;
        gap: 6px;
        margin-bottom: 8px;
        color: #fa8c16;
        font-size: 12px;
        font-weight: 600;
    }

    .bound-stores-list {
        max-height: 120px;
        overflow-y: auto;
    }

    .bound-store-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 6px 8px;
        margin-bottom: 4px;
        background: #fff;
        border: 1px solid #ffd591;
        border-radius: 4px;
        font-size: 12px;
    }

    .bound-store-item .store-info {
        display: flex;
        align-items: center;
        gap: 4px;
        color: #666;
    }

    .bound-store-item .store-price {
        color: #fa8c16;
        font-weight: 600;
    }

    /* 空状态样式 */
    .empty-state,
    .empty-selected {
        text-align: center;
        color: #909399;
        padding: 40px 20px;
    }

    .empty-state i,
    .empty-selected i {
        font-size: 48px;
        margin-bottom: 15px;
        display: block;
        opacity: 0.5;
    }

    .empty-state p,
    .empty-selected p {
        margin: 0;
        font-size: 14px;
    }

    .empty-selected {
        border: 2px dashed #d3d4d6;
        border-radius: 6px;
        margin: 20px 0;
    }

    /* 分页样式 */
    .panel-pagination {
        margin-top: 15px;
        text-align: center;
        padding-top: 10px;
        border-top: 1px solid #e4e7ed;
    }

    /* 动画效果 */
    .store-item-enter-active,
    .store-item-leave-active {
        transition: all 0.3s ease;
    }

    .store-item-enter {
        opacity: 0;
        transform: translateX(-20px);
    }

    .store-item-leave-to {
        opacity: 0;
        transform: translateX(20px);
    }

    .selected-store-enter-active {
        transition: all 0.3s ease;
    }

    .selected-store-leave-active {
        transition: all 0.3s ease;
    }

    .selected-store-enter {
        opacity: 0;
        transform: translateY(-20px) scale(0.8);
    }

    .selected-store-leave-to {
        opacity: 0;
        transform: translateY(20px) scale(0.8);
    }

    @keyframes slideInRight {
        from {
            opacity: 0;
            transform: translateX(20px);
        }
        to {
            opacity: 1;
            transform: translateX(0);
        }
    }

    /* 响应式设计 */
    @media (max-width: 1200px) {
        .store-selection-panel {
            width: 40%;
        }
        .selected-stores-panel {
            width: 30%;
        }
        .price-form-panel {
            width: 30%;
        }
    }

    /* 活动状态下拉菜单样式 */
    .activity-status-dropdown {
        min-width: 100px !important;
    }

    .activity-status-dropdown .status-enable {
        color: #67c23a !important;
        font-weight: 500;
    }

    .activity-status-dropdown .status-enable:hover {
        background-color: #f0f9ff !important;
        color: #67c23a !important;
    }

    .activity-status-dropdown .status-pause {
        color: #e6a23c !important;
        font-weight: 500;
    }

    .activity-status-dropdown .status-pause:hover {
        background-color: #fdf6ec !important;
        color: #e6a23c !important;
    }

    .activity-status-dropdown .status-end {
        color: #f56c6c !important;
        font-weight: 500;
    }

    .activity-status-dropdown .status-end:hover {
        background-color: #fef0f0 !important;
        color: #f56c6c !important;
    }

    .activity-status-dropdown .el-dropdown-menu__item i {
        margin-right: 5px;
    }

    /* 添加店铺价格对话框中已添加店铺的样式 */
    .disabled-option {
        background-color: #f5f7fa !important;
        cursor: not-allowed !important;
    }

    .disabled-option:hover {
        background-color: #f5f7fa !important;
    }

    .el-select-dropdown__item.disabled-option {
        color: #c0c4cc !important;
        cursor: not-allowed !important;
        background-color: #f5f7fa !important;
    }

    .el-select-dropdown__item.disabled-option:hover {
        background-color: #f5f7fa !important;
        color: #c0c4cc !important;
    }

</style>
